{
  "access.denied": "No access to this screen",
  "access.deniedHint": "This account lacks permissions for this part of the portal. If it should have them, ask an administrator.",
  "accounts.active": "active",
  "accounts.add": "Add",
  "accounts.addHint": "Portal sign-in account — grant permissions below",
  "accounts.addTitle": "New account",
  "accounts.allModules": "all",
  "accounts.archive": "Archive",
  "accounts.archived": "Account archived",
  "accounts.archived_": "archived",
  "accounts.cannotSelf": "You cannot do this to your own account",
  "accounts.created": "Account created",
  "accounts.editTitle": "Edit account",
  "accounts.email": "E-mail",
  "accounts.lastLogin": "Last sign-in",
  "accounts.moduleNotForClient": "This module is not available to client accounts",
  "accounts.modules": "Permissions",
  "accounts.modulesAdminHint": "Administrators can access everything",
  "accounts.modulesClientHint": "Client accounts get read-only report access — other modules are unavailable, including for a client administrator",
  "accounts.modulesHint": "Select the modules this account may access",
  "accounts.name": "Name",
  "accounts.newPassword": "New password",
  "accounts.password": "Password",
  "accounts.passwordChanged": "Password changed",
  "accounts.passwordHint": "At least 8 characters. Empty = no local password.",
  "accounts.passwordTitle": "Change password",
  "accounts.passwordTooShort": "Password must be at least 8 characters",
  "accounts.restore": "Restore",
  "accounts.restored": "Account restored",
  "accounts.role": "Role",
  "accounts.saved": "Saved",
  "accounts.scope": "Scope",
  "accounts.scopeHint": "Which customer the account is limited to. The choice cannot be changed by editing later — moving an account between customers is a permissions change, not a field edit.",
  "accounts.scopePick": "— pick a scope —",
  "accounts.scopeSdi": "SDI — all customers",
  "accounts.scopeSdiShort": "SDI",
  "accounts.scopeSdiWarn": "An account with no scope sees ALL customers and every island they own. Create one only for our own people.",
  "accounts.showArchived": "Show archived",
  "accounts.status": "Status",
  "agents.aktualnaWersja": "agent: {wersja}",
  "agents.accept": "Confirm",
  "agents.accepted": "Node confirmed — the portal now accepts its data.",
  "agents.aktualizujTeraz": "update now",
  "agents.aktualizujTerazOpis": "Ask this agent to check its version on its next heartbeat instead of waiting for its own interval (once every 30 cycles). The portal cannot reach into the machine — the request travels in the heartbeat reply, so the effect shows within one cycle. The update itself still happens only after a successful cycle.",
  "agents.aktualizujTerazStary": "This agent is older than {wersja} and does not know this request — it will pick the new version up by itself at its next version check. The button will work after that update.",
  "agents.aktualizujZlecone": "Asked {wezel} to check its version — the agent will hear it on its next heartbeat.",
  "agents.alreadyAccepted": "This node was already confirmed; nothing changed.",
  "agents.alreadyRejected": "This node was already rejected; nothing changed.",
  "agents.bezAutomatu": "database, no machine",
  "agents.clockFixOff": "auto-correction off (Instance settings)",
  "agents.clockFixOn": "auto-correction on",
  "agents.clockShort": "clock:",
  "agents.code.alreadyRevoked": "This code was already revoked.",
  "agents.code.colDenied": "Refusals",
  "agents.code.colExpires": "Valid until",
  "agents.code.colKind": "Kind",
  "agents.code.colLabel": "Description",
  "agents.code.colModel": "Deployment",
  "agents.code.colUses": "Uses",
  "agents.code.copied": "Code copied.",
  "agents.code.copy": "Copy",
  "agents.code.copyFailed": "Could not copy - transcribe the code from the screen.",
  "agents.code.forIsland": "Island",
  "agents.code.hide": "Hide",
  "agents.code.hours": "Valid (hours)",
  "agents.code.hoursWhat": "A code should live as long as the rollout. After expiry it enrols nothing, even if it leaked.",
  "agents.code.islandCode": "Short island identifier",
  "agents.code.islandCodeWhat": "A technical name without spaces or accents — it shows up in portal URLs and exports. We build it from the site name; change it only when the customer has its own naming.",
  "agents.code.islandName": "Site (island) name",
  "agents.code.islandNamePlaceholder": "e.g. company or site name",
  "agents.code.islandNameWhat": "How this site should be named in the portal and in reports — usually the company or site name (e.g. \"East plant\", \"Main warehouse\"). An island is one SPS database: every machine served from that database appears under this name.",
  "agents.code.issue": "Issue code",
  "agents.code.kindFounding": "founding",
  "agents.code.kindJoin": "into island",
  "agents.code.kodZNazwy": "Built from the site name. If that identifier is taken, the instance appends a number.",
  "agents.code.label": "Code description (optional)",
  "agents.code.labelWhat": "A note for us only: it shows in the issued-codes list below and next to the agent that enrolled with it. Helps answer \"what was this code for\" months later. Empty = we use the site name.",
  "agents.code.listTitle": "Issued codes",
  "agents.code.manyClients": "This instance has more than one client - the code will be created for the first one listed. Check that this is the right one.",
  "agents.code.maxUses": "How many machines may enrol",
  "agents.code.maxUsesWhat": "One code covers a whole site. The limit is hard — once used up, the code stops letting anyone in.",
  "agents.code.mode.WYSPA": "Add a machine to an existing island",
  "agents.code.mode.ZALOZYCIELSKI": "Create a new island",
  "agents.code.modeHint.WYSPA": "The code adds machines to the island picked in the switch above — use it for further machines served from the same SPS database.",
  "agents.code.modeHint.ZALOZYCIELSKI": "For the first machine at a new site. The island is created on first use of the code: you give the site name, the agent brings the server and database name — that cannot be known upfront.",
  "agents.code.modelZalozy": "island does not exist yet — this is how it will be created",
  "agents.code.more": "More options — now: {maszyn} machines, valid {godzin} h",
  "agents.code.noIsland": "No island selected - pick one in the switcher above, or issue a founding code.",
  "agents.code.notFoundedYet": "island not created yet",
  "agents.code.onceWarning": "Save the code NOW - it cannot be read again.",
  "agents.code.revoke": "Revoke",
  "agents.code.revokePytanie": "Revoke enrolment code “{label}” ({prefiks}…)?\n\nRevocation is immediate and cannot be undone — no further machine will enrol with this code. Nodes that already enrolled KEEP WORKING: they have their own tokens, revoked separately at the node.\n\nUsed: {uzyc}.",
  "agents.code.revoked": "Code revoked - it will not enrol any further machine.",
  "agents.code.revokedAt": "revoked",
  "agents.code.title": "Enrolment code",
  "agents.code.trybKrotki.SMART_SYNC": "Smart Sync — master in the cloud",
  "agents.code.trybKrotki.ZWYKLY": "standard — one database",
  "agents.code.trybWyspy": "Deployment model for this island",
  "agents.code.trybWyspy.SMART_SYNC": "Smart Sync — master in the cloud",
  "agents.code.trybWyspy.ZWYKLY": "Standard — one database",
  "agents.code.trybWyspyHint.SMART_SYNC": "The master lives in our MSSQL and every machine keeps its own local database. Choosing it here matters: an island switched to Smart Sync AFTER the machines are installed leaves them with no right to synchronise and no database access — they then have to be reinstalled.",
  "agents.code.trybWyspyHint.ZWYKLY": "The master is a database on the customer's machine. This is how the whole existing fleet works.",
  "agents.code.trybWyspyWhat": "Choose NOW. The mode is written into the island when it is created and every machine registers into it.",
  "agents.code.zAdresu": "Filled in from this instance address: \"{nazwa}\". Change it if the site is named differently.",
  "agents.codeStillActive": "The code this node used is still active and will admit further machines. Rejecting blocks this one node only — the code is revoked separately.",
  "agents.colDecision": "Decision",
  "agents.colFound": "What it found",
  "agents.colIsland": "Client / island",
  "agents.colLastSeen": "Last contact",
  "agents.colNode": "Node",
  "agents.colState": "State",
  "agents.ct": "CT",
  "agents.ctOpis": "Native MSSQL Change Tracking is enabled here. The portal does not use it — the agent computes diffs locally. Expand the node to see the covered tables and disable it.",
  "agents.delete": "Delete",
  "agents.deleteBody": "The row disappears from the screen and the node's token is revoked — without that the agent would come back here at its next heartbeat. A copy (node, machine, database, who rejected it and when) stays in the audit trail. If the agent is still installed on that machine, uninstall it first.",
  "agents.deleteHint": "Removes the row and revokes this node's token — for cleaning up after a failed enrolment.",
  "agents.deleteTitle": "Delete this node?",
  "agents.deleted": "Node {wezel} deleted, tokens revoked: {tokeny}",
  "agents.deployTitle": "Deployment: code and installer",
  "agents.fClock": "Clock drift",
  "agents.fCode": "Enrolment code",
  "agents.fDatabase": "SPS database",
  "agents.fEnrolled": "Enrolled",
  "agents.fHostname": "Host",
  "agents.fIp": "IP address (last heartbeat)",
  "agents.fLastSeen": "Last contact",
  "agents.fRole": "Role",
  "agents.fServer": "SPS server",
  "agents.fTimeSync": "Time synchronisation",
  "agents.fTimeZone": "Time zone",
  "agents.fVersion": "Agent version",
  "agents.fVmid": "VMID",
  "agents.ikonaChmura": "Node in the cloud — a database with no machine",
  "agents.ikonaMaszyna": "Node on a machine (vending cabinet)",
  "agents.inst.builtOn": "Built",
  "agents.inst.channel": "Version served to agents (update channel)",
  "agents.inst.download": "Installer (.zip)",
  "agents.inst.downloadExe": "Download installer (.exe)",
  "agents.inst.file": "File",
  "agents.inst.node": "Bundled Node",
  "agents.inst.notReady": "This instance image does not contain the agent installer — report it as a release defect.",
  "agents.inst.size": "Size",
  "agents.inst.smartscreen": "The file is not code-signed, so Windows shows “Windows protected your PC” — this is not a virus warning: click “More info”, then “Run anyway”.",
  "agents.inst.title": "Agent installer",
  "agents.inst.version": "Agent version in package",
  "agents.island.delete": "Delete island",
  "agents.island.deleteBody": "The island goes away together with everything that belongs to it: nodes ({wezly}), their tokens, table intervals and alerts. We only delete islands with no customer data — there are no machines, employees, withdrawals or operations in it. A copy stays in the audit trail.",
  "agents.island.deleteTitle": "Delete this island?",
  "agents.island.deleted": "Island {wyspa} deleted (nodes: {wezly})",
  "agents.island.employees": "Employees",
  "agents.island.force": "Delete with data",
  "agents.island.forceAgents": "Agents in the field lose their tokens with the island: every machine will have to be enrolled again on site. If it is only about broken data, use “Wipe island data” in Settings — nodes and tokens survive there.",
  "agents.island.forceBody": "The island goes away with everything that belongs to it: machines ({automaty}), employees ({pracownicy}), withdrawals ({wydania}), nodes ({wezly}) with their tokens, the change queue, alerts, this island’s enrolment codes and its files in storage. There is no way back — the read model rebuilds only from the customer database, and withdrawals only those SPS still holds.",
  "agents.island.forceConfirm": "Type the island code “{kod}” to confirm",
  "agents.island.forceDone": "Island {wyspa} deleted with its data ({wierszy} rows, {wezly} nodes, {obiekty} files)",
  "agents.island.forceTitle": "Delete the island TOGETHER WITH ITS DATA?",
  "agents.island.island": "Island",
  "agents.island.machines": "Machines",
  "agents.island.nodes": "Nodes",
  "agents.island.title": "Islands of this customer",
  "agents.island.withdrawals": "Withdrawals",
  "agents.masterWyspy": "island master",
  "agents.masterWyspyOpis": "This node hosts the island master database — settled by a successful restore under the master name. In Smart Sync mode the island state is read from it, not from the machines.",
  "agents.othersEmpty": "No agent has reported to this instance yet.",
  "agents.othersTitle": "Active agents",
  "agents.odwolane.tytul": "Revoked, still trying",
  "agents.odwolane.opis": "Revoked tokens that tried to connect in the last 30 days. The portal rejects them — they write nothing.",
  "agents.odwolane.wezel": "Node",
  "agents.odwolane.wyspa": "Island",
  "agents.odwolane.odwolany": "Revoked",
  "agents.odwolane.od": "Trying since",
  "agents.odwolane.ostatnio": "Last attempt",
  "agents.odwolane.adres": "Address",
  "agents.odwolane.coZrobic": "What to do",
  "agents.odinstaluj.przycisk": "Uninstall",
  "agents.odinstaluj.hint": "Remove the agent from the machine and delete the node",
  "agents.odinstaluj.tytul": "Uninstall agent?",
  "agents.odinstaluj.opis": "The agent will remove its service, files and state from the machine and disable its SQL login. The node disappears from the list at once; an offline machine uninstalls when it comes back.",
  "agents.odinstaluj.potwierdz": "Type the node name “{wezel}” to confirm",
  "agents.odinstaluj.zlecone": "Uninstall ordered for {wezel}",
  "agents.odinstaluj.bezTokenu": "Node {wezel} deleted, but it had no token — the machine will not get the order",
  "agents.odinstaluj.zWyspa": "Uninstall agents from machines",
  "agents.odinstaluj.zleconeWyspy": "Uninstall ordered for agents ({n})",
  "agents.odinstalowania.tytul": "Uninstalls",
  "agents.odinstalowania.zlecono": "Ordered",
  "agents.odinstalowania.stan": "Status",
  "agents.odinstalowania.przyjete": "accepted",
  "agents.odinstalowania.pukala": "knocked",
  "agents.odinstalowania.czeka": "waiting for the machine",
  "agents.odwolane.wygasl": "expired",
  "agents.odwolane.staraMaszyna": "The node runs on a new token — stop the agent on the machine at this address",
  "agents.odwolane.bezKlucza": "The node has no working token — enroll the machine again (agent enroll)",
  "agents.oczekujeWiersz": "awaiting confirmation — the portal accepts only heartbeats from this node",
  "agents.reset.button": "Wipe the instance",
  "agents.reset.confirm": "Type “{fraza}” to confirm",
  "agents.reset.dialogTitle": "Wipe the whole instance?",
  "agents.reset.done": "Instance wiped: {wysp} islands, {wezlow} nodes, {wierszy} rows, {kodow} enrolment codes",
  "agents.reset.leftovers": "{n} files could not be removed from storage — the rows are gone, the files stayed. Details in the instance log.",
  "agents.reset.summary": "To be deleted: {wysp} islands, {wezlow} nodes, {maszyn} machines, {wydan} withdrawals.",
  "agents.reset.title": "Wipe the instance to zero",
  "agents.reset.what": "Deletes ALL islands of this instance together with data, nodes, tokens, files in storage and issued enrolment codes — including founding ones that do not point at any island yet. What stays: portal accounts and permissions, customers, the Vending+ token and the audit trail, which records what disappeared.",
  "agents.rodz.dociaganie": "siblings: new issues are flowing, history is catching up in the background (cursor {kursor} of {granica})",
  "agents.rozwinWszystkie": "Expand all",
  "agents.sct": "SCT",
  "agents.sctOpis": "SupplyPoint replication (SyncChangeTracking) is active here — triggers keep writing and nobody consumes the entries. Expand the node to see the numbers and disable it.",
  "agents.szczegoly": "Details",
  "agents.inst.legacy": "legacy",
  "agents.reasonHint": "Reason (optional, goes to the audit trail)",
  "agents.reject": "Reject",
  "agents.rejectConfirm": "Confirm rejection",
  "agents.rejected": "Node rejected — the portal no longer accepts its data.",
  "agents.rodz.blad": "siblings: NOT WRITTEN — {blad}",
  "agents.rodz.milczy": "siblings: node is NOT ASKING for dispensings (last: {kiedy})",
  "agents.doPrzerobienia": "operations to run: {n}",
  "agents.rodz.nadaza": "siblings: up to date ({wpisanych} written)",
  "agents.rodz.nadazaProsto": "siblings: up to date",
  "agents.rodz.zaleglosc": "siblings: pull-down pending (cursor {kursor} of {szczyt})",
  "agents.state.NIEZNANY": "Unknown",
  "agents.state.OCZEKUJE": "Waiting",
  "agents.state.ODRZUCONY": "Rejected",
  "agents.state.POTWIERDZONY": "Confirmed",
  "agents.timeSyncShort": "clock sync:",
  "agents.title": "Agents",
  "agents.uwagiWiecej": "+ {ile} more",
  "agents.verBehind": "Older than target ({docelowa}) — the agent updates itself at its next version check",
  "agents.verShort": "version",
  "agents.wskazMastera": "Set as island master",
  "agents.wskazMasteraOpis": "Marks this node as the island master. Needed when the master database was restored OUTSIDE the portal — without it the portal does not know where the master is and holds back configuration changes to the machines.",
  "agents.wskazanoMastera": "Island master set to node {wezel} — configuration changes will start reaching the machines.",
  "agents.wskazanoMasteraBezZmian": "This node was already the island master; nothing changed.",
  "agents.zwinWszystkie": "Collapse all",
  "alerts.unmonitored": "Machines without an agent",
  "alerts.unmonitoredHint": "Not a failure but a deployment gap: nobody installed an agent here, so the portal knows nothing about this machine beyond what came from SPS.",
  "alr.ack": "Acknowledge",
  "alr.ackGrupe": "Acknowledge {n}",
  "alr.acked": "Acknowledged {n} — that is a marker in the portal, nothing changed on the machine",
  "alr.acknowledged": "acknowledged",
  "alr.bannerBody": "Alerts in this table appear when the agent reports something — today these are island and database matters (agent pointing at a different database than the island, a second data source on the island, a master awaiting approval). An empty list does not mean „no problems”, it means „nobody reported anything”. The section below shows what the portal computes on its own, without a report.",
  "alr.bannerTitle": "Fleet alerts",
  "alr.blindPeople": "people exceeded a limit invisibly to the machines",
  "alr.channelAge": "Last report",
  "alr.code": "Code",
  "alr.code.CONFIG_APPLIED": "Configuration applied on the machine",
  "alr.code.LOW_STOCK": "Low stock in a compartment — refill required",
  "alr.code.SYNC_LAG": "The machine has not reported for a long time",
  "alr.contradiction": "contradiction",
  "alr.contradictionHint": "The portal has this machine as connected while not having heard from it for longer than the threshold. One of those facts is stale.",
  "alr.contradictionNote": "{n} machines are marked as connected although the portal has not heard from them — either the connection flag is stale or the last contact is not being recorded.",
  "alr.detectedNote": "Computed NOW from data the portal already has — no agent involved. These are not rows in the database: they have no state and cannot be acknowledged.",
  "alr.detectedTitle": "Detected by the portal",
  "alr.empty": "There are no reported alerts for this island.",
  "alr.filterAll": "All",
  "alr.hoursAgo": "{n} h ago",
  "alr.lowStockAt": "Low stock at",
  "alr.lowStockTitle": "Compartments running out",
  "alr.lowStockTruncated": "List capped at 100 entries — the counter covers only the fetched rows.",
  "alr.message": "Message",
  "alr.neverSeen": "never reported",
  "alr.odKiedy": "first occurrence: {kiedy}",
  "alr.openCritical": "Open critical",
  "alr.openWarning": "Open warnings",
  "alr.rationingDetail": "Over the limit in total: {over} people; in {rules} rules there are breaches no machine can see.",
  "alr.rationingTitle": "Limits without protection",
  "alr.rationingWhy": "For these people every machine on its own would let the next withdrawal through, because on none of them was the limit ever reached.",
  "alr.razy": "×{n}",
  "alr.reportedTitle": "Reported by the agent",
  "alr.resolved": "resolved",
  "alr.sev.CRITICAL": "critical",
  "alr.sev.INFO": "info",
  "alr.sev.WARNING": "warning",
  "alr.severity": "Severity",
  "alr.silentFor": "{n} h without contact",
  "alr.silentMinutes": "Silent for over (min)",
  "alr.silentMinutesHint": "After how many minutes without contact a machine is reported as silent. Not below 16 — after a failure an agent reports at worst every quarter of an hour, so a lower threshold would accuse of silence someone we are in contact with.",
  "alr.silentTitle": "Machines out of contact",
  "alr.status.ACKNOWLEDGED": "acknowledged",
  "alr.status.ACKNOWLEDGED.hint": "Someone in the portal marked that they saw it. The cause has NOT gone away.",
  "alr.status.OPEN": "open",
  "alr.status.RESOLVED": "resolved",
  "alr.statusCol": "State",
  "alr.when": "When",
  "app.name": "Vendi",
  "asg.allGroupsAssigned": "All groups already have access.",
  "asg.alsoOther": "Also other machines",
  "asg.alsoOtherHint": "This many people with access to this machine also collect from another one — for them a per-machine limit comes out too low.",
  "asg.assignedEmployees": "Have access",
  "asg.assignedGroups": "Groups with access",
  "asg.availableEmployees": "No access",
  "asg.availableGroups": "Groups without access",
  "asg.direct": "Direct",
  "asg.groupWarn": "Assigning a group lets its ENTIRE membership onto the machine at once — and removing it revokes access for everyone who does not have it another way.",
  "asg.groups": "Groups",
  "asg.machine": "Machine",
  "asg.netHeads": "People in the groups being changed",
  "asg.netHeadsHint": "The combined headcount of ALL groups you are granting or revoking. This is not the gain in access: some of these people may have access another way, and when granting and revoking at once the changes point in opposite directions. The real effect appears in the „Reach” column after saving.",
  "asg.noEmployees": "No employee has a direct assignment.",
  "asg.noGroups": "No group has access to this machine.",
  "asg.pendingHint": "There is an unapplied assignment change for this machine.",
  "asg.reach": "Reach",
  "asg.reachHint": "Distinct employees with access: directly OR through a group.",
  "asg.readOnlyForYou": "You have read access to assignments. Only an administrator can make changes.",
  "asg.saved": "Assignment change queued",
  "asg.tab.employees": "Employees",
  "asg.tab.groups": "Groups",
  "asg.title": "Machine access",
  "beben.dodaj": "Add drum",
  "beben.kolumny": "Number of columns",
  "beben.niedostepny": "row pattern not established yet, awaiting a measurement",
  "beben.ostrzezenieTresc": "The write goes to the machine database and changes its geometry. A wrong column count gives no error — it gives a machine pointing at a different physical cell than the planogram shows. Removing a drum requires SPSUI on the machine.",
  "beben.ostrzezenieTytul": "This changes the machine build",
  "beben.podsumowanie": "This creates {szuflad} drawers and {przegrod} compartments. Check this is the right machine — the portal cannot undo it.",
  "beben.poziomy": "Number of levels (drawers per column)",
  "beben.typRamy": "Frame type",
  "beben.tytul": "New drum",
  "beben.utworz": "Create drum",
  "beben.zlecono": "Drum PIC {pic} requested: {szuflad} drawers, {przegrod} compartments. It appears once the change reaches the machine.",
  "cc.add": "Add centre",
  "cc.addTitle": "New cost centre",
  "cc.alias": "Alias",
  "cc.aliasHint": "The entity ALIAS field — a second label for the centre, optional.",
  "cc.code": "Centre code",
  "cc.codeHint": "The natural key in SPS, text given by a human. At most 50 characters. SPS is case-insensitive.",
  "cc.codeTaken": "Centre „{name}” already uses this code. SPS is case-insensitive, so it would be the same row.",
  "cc.created": "Cost centre queued",
  "cc.divergenceIntro": "Cost centre does not match for {n} employees — the same withdrawals will add up differently depending on the report.",
  "cc.spoza": "not in dictionary",
  "cc.spozaHint": "Code typed on employee cards, missing from the SPS dictionary",
  "cc.doSlownika.przycisk": "Add to dictionary",
  "cc.doSlownika.wszystkie": "Add to dictionary ({n})",
  "cc.doSlownika.tytul": "Add to cost centre dictionary",
  "cc.doSlownika.opis": "The codes go to the SPS cost centre dictionary. Employee assignments stay as they are.",
  "cc.doSlownika.osob": "People",
  "cc.doSlownika.nazwyHr": "Fetching names from HR+…",
  "cc.doSlownika.dodaj": "Add {n}",
  "cc.doSlownika.dodano": "Added to dictionary: {n}",
  "cc.divergent": "Divergence",
  "cc.divergentHint": "The gap between people with a membership and people carrying this code in the text field. Both numbers reach the transaction log, so two reports will answer differently.",
  "cc.kpi.centers": "Centres",
  "cc.kpi.mismatch": "String ≠ membership",
  "cc.kpi.multiple": "In several centres",
  "cc.kpi.onlyColumn": "String only",
  "cc.kpi.onlyMembership": "Membership only",
  "cc.kpi.unknownCodes": "Codes outside the dictionary",
  "cc.members": "Membership",
  "cc.name": "Name",
  "cc.usun.akcja": "Delete cost centre",
  "cc.usun.harmonogramy": "Filters report schedules: {lista}",
  "cc.usun.historia": "Issue history stays unchanged.",
  "cc.usun.hrPlus": "HR+ will restore this code on cards if it still sends it.",
  "cc.usun.napisy": "Code on cards to clear",
  "cc.usun.potwierdz": "Delete cost centre",
  "cc.usun.przynaleznosci": "Memberships to remove",
  "cc.usun.slownik": "Dictionary entry",
  "cc.usun.slownikNie": "none — code only on cards",
  "cc.usun.slownikTak": "will be deleted",
  "cc.usun.tytul": "Delete cost centre",
  "cc.usun.wKolejce": "Changes are pending for this code — delete it once they finish.",
  "cc.usun.zlecono": "Deletion queued",
  "cc.niezgodni.karta": "Card",
  "cc.niezgodni.napis": "On the employee",
  "cc.niezgodni.podtytul": "{n} employees. Fix it on the employee card by assigning a cost centre.",
  "cc.niezgodni.pokaz": "Show them",
  "cc.niezgodni.pracownik": "Employee",
  "cc.niezgodni.przynaleznosc": "Assigned centres",
  "cc.niezgodni.pusto": "Nobody — already fixed.",
  "cc.niezgodni.tytul": "Cost centre mismatch",
  "cc.niezgodni.uciete": "and {n} more — the list is truncated.",
  "cc.niezgodni.wielu": "in several centres",
  "cc.onColumn": "String in Users",
  "cc.pendingHint": "There is an unapplied configuration change for this centre.",
  "cd.ack.assumedMapping": "Column names for this table are ASSUMED from SPS convention, not confirmed. The change may hit the wrong column on the customer database.",
  "cd.ack.conflict": "An unapplied change is already waiting for this record. The portal cannot supersede the older intent — queue order will decide.",
  "cd.ack.keyOutOfSequence": "The key is outside the sequence the portal assigns. I understand it may collide with a record issued later.",
  "cd.ack.modeTypeUnknown": "Unknown drum addressing mode. SPS uses 9 (native drum) and 25 (DynaBox); any other value may prevent the drum from starting or shift compartment coordinates.",
  "cd.ack.moduleOwned": "This table has its own portal module which checks domain rules skipped here. I am deliberately bypassing those checks.",
  "cd.ack.nieznanyWiersz": "The portal does not know this row. I understand the deletion still goes to the island databases and there is nothing to mirror in the portal.",
  "cd.ack.podzialNaOperacje": "I understand the change goes out in several operations, each is a separate transaction and rejecting one does not undo the others.",
  "cd.ackTitle": "Confirm that you understand the consequences:",
  "cd.action": "Action",
  "cd.actionI": "I — new row",
  "cd.actionP": "P — change selected columns",
  "cd.actionD": "D — delete row",
  "cd.deleteByKey": "A delete points at the row by its key alone — no data.",
  "cd.addToBatch": "Add to batch",
  "cd.author": "Author",
  "cd.authorNote": "Reason",
  "cd.authorNoteHint": "The portal generates the operation title from facts. This field answers WHY you are reaching for the raw editor instead of a module. It stays in the change log.",
  "cd.authorNotePlaceholder": "e.g. Price correction after a supplier price-list change — there is no item catalogue module",
  "cd.bannerBody": "This screen queues a change written STRAIGHT into the customer database, bypassing the domain checks the portal modules perform. The agent picks the queue up every ~10 s and applies it on the machine — unless the guard refuses, because the row changed in SPSUI after the agent last read it. The state of each operation, and the reason for any refusal, is in the \"State\" column below.",
  "cd.bannerIsland": "Changes target island: {client} — {island}. Switching island in the header clears the draft batch.",
  "cd.bannerTitle": "Database actions — writes straight at the customer database",
  "cd.batchEmpty": "The batch is empty. Add at least one change.",
  "cd.batchOrderHint": "Order matters: changes enter the queue in this order (e.g. a group must exist before its membership).",
  "cd.batchTitle": "Batch — one operation",
  "cd.builderTitle": "Compose a change",
  "cd.chooseTable": "— choose a table —",
  "cd.clearBatch": "Clear batch",
  "cd.closedTitle": "What the editor does not open: {unavailable} tables without a mapping, {forbidden} forbidden",
  "cd.columnsToPatch": "Columns to change",
  "cd.forbiddenTables": "Tables config-down never writes to",
  "cd.keyOnlyTable": "In this table the whole row is the key — there are no separate columns to set.",
  "cd.mappingAssumed": "mapping assumed",
  "cd.mappingConfirmed": "mapping confirmed",
  "cd.moveDown": "Move down",
  "cd.moveUp": "Move up",
  "cd.naturalKey": "Natural key",
  "cd.nextKeyHint": "The portal would assign {next} here (highest in use: {max}). A different number poisons numbering for the future.",
  "cd.noTypeDeclared": "no declared type — not editable",
  "cd.notOfferedActions": "Actions the editor does not offer",
  "cd.opChanges": "Changes",
  "cd.opTitle": "Operation",
  "cd.ownedBy": "has a module: {module}",
  "cd.ownedHint": "Going through the module is safer — it checks domain rules and updates the portal together with the queue.",
  "cd.portalDoesNotKnow": "The portal does not know a record with this key.",
  "cd.portalHasNow": "The portal currently has:",
  "cd.preview": "Preview",
  "cd.previewDesc": "A verdict for each of the {n} changes. Queueing is possible only when none is blocked.",
  "cd.previewIsPortalOnly": "„What the portal has today” is the portal read model, i.e. the agent's LAST SNAPSHOT (configuration cycle every ~60 s), not a live read of the SPS database — the value may have changed since. Before writing, the agent compares the real row anyway and refuses if somebody touched it in SPSUI.",
  "cd.previewRunning": "Checking the batch and trial-mirroring it in the portal…",
  "cd.previewTitle": "Preview before queueing",
  "cd.queueAction": "Queue changes",
  "cd.queued": "Changes queued — the agent will pick them up within ~10 s",
  "cd.queuedHint": "Waiting for the agent. The queue drains every ~10 s; the state changes on its own.",
  "cd.registryEmpty": "No operations have been composed here on this island yet.",
  "cd.registryTitle": "Operations from this tab",
  "cd.removeFromBatch": "Remove from batch",
  "cd.rowData": "Row data",
  "cd.status": "State",
  "cd.statusQueued": "queued",
  "cd.table": "SPS table",
  "cd.unavailableTables": "Tables without a declared natural key",
  "cd.verdictBlocked": "blocked",
  "cd.verdictOk": "will pass",
  "cd.when": "When",
  "chg.action": "Action",
  "chg.actionName.D": "delete the row",
  "chg.actionName.I": "add a row",
  "chg.actionName.P": "change columns",
  "chg.actionName.U": "replace the whole row",
  "chg.author": "Author",
  "chg.authorNote": "Reason",
  "chg.bannerBody": "Stages beyond „queued” are advanced by the agent running at the customer site. Queued does not mean the change is on the machine.",
  "chg.bannerNothingAdvanced": "No operation has ever left the „queued” state. The database agent drains the queue every ~10 s, so today this IS worth checking: either this island has no agent with database access, or the agent is not running, or the guard refuses everything — in which case the reason is shown on the operation. The growing age of the oldest entry remains the most honest measure of this queue.",
  "chg.bannerTitle": "Configuration change queue",
  "chg.changeCount": "Changes",
  "chg.changesPending": "Changes in pending operations",
  "chg.confirmedAt": "Confirmed on the machine",
  "chg.created": "Queued at",
  "chg.data": "Data",
  "chg.przed": "Before",
  "chg.przedBrakHint": "No pre-change state — operation before 15.10.2026, older agent or over 90 days",
  "chg.przedNieBylo": "row did not exist",
  "chg.przedRozny": "differs between machines",
  "chg.cofnij": "Undo",
  "chg.cofa": "Undoes operation",
  "chg.cofnietaPrzez": "Undone ({status})",
  "cofn.tytul": "Undo operation",
  "cofn.opis": "Reverse changes built from the state before the operation. The agent refuses if someone changed these rows since.",
  "cofn.blokady": "Cannot be undone with the button",
  "cofn.uzasadnienie": "Reason (at least 10 characters)",
  "cofn.potwierdz": "Undo operation",
  "cofn.zakolejkowano": "Undo queued",
  "chg.detailTitle": "Config-down operation",
  "chg.details": "Details",
  "chg.empty": "There is no config-down operation for this island yet.",
  "chg.external": "external",
  "chg.externalHint": "The operation was requested by an external system over the API (the person's name is that side's declaration, not an identity we proved).",
  "chg.filterAll": "All",
  "chg.filterNone": "none",
  "chg.fromEditor": "from the editor",
  "chg.holdTitle": "The queue is held — {n} operations waiting",
  "chg.collapse": "Collapse queued",
  "chg.collapsePick": "Table to collapse",
  "chg.collapseConfirm": "Collapse queued operations for {t}? They will not reach the machines. This cannot be undone.",
  "chg.collapseDone": "Collapsed {n} operations for {t}",
  "chg.collapseNone": "Nothing to collapse for {t}",
  "chg.key": "Natural key",
  "chg.never": "never",
  "chg.oldestWaiting": "Oldest waiting",
  "chg.opId": "Operation id",
  "chg.juzPrzejrzane": "Reviewed earlier: {ile}",
  "chg.nicDoZamkniecia": "Nothing to close — all {ile} failed operations are already reviewed",
  "chg.brakNieudanych": "This island has no failed operations",
  "chg.nieudaneWszystkiePrzejrzane": "Failed operations: {ile} — all reviewed",
  "chg.nieudaneZostajaOpis": "These changes never reached the machines. Reviewing fixes nothing — if they were meant to apply, they have to be entered again.",
  "chg.przejrzana": "reviewed",
  "chg.przejrzanaHint": "Who and when — in the operation details",
  "chg.nieudanePasek": "Failed operations: {ile}",
  "chg.nieudanePasekOpis": "These changes will NOT arrive on their own — while they stay open, the island shows “needs attention”. Closing deletes neither the operation nor the error: both stay on record, together with who reviewed it.",
  "chg.pokazNieudane": "Show failed only",
  "chg.nieudanaTytul": "This operation failed",
  "chg.nieudanaPodpowiedz": "“Close” means: we have seen it and it cannot be completed — the operation stays failed, it just stops counting towards island health. “Send again” retries with the SAME value and may overwrite what is on the machine now.",
  "chg.zamknij": "Close",
  "chg.jużZamknięta": "Closed",
  "chg.ponow": "Send again",
  "chg.zamknieta": "Operation closed — it no longer counts towards island health",
  "chg.ponowiona": "Operation is back in the queue ({ile} failed deliveries cleared)",
  "chg.zamknietaPrzez": "Closed by {kto}, {kiedy}",
  "chg.ponawiana": "Retried {ile} times",
  "chg.zamknijWszystkie": "Close all failed ({ile})",
  "chg.zamknieteWszystkie": "Closed {ile} failed operations",
  "chg.opTitle": "Operation",
  "chg.pending": "Operations waiting",
  "chg.seq": "Queue no.",
  "chg.source": "Source",
  "chg.source.AUTHORING": "database actions",
  "chg.source.MODULE": "portal module",
  "chg.sourceHint.AUTHORING": "Composed in “Database actions” — in the editor (without a module’s domain checks) or with a ready-made correction.",
  "chg.stageInProgress": "in progress",
  "chg.stageReached": "reached",
  "chg.stageUnreachable": "not reached yet",
  "chg.status.APPLIED": "applied",
  "chg.status.CONFIRMED": "confirmed",
  "chg.status.FAILED": "failed",
  "chg.status.QUEUED": "queued",
  "chg.status.SENT": "sent",
  "chg.status.SUPERSEDED": "superseded",
  "chg.statusCol": "Stage",
  "chg.statusHint.APPLIED": "The agent wrote to the machine database but has not yet confirmed the change is visible there.",
  "chg.statusHint.CONFIRMED": "The agent confirmed the change is visible in the machine database. Only this means „done”.",
  "chg.statusHint.FAILED": "The write on the machine failed. The reason is in the operation details.",
  "chg.statusHint.QUEUED": "Intent stored in the portal. Nobody has carried it out on the machine yet.",
  "chg.statusHint.SENT": "The agent fetched the change. That does NOT mean it wrote it to the machine database.",
  "chg.statusHint.SUPERSEDED": "A newer change to the same record invalidated this operation.",
  "chg.stepperNote": "Stages after „queued” are advanced by the agent at the customer site once it fetches the operation and applies it to the machine database. An operation sitting here means the agent has not fetched it yet — or is not running.",
  "chg.stepperNoteAdvanced": "This operation moved past the first stage, meaning something carried it out on the machine. In this version of the portal only the agent at the customer site advances stages — the portal never changes them itself.",
  "chg.table": "Table",
  "chg.tables": "Tables",
  "chg.waiting": "Waiting",
  "chg.waitingDays": "{n} days",
  "chg.wydaniaLicznik": "{ile} of {wszystkich} confirmed",
  "chg.wydaniaTytul": "Which databases already have this change",
  "chg.wydanieLiczby": "written {zapisanych} · skipped {pominietych}",
  "common.cancel": "Cancel",
  "common.checkingSession": "Checking session…",
  "common.close": "Close",
  "common.configured": "configured",
  "common.delete": "Delete",
  "common.disabled": "disabled",
  "common.edit": "Edit",
  "common.enabled": "enabled",
  "common.error": "Error",
  "common.inProgress": "in progress",
  "common.loading": "Loading…",
  "common.nie": "no",
  "common.notConfigured": "not configured",
  "common.save": "Save",
  "common.starszaInstancja": "This screen comes from a newer portal build than this instance's API — the missing route answers 404. The feature will appear once the backend rollout finishes; nothing needs fixing.",
  "common.tak": "yes",
  "dashboard.auth": "Authentication",
  "dashboard.noIslandBody": "An island is one SPS database and it appears on its own — with the first agent enrolment on a customer machine. Until one agent enrols, the portal has no source for machines, employees or transactions.",
  "dashboard.noIslandCta": "Add the first agent",
  "dashboard.noIslandNoAccess": "Adding agents is handled by SDI service — contact us and we will bring the first island up.",
  "dashboard.noIslandSteps": "On the Agents screen you issue an enrolment code and download the installer — one archive that lays everything out on the customer machine by itself.",
  "dashboard.noIslandTitle": "No island yet",
  "dashboard.runtime": "Runtime configuration",
  "dashboard.stack": "Stack",
  "dashboard.storage": "File storage (S3/MinIO)",
  "dashboard.storageOff": "not connected",
  "dashboard.subtitle": "Instance status and runtime configuration",
  "dashboard.sync": "Sync engine",
  "dashboard.syncBrakWezlow": "This island has no database node yet — synchronisation starts once the first agent is deployed.",
  "dashboard.syncMasterDoPotwierdzenia": "Island master database: „{baza}\" on the customer machine — not confirmed yet (Island settings → Deployment model and island database).",
  "dashboard.syncMasterNaMaszynie": "Island master database: „{baza}\" — it sits on the customer machine.",
  "dashboard.syncMasterNieustalony": "Island master database: \"{baza}\". The portal does not know which node hosts it — seeding the master will settle that (Backups → to machine → restore).",
  "dashboard.syncMasterOk": "Master \"{baza}\" runs on node {wezel} and is syncing — last signal {minut} min ago.",
  "dashboard.syncMasterSamaBaza": "Island master database: „{baza}\".",
  "dashboard.syncMasterZly": "Master \"{baza}\" on node {wezel} IS NOT RESPONDING PROPERLY (last signal {minut} min ago).",
  "dashboard.syncModul": "This instance has the synchronisation module. This portal version does not report the island state.",
  "dashboard.title": "Dashboard",
  "dashboard.trybSmartSync": "Smart Sync",
  "dashboard.trybZwykly": "plain",
  "dashboard.vendingPlus": "Vending+ token",
  "dashboard.vendingPlusBrak": "none",
  "dashboard.vendingPlusBrakHint": "This instance has no active token — the Vending+ integration has nothing to authenticate with. Issue one in Administration → {gdzie}.",
  "dashboard.vendingPlusHint": "Issued {kiedy}, last used {ostatnio} ({n} calls).",
  "dashboard.vendingPlusNieuzywany": "Issued {kiedy} but NEVER used — the secret did not reach the other side, or their integration never started.",
  "dashboard.vendingPlusWaski": "issued, narrower scope",
  "dashboard.vendingPlusWaskiHint": "The scope is NARROWER than the full integration — some routes will answer 403. Fix the scope under Panel tokens.",
  "dashboard.vendingPlusWydany": "issued",
  "dashboard.version": "Version",
  "emp.active": "Account active",
  "emp.activity": "Activity",
  "emp.add": "Add employee",
  "emp.addTitle": "New employee",
  "emp.alias": "Additional number (alias)",
  "emp.allCostCenters": "all cost centres",
  "emp.allGroups": "all groups",
  "emp.byGroup": "Employees by group",
  "emp.byGroupEmpty": "No group on this island has members yet.",
  "emp.byGroupFilter": "Click to narrow the list to this group.",
  "emp.cardChangeAction": "Change number",
  "emp.cardChangeHistory": "Change the number in the dispense history too",
  "emp.cardChangeHistoryHint": "SPS does NOT do this — on its side past dispenses keep the old number and become detached from the person. Ticking this rewrites them to the new number so reports follow the person. The cost is divergence from any database copy taken earlier on the customer's side.",
  "emp.cardChangeIntro": "In SPS the card number is the key by which seven tables recognise an employee. Changing it moves group membership, machine access, allowed operations, the cost centre and any limit or item access aimed at this person. The rest of the row — including the PIN — is left untouched.",
  "emp.cardChangeNew": "New card number",
  "emp.cardChangeRemovedHolder": "Held by „{name}” (removed from machines) — „Delete from Vendi permanently” frees it.",
  "emp.cardChangeSame": "That is this person's current number.",
  "emp.cardChangeTitle": "Change card number",
  "emp.cardChangeWarn": "The operation reaches the machine on the agent's next cycle as a single batch and is applied in full or not at all. Until it is confirmed the portal already shows the new number while the machine still has the old one.",
  "emp.cardChanged": "Change {stary} → {nowy} queued ({n} dispenses in history)",
  "emp.cardNumber": "Card number",
  "emp.cardPending": "The card is free in the portal but a queued change operation is waiting for it.",
  "emp.cardTaken": "This card is already assigned to „{name}\". SPS is case-insensitive.",
  "emp.columnsNotice": "The change is queued and reaches the machine on the agent’s next cycle. Until it is confirmed the row is marked as pending.",
  "emp.costCenter": "Cost centre",
  "emp.costCenterFromDict": "from the cost-centre dictionary",
  "emp.costCenterInUse": "used by {n} people",
  "emp.costCenterNone": "no cost centre",
  "emp.costCenterUnknown": "outside the dictionary (code from customer data)",
  "emp.created": "Employee created",
  "emp.dateRangeEnable": "Limit account validity to a date range",
  "emp.dateRangeEnd": "Valid until",
  "emp.dateRangeHint": "A calendar date on the machine, with no time zone. An empty bound means “no limit on this side”.",
  "emp.dateRangeOrder": "“Valid from” is later than “valid until” — such a range contains no days at all.",
  "emp.dateRangeStart": "Valid from",
  "emp.detailError": "Could not load the employee’s settings. The form stays closed, because saving without them would zero out what it never showed.",
  "emp.detailLoading": "Loading employee settings…",
  "emp.editTitle": "Edit employee",
  "emp.employee": "Employee",
  "emp.bezNazwy": "(no name)",
  "emp.flag.allowDisabledItems": "May take disabled items",
  "emp.flag.canAccessExternalStock": "Access to external stock",
  "emp.flag.canSizeGrid": "May resize the grid on the machine screen",
  "emp.flag.demoModeOnly": "Demo mode only (no real dispense)",
  "emp.flag.dispenseUsedFirst": "Dispense used items first",
  "emp.flag.forceCountersign": "Require a second person’s countersign",
  "emp.flag.ignoreStrictReturnRule": "Skip the strict return rule",
  "emp.flag.ignoreSwap": "Skip the swap rule “return old, take new”",
  "emp.flag.isHhAdmin": "Handheld terminal administrator (HH)",
  "emp.flag.kitChangeIssue": "May change kit contents when issuing",
  "emp.flag.kitExceed": "May take a kit beyond the planned quantity",
  "emp.flag.kitIgnoreShortage": "Issue a kit despite missing items",
  "emp.flag.offerConUncon": "Offer both returnable and non-returnable items",
  "emp.flag.returnToMenu": "Log out after the operation",
  "emp.flag.singleCompRestrict": "Restrict to a single compartment",
  "emp.flag.skipFpCheck": "Skip fingerprint verification",
  "emp.group": "Employee group",
  "emp.groups": "Groups",
  "emp.groupsNone": "This island has no employee groups yet.",
  "emp.grupySzukaj": "Search groups…",
  "emp.grupyBrakTrafien": "No group matches the search",
  "emp.inactive": "inactive",
  "emp.kpi.active": "Active",
  "emp.kpi.activeRecently": "Active recently ({d} d)",
  "emp.kpi.all": "All",
  "emp.kpi.blocked": "Blocked",
  "emp.kpi.inGroups": "In groups",
  "emp.kpi.withLimits": "With limits",
  "emp.limitsShort": "Lim.",
  "emp.machine": "Machine",
  "emp.machines": "Machines",
  "emp.machinesAll": "Select all",
  "emp.machinesClear": "Clear all",
  "emp.machinesEmpty": "This island has no machines yet.",
  "emp.machinesShort": "Mach.",
  "emp.machinesViaGroup": "via group",
  "emp.machinesViaGroupHint": "This machine is also reachable through the employee’s group — clearing it here will not revoke access.",
  "emp.machinesZGrup": "+{n} via group",
  "emp.machinesZGrupHint": "Machines available through the employee's groups, besides direct assignments",
  "emp.multiHint": "This person collects items from more than one machine — a limit counted per machine would come out too low for them.",
  "emp.name": "Full name",
  "emp.noGroup": "no group",
  "emp.onlyMulti": "Only people using >1 machine",
  "emp.pendingHint": "There is an unapplied configuration change for this employee.",
  "emp.pinChange": "Change PIN",
  "emp.pinClearWarn": "An empty field with the toggle on will CLEAR the employee’s PIN.",
  "emp.pinLabel": "New PIN",
  "emp.rationEffect": "Ration enforcement",
  "emp.rationEffect1": "1 — do not enforce limits at all",
  "emp.rationEffect2": "2 — do not enforce, but log dispenses",
  "emp.rationEffect3": "3 — enforce limits",
  "emp.rationOff": "The machine does NOT enforce limits for this person",
  "emp.saved": "Change queued",
  "emp.section.basic": "Basic data",
  "emp.section.groups": "Employee groups",
  "emp.section.machines": "Machines",
  "emp.section.more": "More settings",
  "emp.section.pin": "PIN at the machine",
  "emp.selected": "selected: {n} of {total}",
  "emp.state": "Account state",
  "emp.stateActive": "Active",
  "emp.stateAll": "All",
  "emp.stateInactive": "Inactive only",
  "emp.status": "Status",
  "emp.statusActive": "active",
  "emp.statusBlocked": "blocked",
  "emp.statusBlockedHint": "Users.ALLOWLOGIN = 0 — the account cannot log in at the machine.",
  "grp.add": "Add group",
  "grp.addTitle": "New employee group",
  "grp.assignAction": "Add to group ({n})",
  "grp.assignTo": "Target group",
  "grp.assignToPick": "pick a group…",
  "grp.available": "Outside the group",
  "grp.candidatesCapped": "Showing at most 50 people — narrow it down with search.",
  "grp.code": "Group code",
  "grp.codeChangeAction": "Change group code",
  "grp.usun.akcja": "Delete group",
  "grp.usun.tytul": "Delete group?",
  "grp.usun.przycisk": "Delete group",
  "grp.usun.zlecone": "Group deletion ordered",
  "grp.usun.blokady": "Cannot delete — the group is referenced by:",
  "grp.usun.blokSzuflada": "drawer (owner): {automat}, drum {beben}, drawer {szuflada}",
  "grp.usun.blokKlapa": "lid (owner): {automat}, drawer {szuflada}, lid {klapa}",
  "grp.usun.blokPozycja": "machine item: {automat}, item {towar} ({role})",
  "grp.usun.blokRaport": "report schedule: {nazwa}",
  "grp.usun.blokKolejka": "unfinished changes of this group in the queue",
  "grp.usun.zniknie": "Deleted together with the group:",
  "grp.usun.czlonkostwa": "memberships",
  "grp.usun.bezInnejGrupy": "{n} with no other group",
  "grp.usun.pokazOsoby": "show people",
  "grp.usun.automaty": "group machines (access)",
  "grp.usun.tracaDostep": "{n} people will lose access to a machine",
  "grp.usun.bezAutomatu": "{n} with no machine at all",
  "grp.usun.operacje": "allowed operations",
  "grp.usun.limity": "limits",
  "grp.usun.uprawnienia": "item permissions",
  "grp.usun.historia": "Issue history stays unchanged.",
  "grp.usun.hrPlus": "HR+ manages {n} members of this group — remove it in HR+ too, otherwise HR+ will point to a group that no longer exists.",
  "grp.usun.hrPlusWyjatek": "The group will be removed from HR+ exceptions.",
  "grp.usun.potwierdz": "Type the group code “{kod}” to confirm",
  "grp.codeChangeIntro": "In SPS the group code is the key by which six tables recognise the group. Changing it moves the membership, machine access, allowed operations and any limit or item access aimed at this group. The rest of the row is left untouched.",
  "grp.codeChangeNew": "New group code",
  "grp.codeChangeTitle": "Change group code",
  "grp.codeChangeWarn": "Dispensing history STAYS under the old code — SPS does not rewrite it either, and a report for a closed period should show the code that applied back then. The operation reaches the machine on the agent's next cycle and is applied in full or not at all.",
  "grp.codeChanged": "Group code change {stary} → {nowy} queued",
  "grp.codePending": "The code is free in the portal but a queued change operation is waiting for it.",
  "grp.codeTaken": "This code is already taken by „{name}\". SPS is case-insensitive.",
  "grp.created": "Group created",
  "grp.editTitle": "Rename group",
  "grp.inGroup": "In group",
  "grp.limits": "Limits",
  "grp.limitsHint": "This many rationing rules target this group.",
  "grp.limitsWarn": "{n} rationing rules target this group. Changing its membership immediately shifts who those limits cover — and limits are counted against fleet-wide totals, not per machine.",
  "grp.machines": "Machines",
  "grp.machinesAll": "Select all",
  "grp.machinesAlsoIn": "The same link is editable on Assignments, from the machine's side.",
  "grp.machinesClear": "Clear all",
  "grp.machinesHeads": "people in group: {n}",
  "grp.machinesNone": "This island has no machines yet.",
  "grp.machinesSaved": "Machine access change queued",
  "grp.machinesSelected": "selected: {n} of {total}",
  "grp.machinesTitle": "Machine access",
  "grp.members": "Members",
  "grp.membersSaved": "Membership change queued",
  "grp.membersTitle": "Group members",
  "grp.name": "Group name",
  "grp.noCandidates": "No employees match the criteria.",
  "grp.noMembers": "The group is empty.",
  "grp.pendingHint": "There is an unapplied configuration change for this group or its membership.",
  "grp.saved": "Change queued",
  "grp.withoutGroupBanner": "{n} active employees belong to no group at all. Rationing rules target groups among other things, so no group rule covers these people.",
  "grp.withoutGroupCount": "without a group: {n}",
  "grp.withoutGroupDesc": "Active employees on this island who belong to no group. Select and assign them — the selection survives paging.",
  "grp.withoutGroupEmpty": "Every active employee belongs to at least one group.",
  "grp.withoutGroupShow": "Show the list",
  "grp.withoutGroupTitle": "Employees without a group",
  "harm.aktywny": "Enabled",
  "harm.bezWysylki": "E-mail delivery is not working yet — we are waiting for attachment support in the notification service. Until then a run BUILDS the file and records the trace (period, row count, size), so you can see it is produced correctly and on time.",
  "harm.brakOdbiorcow": "no recipients — file and trace only",
  "harm.czestotliwosc.DZIENNIE": "daily at {godzina}",
  "harm.czestotliwosc.MIESIECZNIE": "monthly, day {dzienMiesiaca} at {godzina}",
  "harm.czestotliwosc.TYGODNIOWO": "weekly, {dzien} at {godzina}",
  "harm.czestotliwoscNazwa.DZIENNIE": "daily",
  "harm.czestotliwoscNazwa.MIESIECZNIE": "monthly",
  "harm.czestotliwoscNazwa.TYGODNIOWO": "weekly",
  "harm.dniaMiesiaca": "day {n}",
  "harm.dodaj": "New schedule",
  "harm.dzien.1": "on Monday",
  "harm.dzien.2": "on Tuesday",
  "harm.dzien.3": "on Wednesday",
  "harm.dzien.4": "on Thursday",
  "harm.dzien.5": "on Friday",
  "harm.dzien.6": "on Saturday",
  "harm.dzien.7": "on Sunday",
  "harm.edytorOpis": "You set this up once — it runs without you afterwards.",
  "harm.edytuj": "Edit schedule",
  "harm.format": "File format",
  "harm.godzinaHint": "The hour is in the island's time zone, not your browser's — a 6:00 report arrives at six at the customer, daylight saving included.",
  "harm.historia": "Run history",
  "harm.jeszczeNieChodzil": "Has not run even once yet.",
  "harm.kiedy": "When",
  "harm.kolumny": "Columns in the file",
  "harm.kolumnyHint": "The selection and its order are stored WITH THE SCHEDULE, not in this browser — every delivery uses this exact layout.",
  "harm.naglowkiTxt": "Column headers in the .txt file",
  "harm.naglowkiTxtHint": "Applies to this one schedule. Turn it off when the file is ingested by a program that does not expect a column-name row.",
  "harm.naglowkiTxtNie": "Without headers",
  "harm.naglowkiTxtTak": "With headers",
  "harm.nastepny": "next:",
  "harm.nazwa": "Name",
  "harm.nazwaHint": "e.g. Weekly report for the foreman",
  "harm.oGodzinie": "at",
  "harm.odbiorcy": "Recipients",
  "harm.odbiorcyHint": "Addresses separated by commas. May be left empty — the run then only builds the file and records the trace.",
  "harm.okres.biezacyMiesiac": "current month",
  "harm.okres.ostatnie30dni": "last 30 days",
  "harm.okres.ostatnie7dni": "last 7 days",
  "harm.okres.poprzedniMiesiac": "previous month",
  "harm.okres.poprzedniTydzien": "previous week (Mon–Sun)",
  "harm.okres.wczoraj": "yesterday",
  "harm.okresHint": "Computed at every run, in machine time. That is why there is no „from–to” here: a stored date would mean the same week arrives every week.",
  "harm.okresPole": "Period",
  "harm.ostatniBlad": "error",
  "harm.ostatniOk": "OK",
  "harm.podtytul": "The report is built on the server and goes out without anyone clicking. The period is computed at every run, so a weekly report always covers the last week.",
  "harm.pusto": "No schedule yet.",
  "harm.raport": "Report",
  "harm.raport.stanAutomatow": "Machine stock",
  "harm.raport.transactions": "Issues",
  "harm.tytul": "Report schedules",
  "harm.uruchom": "Run",
  "harm.uruchomHint": "Builds the file now. Does NOT move the scheduled time — a check must not delay the delivery.",
  "harm.uruchomionoBlad": "Run failed",
  "harm.uruchomionoOk": "Run finished — {n} rows",
  "harm.usunPytanie": "The definition and the whole run history will disappear. The report itself stays — you can still download it from the screen.",
  "harm.usunTytul": "Delete the schedule?",
  "harm.usunieto": "Schedule deleted.",
  "harm.wierszy": "rows: {n}",
  "harm.wrocDoRaportow": "Back to reports",
  "harm.wylaczony": "disabled",
  "harm.zaDuzy": "too big for e-mail",
  "harm.zaDuzyHint": "The file exceeds 20 MB, the limit a recipient's mailbox normally accepts. Narrow the period or pick fewer columns.",
  "hist.bezKonta": "no linked account",
  "hist.bezWartosci": "limit removed",
  "hist.dojechalo": "confirmed by the machines",
  "hist.dymek": "The portal changed this limit {n} times — show what it was",
  "hist.pusto": "The portal has not changed this limit.",
  "hist.rodzaj.INNE": "other change",
  "hist.rodzaj.USTAWIONY": "set",
  "hist.rodzaj.ZDJETY": "removed",
  "hist.rodzaj.ZMIENIONY": "changed",
  "hist.tytul": "Limit changes made in the portal",
  "hist.wDrodze": "not at the machines yet ({stan})",
  "hist.zakresWiedzy": "Only changes submitted from the portal are shown, and at most the last 30. Changes made at the machine in SPSUtilities are invisible to the portal.",
  "histKarty.bezKonta": "no account",
  "histKarty.dojechalo": "delivered to the machines",
  "histKarty.pokaz": "Number history",
  "histKarty.pusto": "The portal has never changed this employee’s card number.",
  "histKarty.tytul": "Card number changes made in the portal",
  "histKarty.wDrodze": "on its way to the machines ({stan}) — they still know the old number",
  "histKarty.zakresWiedzy": "Only changes made through the portal appear here. A number changed at the machine (SPSUtilities) cannot be shown — the portal never composed that change.",
  "ig.codeChangeAction": "Change group code",
  "ig.codeChangeIntro": "In SPS the group code is the key by which seven tables recognise the group. Changing it moves the item assignments, subgroups, limits and access along with it. Subgroups have a composite key made of the group code and their own, so each one gets its own move — a subgroup with an inconsistent key stops the whole operation instead of being orphaned.",
  "ig.codeChangeNew": "New group code",
  "ig.codeChangeTitle": "Change item group code",
  "ig.codeChangeWarn": "In SPS the group code holds only 16 characters — fewer than an item number. The operation reaches the machine on the agent's next cycle and is applied in full or not at all; if a single row in the cascade were left under the old code, the agent rejects the whole thing.",
  "ig.codeChanged": "Group code change {stary} → {nowy} queued",
  "igrp.add": "Add group",
  "igrp.addSub": "Add subgroup",
  "igrp.addSubTitle": "New subgroup",
  "igrp.addTitle": "New item group",
  "igrp.brakObrazkow": "Groups with an image the portal does not have: {n}",
  "igrp.code": "Group code",
  "igrp.codeFree": "Code is free",
  "igrp.codeHint": "The code is assigned by a person — in SPS it is text, e.g. BHP. At most 16 characters, no underscore.",
  "igrp.codeImmutable": "The code cannot be changed here, and that is not an oversight. Items point at a group by the text value of its code and SPS has no foreign keys — changing the code means rewriting it in Items (two columns), in subgroups (code and composite key) and in rationing rules. That is a separate operation with its own risk, not a field edit.",
  "igrp.codePending": "A queued change operation is waiting for this key.",
  "igrp.codeReused": "This code has been deleted on this island before. The deletion cascade does cover access entries (Restrictions2), but only those known to the portal read-model and only once the operation has been APPLIED to the customer database. If that operation has not landed yet, or synchronisation did not carry every entry, orphaned entries with the old code will attach to this group. We do not read the REST_ENABLED/REST_DENY flags, so it is not known whether such an entry permits or DENIES — worth checking access after this applies.",
  "igrp.codeTaken": "Code {code} already belongs to „{name}\". SPS is case-insensitive.",
  "igrp.collapse": "Collapse subgroups",
  "igrp.created": "Group added to the change queue",
  "igrp.delAssumedKeyAck": "I understand the key of the access-entry table (Restrictions2) is ASSUMED in our mapping, not confirmed by any executed write — if it differs, the deletion will not match the row in the customer database. I also understand the cascade removes only entries known to the portal read-model; if synchronisation did not carry them all, the rest must be cleaned up separately.",
  "igrp.delItemsDetached": "items will be DETACHED from the group (the items themselves stay in the catalogue — they are not deleted)",
  "igrp.delItemsToParent": "items will return to group {code} (the subgroup goes, the main group code stays on the item)",
  "igrp.delPendingWarn": "A change operation is already queued for this key. The deletion enters the queue AFTER it, so check they do not cancel each other out.",
  "igrp.delRationing": "rationing rules targeting this group will be deleted — the limit stops applying",
  "igrp.delRestrictions": "item access entries will be deleted (including those of the subgroups) — the portal does not know whether they permitted or DENIED",
  "igrp.delSubGroups": "subgroups will be deleted:",
  "igrp.deleteConfirm": "Delete",
  "igrp.deleteSubTitle": "Delete subgroup",
  "igrp.deleteTitle": "Delete group",
  "igrp.deleted": "Deletion added to the change queue",
  "igrp.doArtykulow": "Show items in this group",
  "igrp.empty": "No item groups for these filters.",
  "igrp.emptyGroup": "Neither this group nor its subgroups hold a single item.",
  "igrp.emptyHint": "A group that, together with its subgroups, holds no items at all.",
  "igrp.expand": "Expand subgroups",
  "igrp.exp.groupName": "Group name",
  "igrp.exp.isgid": "Subgroup key (ISGID)",
  "igrp.exp.items": "Items",
  "igrp.exp.itemsSubtree": "Items incl. subgroups",
  "igrp.exp.machines": "Machines",
  "igrp.exp.rationing": "Limits",
  "igrp.exp.subName": "Subgroup name",
  "igrp.group": "Group",
  "igrp.inGroup": "In group",
  "igrp.isgidPreview": "The composite key sent to SPS will be:",
  "igrp.isgidTaken": "The composite key already belongs to „{name}\" — to SPS that is the same row.",
  "igrp.isgidWhy": "The subgroup key is this joined value (ISGID), not the bare code — a bare subgroup code need not be unique, so it is the composite that items carry.",
  "igrp.itemsDirect": "items",
  "igrp.obrazek": "Group image",
  "igrp.kafelki.brak": "The portal does not know this setting on this island.",
  "igrp.kafelki.czesc": "enabled: {n} of {m}",
  "igrp.kafelki.nigdzie": "disabled everywhere ({m})",
  "igrp.kafelki.wszedzie": "enabled everywhere ({m})",
  "igrp.kafelki.zmien": "Change",
  "igrp.kafelki.restart": "The setting takes effect after SPSUI restarts, new group images after logging in again.",
  "igrp.kafelki.starsze": "Saving requires agent {wersja}: {wezly}",
  "igrp.kafelki.tytul": "Graphic selection",
  "igrp.kafelki.wKolejce": "queued",
  "igrp.kafelki.zapisano": "Change queued (machines: {n})",
  "igrp.itemsSubtree": "with subgroups",
  "igrp.kpi.emptyGroups": "Groups with no items",
  "igrp.kpi.groups": "Main groups",
  "igrp.kpi.itemsInSubGroups": "Items in subgroups",
  "igrp.kpi.itemsWithoutGroup": "Items with no group",
  "igrp.kpi.rationing": "Limits on groups",
  "igrp.kpi.subGroups": "Subgroups",
  "igrp.machines": "machines",
  "igrp.name": "Name",
  "igrp.nameHint": "At most 32 characters. Note: an ITEM name allows 255, but a group name in SPS (DESCR) only 32 — SPS would truncate a longer one without warning.",
  "igrp.noGroupHint": "In SPS both group columns may be empty, so an item with no group is a legal state — not an error.",
  "igrp.noIsgid": "no composite key",
  "igrp.noIsgidHint": "This subgroup has no stored ISGID, so there is nothing to address its row in SPS with — renaming will fail. This is data to repair on the synchronisation side.",
  "igrp.orphanHint": "{n} rationing rules target a code that no main group on this island has.",
  "igrp.orphanNotice": "Note: {n} rationing rules target a group code that does not exist on this island. SPS has no foreign keys, so such a row is legal there and nothing flags it — while the limit covers nothing. Worth checking whether the group was deleted outside the portal.",
  "igrp.pending": "change queued",
  "igrp.pokr.brakNa": "missing: {n}",
  "igrp.pokr.braki": "missing for {n} groups",
  "igrp.pokr.czesciowo": "only some machines checked",
  "igrp.pokr.innyNa": "different: {n}",
  "igrp.pokr.nieSprawdzano": "never checked",
  "igrp.pokr.rozjazd": "different file for {n} groups",
  "igrp.pokr.sprawdzono": "checked {kiedy}",
  "igrp.pokr.tytul": "Group images on machines",
  "igrp.pendingHint": "A queued change operation is waiting for this key.",
  "igrp.rationing": "limits",
  "igrp.rationingHint": "Rationing rules targeting a main group code (Rationing.ITEMTYPE=8).",
  "igrp.renameTitle": "Rename",
  "igrp.renamed": "Rename added to the queue",
  "igrp.searchPlaceholder": "Search by code or name…",
  "igrp.showEmpty": "Show groups with no items",
  "igrp.subCode": "Subgroup code",
  "igrp.subCodeHint": "At most 16 characters. An underscore is allowed here — the subgroup key splits on the first one, and that belongs to the parent group.",
  "igrp.subCreated": "Subgroup added to the change queue",
  "igrp.subGroup": "Subgroup",
  "emp.importuj": "Import",
  "emp.usunKarty": "Remove cards",
  "emp.usunieta": "Removed from machines",
  "emp.usunietaHint": "Only in Vendi — removed from machines {kiedy} (from the portal)",
  "emp.usunietaHintWezel": "Only in Vendi — removed from machines {kiedy} (on {wezel})",
  "emp.filtrUsunieci": "Removed from machines",
  "emp.usunZAutomatow": "Remove from machines",
  "emp.usunTrwale": "Delete from Vendi permanently",
  "emp.hr.HR_PLUS": "HR+",
  "emp.hr.HR_PLUS_ZABLOKOWANA": "HR+ · blocked",
  "emp.hr.SPOZA_HR": "Not in HR+",
  "emp.hr.numer": "HR+ number: {n}",
  "emp.hr.filtr": "HR+",
  "emp.hr.filtrZ": "From HR+",
  "emp.hr.filtrSpoza": "Not in HR+",
  "emp.hrPlusBaner": "HR+ manages this island's employees — adding is off, and manual changes to name, cost centre and block will be overwritten with HR+ data.",
  "emp.hrPlusZablokowane": "People are added by HR+",
  "emp.hrPlusEdycja": "HR+ manages this island — name, cost centre and block will be overwritten with HR+ data.",
  "karty.tytul": "Remove cards from machines",
  "karty.opis": "One card per line. Blocked first, then deleted; the person stays in Vendi with the issue history.",
  "karty.lista": "Card numbers",
  "karty.placeholder": "0001\n0002",
  "karty.ile": "Cards: {n}",
  "karty.zaDuzo": "At most {n} cards at once",
  "karty.doUsuniecia": "To remove: {n}",
  "karty.juzUsuniete": "Already removed: {n}",
  "karty.nieznane": "Unknown: {n}",
  "karty.powtorzenia": "Duplicates: {n}",
  "karty.zniknie": "Removed from machines",
  "karty.przypisan": "machines {n}",
  "karty.grup": "groups {n}",
  "karty.mpk": "cost centers {n}",
  "karty.operacji": "operations {n}",
  "karty.limitow": "limits {n}",
  "karty.dostepow": "access {n}",
  "karty.dostawcow": "suppliers {n}",
  "karty.bazy": "Databases: {lista}",
  "karty.operacjiWCzesciach": "Operations: {n} (50 cards each)",
  "karty.starsze": "Requires agent {wersja} on every database. Older ones: {lista}",
  "karty.kolKarta": "Card",
  "karty.kolOsoba": "Person",
  "karty.kolStan": "State",
  "karty.kolAutomaty": "Machines",
  "karty.kolWydania": "Issues",
  "karty.stan.DO_USUNIECIA": "to remove",
  "karty.stan.JUZ_USUNIETA": "already removed",
  "karty.stan.NIEZNANA": "unknown",
  "karty.iWiecej": "…and {n} more",
  "karty.trwale": "Also delete from Vendi (permanently)",
  "karty.odpiecie": "I understand: {n} issues will stay without a person (with the number and name at issue time), and Vending+ will receive the person deletion.",
  "karty.zmienListe": "Change list",
  "karty.sprawdz": "Check",
  "karty.usun": "Remove from machines",
  "karty.usunTrwale": "Delete from Vendi permanently",
  "karty.wynik": "Queued — cards: {n}, operations: {k}",
  "karty.wynikTrwale": "Permanently from Vendi: {n}",
  "karty.wynikBlokada": "Blocked first: {n}",
  "karty.zakolejkowano": "Card removal queued",
  "imp.grupy.brakNaWyspie": "This island has no employee groups yet.",
  "imp.grupy.klik": "Click to see this island groups and enter the right one",
  "imp.grupy.nicNiePasuje": "Nothing matches",
  "imp.grupy.opis": "This row says: {co}. Click a group to put it into this row.",
  "imp.grupy.osob": "{ile} ppl.",
  "imp.grupy.szukaj": "group name or code",
  "imp.grupy.tylkoPodglad": "In the spreadsheet import the group comes from a file column — fix it in the column mapping.",
  "imp.grupy.tytul": "Employee groups on this island",
  "imp.zajeta.aktywne": "active",
  "imp.zajeta.bezNazwy": "(no name)",
  "imp.zajeta.klik": "Click to see who uses this card",
  "imp.zajeta.konto": "Account",
  "imp.zajeta.nadpisuj": "Overwrite existing employees",
  "imp.zajeta.nadpisujIle": "Applies to the WHOLE batch: {ile} rows use a taken card. Each becomes an update instead of a create.",
  "imp.zajeta.nieWiemyKto": "The number is taken, but we do not know by whom — we load up to 500 employees; a larger island is checked by the instance.",
  "imp.zajeta.opis": "This card number already has an employee on this island.",
  "imp.zajeta.tytul": "Who uses this card",
  "imp.zajeta.zablokowane": "blocked",
  "imp.bezZmianWiersz": "Every provided field matches the database — saving would not change a single column.",
  "imp.bylo": "This is what the client database has now",
  "imp.odznaczBezZmian": "Clear unchanged ({ile})",
  "imp.puste": "(empty)",
  "imp.trybBezZmian": "no change",
  "imp.noweCentrum": "New cost center — nobody on this island has it yet",
  "imp.nadpisuj": "Update employees that already exist",
  "imp.nadpisujOpis": "A row with an existing card number will overwrite that person instead of being rejected. Empty fields are left untouched.",
  "imp.grupyZastapuj": "Group from the file replaces the current ones",
  "imp.grupyZastapujOpis": "Old memberships will be removed, only the group from the file remains.",
  "imp.grupyDodajOpis": "The group from the file will be added to those the employee already has.",
  "imp.rozbicie": "new: {nowych} · overwritten: {aktualizacji}",
  "imp.tryb": "What happens",
  "imp.trybNowy": "new",
  "imp.trybAktualizacja": "overwrite",
  "imp.bezZmian": "unchanged",
  "imp.bezZmianHint": "Empty in the file — the employee keeps what they have",
  "imp.automatyTylkoNowym": "Applies to new ones only. For the {ile} overwritten we do not touch machine access — the file says nothing about it.",
  "imp.odWiersza": "From row",
  "imp.doWiersza": "To row",
  "imp.odsianeFormuly": "Skipped {ile} rows where the card number is a formula result, not a number",
  "imp.odsianeBezKarty": "skipped {ile} rows with no card number",
  "imp.odznaczPowtorzone": "Uncheck repeated ({ile})",
  "imp.odznaczBledne": "Uncheck rows with errors ({ile})",
  "imp.odznaczonych": "unchecked: {ile}",
  "imp.przywrocWszystkie": "Restore all",
  "imp.wierszyZ": "{ile} of {z} will be imported",
  "imp.wezWiersz": "Include row {nr}",
  "imp.wLewo": "Move {pole} left",
  "imp.wPrawo": "Move {pole} right",
  "imp.kolejnoscDomyslna": "Restore the default order",
  "imp.usunZera": "Strip leading zeros from the card number",
  "imp.usunZeraSaZera": "{ile} numbers in this batch start with a zero.",
  "imp.usunZeraObcieto": "Stripped zeros from {ile} numbers — marked with an asterisk in the preview.",
  "imp.wPliku": "In the file: {co}",
  "imp.tytul": "Import employees",
  "imp.zakladkaTekst": "Paste a list",
  "imp.zakladkaPlik": "Excel file",
  "imp.pole.karta": "Card number",
  "imp.pole.nazwa": "Name",
  "imp.pole.alias": "Alias",
  "imp.pole.centrum": "Cost centre",
  "imp.pole.grupa": "Employee group",
  "imp.pole.logowanie": "Allow login",
  "imp.pole.wyloguj": "Log out after operation",
  "imp.pole.przegroda": "Single compartment restriction",
  "imp.pole.polityka": "Rationing policy",
  "imp.separator.tab": "Tab separated",
  "imp.separator.srednik": "Semicolon separated",
  "imp.separator.przecinek": "Comma separated",
  "imp.wierszy": "rows: {ile}",
  "imp.wybierzPlik": "Choose a file",
  "imp.arkusz": "Sheet",
  "imp.pierwszyNaglowek": "First row is a header",
  "imp.przeciagnij": "Drag a column onto a field, or pick it from the list.",
  "imp.kolumnaBezNazwy": "Column {nr}",
  "imp.bezKolumny": "— none —",
  "imp.domyslnie": "default",
  "imp.kartaLiczbowa": "The card-number column holds NUMERIC values in this file. If the numbers have leading zeros, the file no longer contains them and they cannot be recovered — check the preview before importing.",
  "imp.bladPliku": "Could not read the file.",
  "imp.podglad": "Preview",
  "imp.wiersz": "Row",
  "imp.pokazanoCzesc": "Showing the first 200 of {ile}.",
  "imp.brakGrup": "This island has no employee groups:",
  "imp.wWierszach": "rows",
  "imp.zaDuzy": "At most {max} employees per import — split the batch.",
  "imp.automaty": "Machine access",
  "imp.automatowWybrano": "{ile} of {z} selected — that is {wierszy} assignments in the client database.",
  "imp.zaimportuj": "Import ({ile})",
  "imp.zrobione": "Queued an import: {nowych} new, {aktualizacji} overwritten",
  "imp.blad.kartaPusta": "Card number missing",
  "imp.blad.kartaDluga": "Card number is at most 32 characters",
  "imp.blad.kartaZnaki": "Card number takes ASCII only — remove:",
  "imp.blad.kartaZajeta": "This card number is already in use on the island",
  "imp.blad.nazwaDluga": "Name is at most 50 characters",
  "imp.blad.aliasDlugi": "Alias is at most 50 characters",
  "imp.blad.centrumDlugie": "Cost centre is at most 50 characters",
  "imp.blad.grupaBrak": "No such employee group:",
  "imp.blad.grupaWiele": "That name matches several groups:",
  "imp.blad.znacznik": "Expected 0 or 1, got:",
  "imp.blad.polityka": "Rationing policy is 1, 2 or 3, got:",
  "overview.healthNoPk": "Database without primary keys: {ile} tables — show the fix",
  "agents.bezKlucza": "Database without primary keys: {ile} tables",
  "agents.bezKluczaSkutek": "The portal receives no: {co}. Config-down will also refuse writes to these tables.",
  "agents.bezKluczaPokazNaprawe": "Show how to fix it",
  "agents.naprawaTytul": "Database schema repair",
  "agents.naprawaTabel": "tables without a key",
  "agents.naprawaOpis": "These tables exist but have no primary key, so the agent cannot identify a row and skips them every cycle. The portal receives no: {co}.",
  "agents.naprawaSkad": "SPS creates these keys itself — their absence means they were dropped in this database. The columns below are read from a working installation of the same SPS version, not invented.",
  "agents.naprawaPolecenia": "To run against this node’s database",
  "agents.naprawaOstrzezenie": "The portal does not run this. Each pair is first a duplicate-key check, then the key creation — if the first SELECT returns rows, do not add the key until you decide which row is the real one.",
  "podm.beben": "drum {pic} ({n})",
  "podm.blad": "Could not swap the item",
  "podm.dalej": "Next",
  "podm.gdzieLezy": "The old item sits in {n} compartments:",
  "podm.jednolitosc": "Uniform-content rule removed from columns: {kolumny}.",
  "podm.limityPrzeniesione": "Moved {limitow} limit(s) and {ograniczen} access restrictions.",
  "podm.limityZostaja": "{limitow} limit(s) and {ograniczen} access restrictions stay on the old item. This operation does not touch them — the new item has none.",
  "podm.maks": "Capacity",
  "podm.nicNieZostalo": "All drums unchecked — nothing to swap.",
  "podm.nieWiadomo": "Not sure the request went through — check the change register.",
  "podm.opis": "The old item leaves its compartments, the new one takes them. The portal works out which.",
  "podm.potwierdz": "To be queued: “{z}” → “{na}” in {n} comp.",
  "podm.potwierdzPuste": "To be queued: emptying {n} comp. of “{z}”.",
  "podm.przegrodek": "{n} comp.",
  "podm.przeniesLimity": "Move limits to the new item",
  "podm.przeniesLimityOpis": "A separate operation: rewrites limits and access restrictions from the old item to the new one. Island-wide scope — these tables carry no machine number.",
  "podm.przycisk": "Swap item",
  "podm.pusta": "empty compartment",
  "podm.stanPrzepadnie": "{n} units of stock will be lost — SPS swaps an item by deleting and re-inserting the row.",
  "podm.tytul": "Swap an item in the planogram",
  "podm.wTeSame": "into the same compartments",
  "podm.wybierz": "— choose —",
  "podm.wyd": "Issue size",
  "podm.wykonaj": "Swap",
  "podm.wykonajPuste": "Empty",
  "podm.zIndeksu": "Retired",
  "podm.zeStarego": "as before",
  "podm.zlecona": "Queued a swap of “{z}” for “{na}” in {n} comp. — waiting in the change register.",
  "podm.zleconaPuste": "Queued emptying of {n} comp. of “{z}” — waiting in the change register.",
  "zdj.sciagnijZMaszyny": "download from machine",
  "podgladM.zapiszWBibliotece": "Save to the portal library",
  "podgladM.nazwaWBibliotece": "File name in the library",
  "podgladM.zapisz": "Save",
  "podgladM.zapiszNadpisz": "Save and overwrite",
  "podgladM.nadpiszeBiblioteke": "The library already holds {plik} — saving will overwrite its content. That is the only copy outside the machines.",
  "podgladM.zapisanoOpis": "Saved to the library as {plik}. Nothing was sent to the machines — broadcasting is a separate step.",
  "napraw.tytul": "Download from machine and send",
  "napraw.krok1": "The portal does not have this file. Choose a machine to download it from.",
  "napraw.krok2": "File from {maszyna}. Check it is the right photo and save it in the portal.",
  "napraw.innaMaszyna": "Another machine",
  "napraw.wezZtej": "download from this one",
  "napraw.brakZrodla": "No checked machine has this file. Upload a photo from your computer in the item window.",
  "napraw.wBibliotece": "Saved in the portal as {plik}. Nothing has gone to the machines yet.",
  "napraw.rozeslijOstrzezenie": "Sending assigns {plik} to this item and sends it to all machines ({n}) — including those with a different photo under this name. Those versions cannot be recovered afterwards.",
  "napraw.rozeslij": "Assign and send to machines",
  "napraw.rozeslano": "Sending {plik} to machines: {n}",
  "napraw.mozeszWyjsc": "You can close the window — the file stays in the portal.",
  "islands.none": "No sync islands available.",
  "kod.reguly": "Max 32 characters, no accented letters",
  "grp.opsLabel": "Allowed system operations",
  "grp.opsWybrane": "{ile} of {z} selected",
  "grp.opsBrakSlownika": "This SPS installation has not sent the operations dictionary yet — you can grant permissions after the first sync.",
  "kod.zaDlugi": "Max 32 characters",
  "kod.zleZnaki": "No accented or special characters",
  "islands.single": "This instance serves a single SPS master database — nothing to switch.",
  "islands.smartSync": "SMART SYNC",
  "islands.sync.dociaganie": "Catching up on withdrawal history on {n} nodes — new withdrawals keep flowing.",
  "islands.sync.zaleglosc": "{n} nodes are behind on sibling withdrawals.",
  "islands.smartSyncHint": "This island runs the Smart Sync model: the master lives in our MSSQL and the machines are slaves with their own local databases. In the regular model the master sits on the customer machine.",
  "islands.switch": "Active island (client / group)",
  "itm.absent": "not in the drum",
  "itm.absentShort": "not in drum",
  "itm.activity": "Activity",
  "itm.add": "Add item",
  "itm.addTitle": "New item",
  "itm.allGroups": "all groups",
  "itm.anyAssignment": "any assignment",
  "itm.anyFill": "any fill",
  "itm.assignment": "Assignment",
  "itm.belowThreshold": "needs refilling",
  "itm.brand": "Brand",
  "itm.breakdownTitle": "Per-machine breakdown",
  "itm.byGroup": "Items by group",
  "itm.created": "Item added to the change queue",
  "itm.editTitle": "Edit item",
  "itm.empty": "No items for these filters.",
  "itm.fill": "Fill",
  "itm.fillEmpty": "empty (0 units)",
  "itm.fillLow": "below the SPS threshold",
  "itm.fillOk": "above the threshold",
  "itm.group": "Item group",
  "itm.inDrumNoLimit": "no limit row",
  "itm.inDrumNoLimitHint": "The item sits in the drum but has no row in the machine item table (VendingMachineItems). SPS keeps the limit and reorder threshold there, so this item dispenses with neither.",
  "itm.isSubGroup": "This is an item subgroup",
  "itm.kpi.assigned": "Assigned",
  "itm.kpi.duplicateSupplierPart": "Dup. supplier no.",
  "itm.kpi.lowStock": "Needs refilling",
  "itm.kpi.obsolete": "Obsolete",
  "itm.kpi.total": "All",
  "itm.kpi.unassigned": "Unassigned",
  "itm.limits": "Limits",
  "itm.lowHint": "How many machines hold stock at or below the SPS reorder threshold. Machines without a threshold set are NOT counted here.",
  "itm.machine": "Machine",
  "itm.machines": "Machines",
  "itm.name": "Name",
  "itm.noCapacity": "no capacity",
  "itm.noGroup": "no group",
  "itm.noThreshold": "threshold not set",
  "itm.noThresholdHint": "This machine has no reorder threshold set (CRITICALLEVEL), so „needs refilling\" cannot be stated.",
  "itm.notAssigned": "This item is not assigned to any machine.",
  "itm.notAssignedShort": "unassigned",
  "itm.number": "Item number",
  "itm.numberChangeAction": "Change item number",
  "itm.numberChangeIntro": "In SPS the item number is the key by which seven tables recognise the item. Changing it moves the machine assignments, compartment contents, limits, access and external inventory along with it. Stock levels in compartments are left untouched — which is why the rows are not deleted and re-inserted, only the key is moved.",
  "itm.numberChangeNew": "New item number",
  "itm.numberChangeTitle": "Change item number",
  "itm.numberChangeWarn": "Dispensing history STAYS under the old number — SPS does not rewrite it either, and a report for a closed period should show the number that applied back then. The operation reaches the machine on the agent's next cycle and is applied in full or not at all.",
  "itm.numberChanged": "Item number change {stary} → {nowy} queued",
  "itm.numberPending": "The number is free in the portal but a queued change operation is waiting for it.",
  "itm.numberTaken": "This number already belongs to „{name}\". SPS is case-insensitive.",
  "itm.obsolete": "obsolete",
  "itm.obsoleteUnverified": "The OBSOLETE column is absent from the schema read out of the SPS product — it is optional per installation. We have not confirmed this customer’s database has it, so this operation may not apply there. The change log will record that explicitly.",
  "itm.onlyAssigned": "assigned to a machine only",
  "itm.onlyDuplicates": "Only items sharing a supplier number with another item",
  "itm.onlyUnassigned": "unassigned only",
  "itm.pendingHint": "A queued change operation is waiting for this item.",
  "itm.restoreConfirm": "Restore",
  "itm.restoreTitle": "Restore item",
  "itm.restoreWhy": "Restoring clears the OBSOLETE flag — the item returns to dispensing on the machines.",
  "itm.restored": "Restoration added to the change queue",
  "itm.retireConfirm": "Retire",
  "itm.retireTitle": "Retire item",
  "itm.retireWhy": "Retiring sets the OBSOLETE flag rather than deleting the row. It is the only reversible way to disable an item in SPS: a hard delete would leave orphaned references across a dozen tables and return the number to circulation.",
  "itm.retired": "Retirement added to the change queue",
  "itm.saved": "Item change added to the queue",
  "itm.state": "State",
  "itm.status": "Catalogue status",
  "itm.statusActive": "active",
  "itm.statusAll": "all",
  "itm.statusObsolete": "obsolete",
  "itm.stock": "Stock",
  "itm.subGroupHint": "A subgroup goes to SPS as the composite ISGID key, not the bare code — the bare subgroup code is not unique.",
  "itm.subGroupIsgid": "Subgroup addressed in SPS by composite key: {isgid}",
  "itm.supplierPart": "Supplier part no.",
  "itm.supplierPartHint": "The supplier catalogue number. It need not be unique — the portal warns when two items share one.",
  "itm.supplierPartSharedHint": "Other items share this supplier number. An order may arrive for the wrong item.",
  "itm.threshold": "SPS threshold",
  "itm.unitCost": "Unit cost",
  "itm.withdrawals": "withdrawals",
  "klucz.ponadSps": "{n} rows will be rewritten BEYOND what SPS does — the vendor cascade would leave the old prefix in them, pointing at a code that no longer exists.",
  "klucz.przyOkazji": "{n} rows will be rewritten ALONG THE WAY — the SPS cascade has no discriminator here, so it also touches rows that share the key but are not part of this operation. We keep the SPS behaviour so that the same change made from SPSConfig gives the same result.",
  "klucz.taSama": "That is the current value.",
  "klucz.wKolejce": "The value is free in the portal, but an operation in the change queue is waiting for it.",
  "klucz.wykonaj": "Move the key",
  "klucz.zaDlugi": "At most {n} characters — SPS would silently truncate a longer one and the record would land under a different key.",
  "klucz.zajety": "This value already belongs to „{name}”.",
  "klucz.zakres": "What this change will touch",
  "klucz.zakresSuma": "{n} rows",
  "klucz.zleZnaki": "Only ASCII characters are allowed — remove: {znaki}",
  "kopia.gotowa": "Ready",
  "kopia.plikUsuniety": "file removed (we keep the last 5)",
  "kopia.pobierz": "Download",
  "kopia.wKolejce": "queued",
  "kopia.zlec": "Back up the database",
  "kopia.zlecLokalna": "Backup on machine disk",
  "kopia.zlecLokalnaOpis": "Make a backup and keep it on the customer machine — no upload. The agent refuses if space would run out.",
  "kopia.zlecona": "Backup ordered — the agent will pick it up on its next cycle",
  "kopia.zleconaLokalna": "Local backup queued — it will appear in the list below when finished",
  "kopie.brak": "No backup exists for this island yet.",
  "kopie.brakAgenta": "This island has no database agent — nothing can take a backup.",
  "kopie.doPobrania": "downloadable: {n}",
  "kopie.dysk": "Disk {wolumen}",
  "kopie.dyskNieznany": "The agent has not reported disk state yet.",
  "kopie.kiedy": "When",
  "kopie.lista": "Backups taken",
  "kopie.lokalneBrakPomiaru": "This agent keeps no local backups, or has not measured them yet.",
  "kopie.lokalneOpis": "Stored at the customer site, outside the object store. No count limit — only disk space.",
  "kopie.lokalnePusto": "The backup folder on the machine is empty.",
  "kopie.lokalneTytul": "Backups on the machine disk",
  "kopie.maloMiejsca": "Less than 10% free — the agent will refuse the next backup, and a full disk stops SQL Server.",
  "kopie.maszyna": "Machine",
  "kopie.naMaszyne": "To machine",
  "kopie.naMaszyneNie.brakMaszyny": "Pick a machine from the list above first.",
  "kopie.naMaszyneNie.brakSumy": "This backup predates checksums, so the machine could not verify it arrived whole. Make a fresh backup.",
  "kopie.naMaszyneNie.juzTam": "This machine already holds this backup (checksums match) — pulling it would change nothing and costs hundreds of megabytes over the customer link.",
  "kopie.naMaszyneNie.trwa": "Wait — another task is already running on this machine.",
  "kopie.naMaszyneOpis": "Pull this backup from the store onto the machine's disk — it can be restored from there.",
  "kopie.odtworz": "Restore database",
  "kopie.odtworzOkno": "The file {plik} will be unpacked on the machine and loaded as a new database on its SQL Server.",
  "kopie.odtworzOpis": "Load this backup onto this machine's SQL Server as a NEW database",
  "kopie.odtworzPole": "Target database name",
  "kopie.odtworzTytul": "Restore a database from this backup?",
  "kopie.odtworzWarunek": "A database with this name must NOT exist yet — the agent deliberately cannot overwrite, because RESTORE onto an existing database is irreversible. If it exists, the task comes back failed and nothing happens.",
  "kopie.odtworzZlaNazwa": "The name must start with a letter or underscore and contain only letters, digits, \"_\", \"$\" and \"-\".",
  "kopie.odtworzZlecone": "Restore requested — the agent will pick it up on its next cycle",
  "kopie.plik": "File",
  "kopie.pobranieZlecone": "Download to the machine queued",
  "kopie.podtytul": "SPS database backups taken by the agent — order one, see what exists, download it.",
  "kopie.przerwano": "Task abandoned — buttons unblocked",
  "kopie.przerwij": "Abandon",
  "kopie.przerwijOpis": "Stop waiting for this task and unblock the buttons. It will not stop the agent, but its late result will be rejected.",
  "kopie.rozmiar": "Size",
  "kopie.spisSprzed": "This list predates the last operation — the machine sends it with its heartbeat, so a fresh one arrives on the next cycle (within a minute).",
  "kopie.stan": "State",
  "kopie.trwa.KOPIA_BAZY": "Backup to the store in progress — wait for it to finish",
  "kopie.trwa.KOPIA_LOKALNA": "Backup on the machine disk in progress — wait for it to finish",
  "kopie.trwa.KOPIA_ODTWORZ": "Database restore in progress — wait for it to finish",
  "kopie.trwa.KOPIA_POBIERZ": "Download to the machine in progress — wait for it to finish",
  "kopie.trwa.KOPIA_WYSLIJ": "Upload to the store in progress — wait for it to finish",
  "kopie.sprzatnij": "Clear entries without a file ({n})",
  "kopie.sprzatnijOpis": "Remove rows for backups whose file no longer exists. The screen hides them on its own after {d} days — this button does it now.",
  "kopie.sprzatnijPytanie": "Remove {n} entries for backups without a file?\n\nFiles are not affected — they are already gone. Who created and deleted each backup stays in the audit log.",
  "kopie.sprzatnieto": "Entries removed: {n}",
  "kopie.ukryte": "Hidden entries for backups whose file is gone: {n} (older than {d} days). Who deleted a backup and when — see the Logs tab.",
  "kopie.usun": "Delete",
  "kopie.usunLokalnaOpis": "File {plik} ({mb}) will be deleted from the customer machine disk.",
  "kopie.usunLokalnaSkutek": "If this backup is not in the store, after deletion it will exist nowhere. The agent performs it on its next cycle.",
  "kopie.usunLokalnaTytul": "Delete the backup from the machine disk?",
  "kopie.usunOpis": "The backup from {kiedy} disappears from storage for good — there is no bin and no second copy.",
  "kopie.usunTytul": "Delete the backup file?",
  "kopie.usunWpis": "The list entry stays, so it remains visible who took the backup and when. Only the file goes.",
  "kopie.usuniecieZlecone": "Deletion from the machine disk queued",
  "kopie.usunieta": "Backup deleted from storage",
  "kopie.utknelo": "This task has been sitting for {minut} min.",
  "kopie.utknelo.bezAgenta": "We do not know when the agent was last heard from. The portal releases the task by itself after 30 minutes of silence — the button next to this does it now.",
  "kopie.utknelo.cisza": "The agent was last heard from {minut} min ago. The portal releases the task by itself after 30 minutes of silence — the button next to this does it now.",
  "kopie.wPlanie": "Restoring lives with the backups held on the machine: a file from the store is pushed to the machine first, then restored under a new name. Still missing: the post-restore delta and Smart Sync settings.",
  "kopie.wgraj": "Upload a file from your computer",
  "kopie.wgrajOpis": "Send a backup (.bak or .zip) from your own disk straight to the store — bypassing the machine. From there it can be pushed to the machine and restored.",
  "kopie.wgrana": "File uploaded to the store as {plik}",
  "kopie.wgrywanie": "Uploading {plik}",
  "kopie.wgrywanieKoniec": "Bytes are through — waiting for the store to confirm.",
  "kopie.wolne": "{wolne} free of {calkowite}",
  "kopie.wyczysc": "Clear failed ({n})",
  "kopie.wyczyscOpis": "Remove entries left by failed tasks. None of them produced a file, and the record of who requested them stays in the audit log.",
  "kopie.wyczyszczono": "Failed entries removed: {n}",
  "kopie.wyslanieZlecone": "Upload to the store queued",
  "kopie.wyslijDoMagazynu": "Upload to store",
  "kopie.wyslijDoMagazynuOpis": "Send this file from the machine's disk to the instance store — you can download it to your computer from there.",
  "kopie.wyslijNie.juzTam": "This backup is already in the store (checksums match) — sending it again would change nothing.",
  "kopie.zKomputera": "uploaded from a computer",
  "kopie.zZadania": "from task",
  "kopie.zZadaniaOpis": "This package is on the machine because the portal downloaded it there — its name, size and checksum come from that task. The machine has not sent its inventory yet (the agent sends it with the heartbeat of a successful cycle), so the disk gauge and the rest of the folder stay unknown.",
  "kopie.zadnaDoPobrania": "None of these entries has a file in the store — only a finished backup gets the \"Download\" and \"To machine\" buttons. Make a new backup or upload a file from your computer.",
  "kopie.zmierzono": "Measured: {kiedy}",
  "poczek.tytul": "Waiting room",
  "poczek.ile": "packages: {ile}",
  "poczek.wgraj": "Upload backup to waiting room",
  "poczek.wgrajOpis": "This island has no machine yet — the package will wait in storage.",
  "poczek.wgrana": "Package {plik} is waiting in storage.",
  "poczek.brakAgentaAle": "You can already upload a backup — it will wait for the first machine.",
  "poczek.zKodu": "for island {wyspa}",
  "poczek.zKoduOpis": "Pinned to the registration code that will create this island.",
  "poczek.zPolki": "unpinned",
  "poczek.zPolkiOpis": "Uploaded without pinning it to an island or a code.",
  "poczek.przejmij": "Move to storage",
  "poczek.przejmijOpis": "The package becomes a backup of this island — from there you push it to a machine.",
  "poczek.przejeta": "Package {plik} is now in the island storage.",
  "poczek.brakWezla": "The island needs a database node first.",
  "poczek.brakWyspy": "No island yet — nothing can take a backup.",
  "poczek.usunOpis": "Delete from the waiting room together with the file",
  "poczek.usunTytul": "Delete the package from the waiting room?",
  "poczek.usunTresc": "The file will be removed from storage. We have no second copy.",
  "poczek.usunieta": "Package deleted from the waiting room.",
  "poczek.naZapas": "Backup upfront",
  "poczek.naZapasOpis": "Upload a database backup for the island this code will create.",
  "poczek.juzCzeka": "waiting: {ile}",
  "korekta.biezaca": "Set this price as the item's current one as well",
  "korekta.biezacaHint": "That is the root cause — without it the next issues run at the old price again and there will be another correction next month.",
  "korekta.brakTowarow": "No item matches that text.",
  "korekta.byloCeny": "Prices before the correction:",
  "korekta.cena": "New price (PLN)",
  "korekta.cenaBiezacaTeraz": "Item's current price:",
  "korekta.do": "To",
  "korekta.doZmiany": "To correct: {n} issues",
  "korekta.dodatkowe": "Additional (present in this island's data)",
  "korekta.eksport": "Export these issues",
  "korekta.eksportGotowy": "Downloaded {n} issues",
  "korekta.juzPoprawne": "skipping {n} already correct",
  "korekta.nicDoZmiany": "No issues to correct in this range — either they all already carry this price, or the range is empty.",
  "korekta.od": "From",
  "korekta.opis": "Fixes the price on one item's issues in the chosen period — where the machine held an outdated one. The change goes to the machine's database and is reflected in the portal right away.",
  "korekta.ostrzezenie": "SPS does not version the issue log: once applied, the previous prices cannot be restored other than by a second correction. Check the period and the amounts.",
  "korekta.podstawowe": "Main",
  "korekta.pokaz": "Show what will change",
  "korekta.przycisk": "Price change",
  "korekta.szukajTowaru": "Start typing a name or index…",
  "korekta.towar": "Item",
  "korekta.tytul": "Historical price correction",
  "korekta.wartosc": "Value in this period:",
  "korekta.wszystkieTypy": "All operation types",
  "korekta.zWiersza": "Correct this item's price in history",
  "korekta.zatwierdz": "Apply the correction",
  "korekta.zrobione": "Corrected {n} issues — the change is on its way to the machine",
  "login.email": "E-mail",
  "login.failed": "Sign-in failed",
  "login.modeDev": "DEV mode (no Keycloak)",
  "login.modeKeycloak": "Authentication: Keycloak",
  "login.password": "Password",
  "login.submit": "Sign in",
  "login.subtitle": "Vending management portal",
  "login.title": "Sign in",
  "logs.action": "Event (or its prefix)",
  "logs.actor": "Who",
  "logs.aktor.AGENT": "agent",
  "logs.aktor.API": "API integration",
  "logs.aktor.BEZ_KONTA": "account deleted or unknown",
  "logs.aktor.PANEL": "panel token",
  "logs.aktor.PORTAL": "portal, automatic",
  "logs.anyLevel": "any",
  "logs.anyOutcome": "any",
  "logs.count": "entries",
  "logs.denied": "DENIED",
  "logs.emptyAudit": "No audit entries for these filters.",
  "logs.emptyDiagnostic": "No diagnostic entries for these filters.",
  "logs.instanceWide": "whole instance",
  "logs.limitDays": "day limit",
  "logs.limitRows": "row limit",
  "logs.live.co": "What arrived",
  "logs.live.kiedy": "Time",
  "logs.live.opis": "What came in from Smart Sync — only what changed. Refreshes itself.",
  "logs.live.pusto": "Nothing changed. On a working island that is the normal state: an entry appears only when an agent’s batch brought something in.",
  "logs.live.wezel": "Node",
  "logs.live.wydan": "{n} withdrawals",
  "logs.live.wydanie": "{n} withdrawal",
  "logs.live.zachowane": "retained {n}",
  "logs.minLevel": "Level at least",
  "logs.noAccount": "no linked account",
  "logs.notRotated": "Never rotated — nothing deletes these entries automatically",
  "logs.onlyIsland": "selected island only",
  "logs.outcome": "Outcome",
  "logs.rotated": "Rotated — these entries will disappear over time",
  "logs.search": "Search in text",
  "logs.source": "Source",
  "logs.tabAudit": "Audit trail",
  "logs.tabDiagnostic": "Diagnostic log",
  "logs.tabLive": "Live",
  "logs.tabSpsLog": "SPS logs",
  "logs.tabTraffic": "Data usage",
  "logs.title": "Logs & statistics",
  "machines.add": "Add machine",
  "machines.addTitle": "New machine",
  "machines.agentVersion": "Agent version",
  "machines.bazaBrakPomiaru": "This agent does not report the database state — an older version. The badge only says that the island database physically sits here.",
  "machines.bazaNieaktualny": "The last measurement said the database answers, but this machine's agent is silent — so nobody is checking it now. This is the state from before it went quiet, not the current one.",
  "machines.bazaNieaktualnyBlad": "The last reading said the database was NOT responding, but this machine’s agent is silent, so nobody is checking it right now — this is the state from before it went quiet, not the current one.",
  "machines.bazaNieodpowiada": "THE ISLAND DATABASE DOES NOT ANSWER — the agent could not open it. While this lasts, synchronisation of the WHOLE island is stopped, not just this machine.",
  "machines.bazaOdpowiada": "The island database ANSWERS — the agent's last cycle read from it.",
  "machines.code": "Code",
  "machines.compartments": "Compartments",
  "machines.compartmentsFilled": "Compartments holding an item",
  "machines.compartmentsHint": "Compartments with an assigned item / all compartments of the machine. The denominator comes from the planogram.",
  "machines.createNotice": "The wizard queues two changes atomically: the machine row and PICAddressMode (MODETYPE=9) — without the latter the machine will not start. The agent picks the queue up within ~10 s; the state is shown under „Changes”.",
  "machines.created": "Machine created",
  "machines.drums": "Drums",
  "machines.drumsHint": "Portal metadata — the actual drum count comes from the planogram.",
  "machines.editNotice": "The change is sent as a patch (only modified columns) so the rest is preserved. The agent picks the queue up within ~10 s; the state is shown under „Changes”.",
  "machines.editTitle": "Edit machine",
  "machines.fill": "Fill level",
  "machines.hasDatabase": "ISLAND DATABASE",
  "machines.hasDatabaseHint": "This machine hosts the island database — switching it off stops synchronisation for the whole island",
  "machines.lastSeen": "Last contact",
  "machines.mode25": "25 — DynaBox",
  "machines.mode9": "9 — native drum (BiPoint)",
  "machines.modeType": "Drum addressing mode",
  "machines.modeTypeHint": "Determines the MACHINE TYPE. Compartment coordinates are computed differently per mode, so a wrong value makes the planogram point at a different physical cell than the one you click.",
  "machines.name": "Name",
  "machines.noPlanogram": "no planogram",
  "machines.onlyOnline": "Online only",
  "machines.pending": "queued",
  "machines.pendingHint": "There is an unapplied configuration change for this machine.",
  "machines.presence.NEVER_CONNECTED": "agent never connected",
  "machines.presence.NO_AGENT": "no agent",
  "machines.presence.ONLINE": "Online",
  "machines.presence.SILENT": "agent silent",
  "machines.presence.awaiting": "awaiting confirmation",
  "machines.presence.awaitingHint": "The agent heartbeats correctly, but the portal accepts neither configuration nor issues from it until you confirm the node on the Agents screen.",
  "machines.presence.contradiction": "CONTRADICTION",
  "machines.presence.contradictionHint": "The machine reports being connected while its agent is silent — one of these is out of date.",
  "machines.saved": "Change queued",
  "machines.spsui": "SPSUI",
  "machines.spsui.brakPomiaru": "This agent does not check the process — an older version, or a machine that does not run SPS. It does not mean the machine is down.",
  "machines.spsui.dolaczone": "A start was already queued — waiting for its result",
  "machines.spsui.dziala": "running",
  "machines.spsui.maint": "MAINT — database lost",
  "machines.spsui.maintByl": "Maint {n} min ago",
  "machines.spsui.maintHint": "The SPS repair tool is running. It starts when SPS loses its database connection, so it means \"this machine lost the database\" — worse than a stopped interface, because nobody starts it on purpose.",
  "machines.spsui.nieznany": "state unknown",
  "machines.spsui.nieznanyHint": "Last reading said: {stan}. This machine’s agent is silent, so nobody is checking SPSUI right now — this is the state from before it went quiet, not the current one.",
  "machines.spsui.stoi": "not running",
  "machines.spsui.stoiHint": "The machine's interface is not running — nobody standing at it will get anything. It is sometimes switched off on purpose (servicing, relocation), hence amber rather than red.",
  "machines.spsui.uruchom": "Start machine interface (SPSUI)",
  "machines.spsui.uruchomDziala": "SPSUI was running at the last report — click anyway if the machine screen is blank",
  "machines.spsui.uruchomOffline": "This machine's agent is offline — nobody can start the interface",
  "machines.spsui.zlecone": "Interface start queued — you'll see the result in the machine's task list",
  "machines.spsui.zmierzono": "checked:",
  "machines.status": "Connectivity",
  "machines.willGetVmid": "Will get VMID",
  "machines.zakladka.lista": "List",
  "machines.zakladka.ustawienia": "Settings",
  "mcard.brakAgenta": "There is no agent on this machine — the portal only knows what another node of the island brought.",
  "mcard.brakParametrow": "The portal has no parameters for this machine yet — they arrive with configuration sync.",
  "mcard.brakWydan": "No dispensations with a recognised item.",
  "mcard.czekaDociagniecie": "pull-down pending (foreign up to {n})",
  "mcard.dyskZajete": "Used {proc}%",
  "mcard.f.baza": "SPS database",
  "mcard.f.bebny": "Drums",
  "mcard.f.bladWpisu": "Write error",
  "mcard.f.czasMaszyny": "Machine time",
  "mcard.f.ipMaszyny": "Machine address",
  "mcard.f.ipPortalu": "Address seen by portal",
  "mcard.f.kod": "Machine code",
  "mcard.f.kolumny": "Columns (DynaBox)",
  "mcard.f.komputer": "Computer",
  "mcard.f.kontakt": "Last contact",
  "mcard.f.korekta": "Correction by agent",
  "mcard.f.kursor": "Sibling dispensation cursor",
  "mcard.f.meldunek": "Last report",
  "mcard.f.nazwa": "Name",
  "mcard.f.problem": "Problem",
  "mcard.f.przegrodki": "Compartments",
  "mcard.f.pytal": "Last asked for dispensations",
  "mcard.f.razem": "Total",
  "mcard.f.rodzenstwo": "Sibling dispensation broadcast",
  "mcard.f.rola": "Role",
  "mcard.f.rozjazd": "Offset from portal time",
  "mcard.f.serwer": "SQL server",
  "mcard.f.sqlWersja": "SQL Server",
  "mcard.f.stan": "State",
  "mcard.f.strefa": "Machine time zone",
  "mcard.f.system": "Operating system",
  "mcard.f.szuflady": "Drawers",
  "mcard.f.tryb": "Island mode",
  "mcard.f.uwagi": "Cycle warnings",
  "mcard.f.vmid": "VMID",
  "mcard.f.w32time": "Clock sync (W32Time)",
  "mcard.f.wersja": "Agent version",
  "mcard.f.wezel": "Node",
  "mcard.f.wolne": "Free space",
  "mcard.f.wpisanych": "Sibling rows written",
  "mcard.f.wyspa": "Island",
  "mcard.f.zadan": "Requests",
  "mcard.f.zmierzono": "Measured",
  "mcard.innaNizMaster": "different from island master ({baza})",
  "mcard.k.przegrodek": "Compartments",
  "mcard.k.towarow": "Items in machine",
  "mcard.k.wydan": "Dispensations from this machine",
  "mcard.korektaOd": "from {n} s",
  "mcard.korektaWyl": "(threshold {n} s — reporting only)",
  "mcard.nadaza": "up to date",
  "mcard.nieustalone": "not determined",
  "mcard.nieustawiony": "not set",
  "mcard.nigdy": "never",
  "mcard.oczekuje": "awaiting",
  "mcard.ostatnieWydanie": "Latest",
  "mcard.p.never": "never connected",
  "mcard.p.noAgent": "no agent",
  "mcard.p.online": "online",
  "mcard.p.silent": "silent",
  "mcard.portalZna": "(portal knows {n})",
  "mcard.potwierdzony": "confirmed",
  "mcard.przegrodkiHint": "Compartments the portal knows from configuration",
  "mcard.ruchBrak": "Machine without an agent — nothing to measure",
  "mcard.s.dyskZegar": "Disk and clock",
  "mcard.s.ruch": "Data usage",
  "mcard.s.setup": "SPS settings of this machine",
  "mcard.s.sprzet": "Machine and hardware",
  "mcard.s.sync": "Synchronisation state",
  "mcard.s.towary": "What people take from here",
  "mcard.s.wezel": "Node and system",
  "mcard.svc.auto": "automatic",
  "mcard.svc.disabled": "disabled",
  "mcard.svc.manual": "manual",
  "mcard.svc.running": "running",
  "mcard.svc.stopped": "stopped",
  "mcard.svc.unknown": "unknown whether it runs",
  "mcard.th.nadpisanie": "Override",
  "mcard.th.opis": "Description",
  "mcard.th.param": "Parameter",
  "mcard.th.sztuk": "Units",
  "mcard.th.towar": "Item",
  "mcard.th.wartosc": "Value",
  "mcard.th.wydan": "Dispensations",
  "mcard.trybZwykly": "standard",
  "mcard.w32timeOff": "The machine will not fix its clock itself — the skew will keep growing",
  "mcard.wDol": "down",
  "mcard.wGore": "up",
  "mcard.wlaczona": "enabled",
  "mcard.wlaczone": "enabled",
  "mcard.wrocDoListy": "I cannot see this machine on the selected island. If you switched islands, go back to the list and open the machine from there.",
  "mcard.wylaczoneNaWyspie": "disabled on this island",
  "mcard.wyspaOczekuje": "island expects {strefa}",
  "mcard.zakladka.moduly": "Modules",
  "mcard.zakladka.ogolne": "General",
  "mcard.zakladka.ustawienia": "Settings",
  "ust.tytul": "Machine settings",
  "ust.licznik": "{n} settings",
  "ust.szukaj": "Search name, description or value",
  "ust.wszystkieGrupy": "All groups",
  "ust.bezGrupy": "No group",
  "ust.tylkoRozne": "Only different from other machines",
  "ust.zapisBlokuje": "Saving needs agent {wersja} on every database of the island — older on: {wezly}",
  "ust.brak": "The portal has no settings for this machine yet — they arrive with agent {wersja}.",
  "ust.tak": "Yes",
  "ust.nie": "No",
  "ust.zmien": "Change",
  "ust.wszystkieAutomaty": "On all machines ({n})",
  "ust.naWszystkich": "always on all machines",
  "ust.wKolejce": "queued",
  "ust.inneNa": "different on: {lista}",
  "ust.zakolejkowano": "Queued {param} on {n} machines",
  "ust.calaWyspa": "Whole island",
  "ustW.licznik": "{n} settings on {automatow} machines",
  "ustW.tylkoRozne": "Only differing between machines",
  "ustW.ustawienie": "Setting",
  "ustW.brakParametru": "This machine does not have this parameter",
  "ustW.nowaWartosc": "New value",
  "ustW.naKtorych": "On which machines",
  "ustW.wszystkie": "all",
  "ustW.odstajace": "only outliers",
  "moduly.brak": "The portal does not know any drum of this machine yet — wait for the configuration sync.",
  "moduly.brakWcale": "{wezel}: none at all",
  "moduly.brakWcaleGrupa": "none at all — {wezly}",
  "moduly.brakujeGrupa": "{ile} missing — {wezly}",
  "moduly.brakujeIle": "{wezel}: {ile} missing",
  "moduly.czekaNa": "waiting for",
  "moduly.deklarowanych": "the build promises {n}",
  "moduly.dojezdza": "change still propagating",
  "moduly.domkniecie.nazwa": "Overwrite this machine in other databases",
  "moduly.domkniecie.pytanie": "Overwrite vending machine {nazwa} in the other machines’ databases?\n\nEach of them gets an exact copy of the record from the machine that serves this vending machine: missing rows are added, different ones corrected, and anything that is NOT there gets REMOVED — together with the stock counts of those rows.\n\nThe machine that serves this vending machine will not receive this operation: there, those rows are the truth. Other vending machines are not changed.\n\nThis cannot be undone. Continue?",
  "moduly.domkniecieDymek": "Every machine on the island keeps a record of this vending machine in its database: drums, drawers, compartments and the items in them. This button replaces it in the other machines’ databases with an exact copy from the machine that serves this vending machine. Other vending machines are not changed.\n\nAdds: yes · Changes: yes · Removes: yes, together with stock counts. Cannot be undone.",
  "moduly.innaTresc": "same row count, DIFFERENT CONTENT — only “Overwrite this machine in other databases” corrects it",
  "moduly.kolumn": "DynaBox columns",
  "moduly.kolumnRoto": "Columns",
  "moduly.mozeszWyrownac": "Some machines do not have this vending machine in their database AT ALL. The “Fill in this machine in other databases” button at the top of the screen will add the missing rows.",
  "moduly.nadmiar": "{wezel}: {ile} more than the owner — only “Overwrite this machine in other databases” removes them",
  "moduly.nieznanaKonstrukcja": "Unknown build",
  "moduly.odrzucone": "Refused by a node: {ile}",
  "moduly.odrzuconeWyjasnienie": "A refused operation does NOT return to the queue — nobody will retry it. Read the reason and decide whether to send it again or accept the state from the machine.",
  "moduly.pic": "Drum",
  "moduly.pokazLiczby": "show raw row counts",
  "moduly.pominieteBebny": "Skipped drums that do not fit in one transaction: {bebny}. Report this — such a drum must be sent drawer by drawer.",
  "moduly.pozaWyrownaniem": "not covered by alignment",
  "moduly.propagacjaWToku": "The island machines temporarily report different counts — normal while a change is still reaching them. If it lasts longer than {minut} min it will be reported as a divergence.",
  "moduly.przegrod": "Compartments",
  "moduly.rozjazd": "The configuration reports {konfiguracja} drums, the portal knows {portal}. The numbers below cover only the known ones.",
  "moduly.rozjazdWezlow": "The island machines disagree about this machine’s configuration. The numbers below describe what its own machine reports.",
  "moduly.swobodne": "Free issue",
  "moduly.szuflad": "Drawers",
  "moduly.typSzuflady": "Drawer type",
  "moduly.ukryjLiczby": "hide raw row counts",
  "moduly.wDrodze": "In flight: {ile} change(s) waiting for nodes",
  "moduly.wstrzymane": "Held until the agent updates",
  "moduly.wstrzymaneWyjasnienie": "Nothing to do — these operations will run on their own once the agent updates.",
  "moduly.wymagaWersji": "needs version {wersja}",
  "moduly.wyrownaj": "Fill in this machine in other databases",
  "moduly.wyrownajDymek": "Every machine on the island keeps a record of this vending machine in its database: drums, drawers, compartments and the items in them. This button adds to the other machines’ databases only what is missing there. Other vending machines are not changed.\n\nAdds: yes · Changes: no · Removes: no",
  "moduly.wyrownajPytanie": "Fill in vending machine {nazwa} in the other machines’ databases?\n\nThe portal will add the missing drums, drawers, compartments, channels and lids, plus the missing planogram entries — what actually sits in the compartments. Machines that already have these rows will skip the change — nothing gets overwritten.\n\nStock levels are NOT sent from the portal: a new entry gets zero, because stock belongs to the machine.\n\nThis does NOT reconcile rows that exist somewhere with different content — that is what “Overwrite this machine in other databases” is for.",
  "moduly.wyrownanieZlecone": "Top-up queued: {zmian} changes.",
  "moduly.wyrownanieZleconeBebny": "Queued: {operacji} operations (one per drum), {zmian} changes in total.",
  "moduly.zrodloDomysl": "{wezel} has the most rows — but the portal does not know which node serves this machine, so this is a guess, not a source.",
  "moduly.zrodloZmian": "This machine is served by {wezel} — changes come from there, because that is where its configuration is the truth.",
  "nagr.automat": "Machine",
  "nagr.bezPodgladu": "No preview",
  "nagr.brak": "No recordings in this period",
  "nagr.do": "To",
  "nagr.kolAutomat": "Machine",
  "nagr.kolDlugosc": "Length",
  "nagr.kolKiedy": "When",
  "nagr.kolOperacja": "Operation",
  "nagr.kolOsoba": "Person",
  "nagr.kolRozmiar": "Size",
  "nagr.kolStan": "Status",
  "nagr.kolTowary": "Items",
  "nagr.limit": "File limit (MB)",
  "nagr.od": "From",
  "nagr.odtworz": "Play",
  "nagr.okres": "Period (months)",
  "nagr.pobieraj": "Download",
  "nagr.pobierz": "Download",
  "nagr.pobierzOryginal": "Download original",
  "nagr.przygotowuje": "Preparing…",
  "nagr.rodzaj.doRegeneracji": "Taken for rework",
  "nagr.rodzaj.inne": "Other",
  "nagr.rodzaj.korekta": "Stock adjustment",
  "nagr.rodzaj.pobranie": "Withdrawal",
  "nagr.rodzaj.uzupelnienie": "Restock",
  "nagr.rodzaj.wrzut": "Drop for rework",
  "nagr.rodzaj.zRegeneracji": "From rework",
  "nagr.rodzaj.zlom": "Scrap",
  "nagr.rodzaj.zwrot": "Return",
  "nagr.sek": "{n} s",
  "nagr.stan.OCZEKUJE": "In transit",
  "nagr.stan.WYSLANE": "Stored",
  "nagr.stan.ZA_DUZE": "Too large",
  "nagr.ustawienia": "Settings",
  "nagr.wszystkie": "All",
  "nagr.usunPoDniach": "Delete from machine after (days)",
  "nagr.usunZMaszyny": "Delete from machine",
  "nagr.usunOstrzezenie": "Recordings {kody} will be deleted from the machine computer after {n} days — they cannot be restored",
  "nagr.katalogi": "Recordings folder on machines",
  "nagr.katalogBrak": "Agents have not measured the recordings folders yet",
  "nagr.katalog": "Folder",
  "nagr.plikow": "Files",
  "nagr.usunieto": "Deleted",
  "nagr.zmierzono": "Measured",
  "nagr.zapisano": "Recording settings saved",
  "hr.stan.podglad": "Preview only — nothing reaches the machines",
  "hr.sprawdzono": "Checked {kiedy}",
  "hr.polaczenie": "Connection",
  "hr.brakSejfu": "Instance without SESSION_SECRET — the key cannot be stored",
  "hr.kluczNieczytelny": "The stored key cannot be read — enter it again",
  "hr.adres": "HR+ address",
  "hr.serwis": "Service ID",
  "hr.serwisPodpowiedz": "UUID or HR+ feed URL",
  "hr.klucz": "Key",
  "hr.kluczJest": "Stored: {p}…",
  "hr.kolejnosc": "Name",
  "hr.kolejnosc.IMIE_NAZWISKO": "First Last",
  "hr.kolejnosc.NAZWISKO_IMIE": "Last First",
  "hr.zrodlo": "Card number from",
  "hr.zrodlo.employeeNo": "employee number (employeeNo)",
  "hr.zrodlo.atrybut": "custom field",
  "hr.zrodlo.inne": "other path",
  "hr.atrybut": "Custom field name",
  "hr.sciezka": "Field path",
  "hr.zapisz": "Save",
  "hr.zapisano": "Saved",
  "hr.sprawdz": "Test connection",
  "hr.wHr": "In HR+: {n}",
  "hr.polaDodatkowe": "Custom fields: {a}",
  "hr.brakPolDodatkowych": "No custom fields",
  "hr.przyklad": "Example: {nazwa} · card {numer}",
  "hr.przykladBezKarty": "Example: {nazwa} · no card number",
  "hr.podglad": "Preview",
  "hr.porownaj": "Fetch and compare",
  "hr.dopasowani": "Matched: {n}",
  "hr.bezZmian": "unchanged: {n}",
  "hr.kat.zmiany": "With changes",
  "hr.kat.nowi": "New",
  "hr.kat.przywroceni": "To restore",
  "hr.kat.bezAutomatu": "No machine",
  "hr.kat.bezKarty": "No card number",
  "hr.kat.zlyNumer": "Invalid card number",
  "hr.kat.zdublowani": "Same card in HR+",
  "hr.kat.tylkoUNas": "Only in Vendi",
  "hr.zmianyNazwy": "name: {n}",
  "hr.zmianyMpk": "cost centre: {n}",
  "hr.doOdblokowania": "unblock: {n}",
  "hr.doZablokowania": "block: {n}",
  "hr.noweMpk": "Cost centres not in the dictionary: {n}",
  "hr.dlugieNazwy": "Names cut to 50 characters: {n}",
  "hr.zaDlugieMpk": "Cost centres longer than 50 characters: {n}",
  "hr.zakladkaJest": "Vending tab: present",
  "hr.zakladkaBrak": "HR+ does not send the Vending tab — in the Vendi service (Data) untick all fields. Until then nobody is added",
  "hr.zmianyAliasu": "additional info: {n}",
  "hr.zmianyFlag": "flags: {n}",
  "hr.zmianyGrup": "groups: {n}",
  "hr.zmianyAutomatow": "machines: {n}",
  "hr.obceIdentyfikatory": "Group or machine from outside this island — list unchanged: {n}",
  "hr.zlyBlok": "Unreadable Vending tab — unchanged: {n}",
  "hr.bezBloku": "Without the Vending tab: {n}",
  "hr.kol.numer": "Card",
  "hr.kol.nazwa": "Name from HR+",
  "hr.kol.uwagi": "Changes / reason",
  "hr.pierwsze": "First {n} of {z}",
  "hr.stan.wlaczona": "On — HR+ manages this island's employees",
  "hr.wlaczonaOd": "since {kiedy}",
  "hr.nadpisze": "HR+ data (name, cost centre, block) overwrites manual changes — correct it in HR+.",
  "hr.wstrzymane": "Held: the batch would cut {n} people off the machines (limit {p})",
  "hr.wstrzymaneZ": "Held: the batch would cut {n} of {z} people off the machines ({pct}%)",
  "hr.powod.PUSTA_LISTA": "HR+ returned an empty employee list",
  "hr.powod.PROG": "Over the limit of {p} people",
  "hr.powod.PROCENT": "Over {pct}% of HR+ people",
  "hr.czekaOd": "waiting since {kiedy}",
  "hr.zgodaTytul": "Allow this batch?",
  "hr.kol.osoba": "Person",
  "hr.kol.jak": "Loses",
  "hr.jak.BLOKADA": "Block",
  "hr.jak.AUTOMATY": "All machines",
  "hr.wylaczonaPoZmianie": "Address or service changed — integration turned off",
  "hr.liczby": "From HR+: {z} ({zb} blocked) · Not in HR+: {s} ({sa} active, {w} exceptions, {sz} blocked by the switch)",
  "hr.eksport": "Export for HR+",
  "emp.hr.WYJATEK": "HR+ exception",
  "emp.hr.SPOZA_ZABLOKOWANA": "Not in HR+ · blocked",
  "emp.hr.filtrWyjatki": "Exceptions",
  "emp.hr.ustawWyjatek": "Do not block (outside HR+)",
  "emp.hr.zdejmijWyjatek": "Remove HR+ exception",
  "emp.hr.wyjatekUstawiony": "Exception set — this person outside HR+ will not be blocked",
  "emp.hr.wyjatekZdjety": "Exception removed",
  "hr.blokujSpoza": "Block people not in HR+",
  "hr.wyjatkiGrup": "Do not block members of groups:",
  "hr.spozaPodglad": "Not in HR+: to block {b} · exceptions {w} · to unblock {o}",
  "hr.jak.SPOZA": "Not in HR+",
  "hr.przepusc": "Allow",
  "hr.przepuszczono": "Allowed — sync in progress",
  "hr.ostatniPrzebieg": "Last run {kiedy}: {opis}",
  "hr.uzgodnienie": "Full reconciliation: {kiedy}",
  "hr.synchronizuj": "Sync now",
  "hr.zsynchronizowano": "Synced",
  "hr.wlacz": "Turn on integration",
  "hr.wlaczTytul": "Turn on the HR+ integration?",
  "hr.wlaczOpis": "HR+ will add, overwrite and block this island's employees. Manual changes to that data will be overwritten.",
  "hr.wlaczBezpiecznik": "A batch that would cut more than {p} people or over 20% of HR+ people off the machines (block or removal of all machines) will wait for approval. An empty list from HR+ always does.",
  "hr.wlaczono": "Turned on — first sync in progress",
  "hr.wylacz": "Turn off",
  "hr.wylaczono": "Turned off",
  "hr.progBlokad": "Safety limit: people cut off per batch",
  "hr.zakladajMpk": "Write new cost centres",
  "nav.accounts": "Accounts & API",
  "nav.agents": "Agents",
  "nav.alerts": "Alerts",
  "nav.assignments": "Machine access",
  "nav.authoring": "Database actions",
  "nav.backups": "Backups",
  "nav.changes": "Pending changes",
  "nav.costCenters": "Cost centres",
  "nav.dashboard": "Dashboard",
  "nav.employees": "Employees",
  "nav.groups": "Groups",
  "nav.itemGroups": "Item groups",
  "nav.items": "Items",
  "nav.machines": "Machines",
  "nav.limits": "Limits",
  "nav.permissions": "Limits",
  "nav.planogram": "Planogram",
  "nav.programy": "Software",
  "nav.recordings": "Recordings",
  "nav.hrplus": "HR+",
  "nav.reports": "Reporting",
  "nav.section.admin": "Administration",
  "nav.section.people": "People",
  "nav.section.stock": "Stock",
  "nav.service": "Logs & statistics",
  "nav.settings": "Instance settings",
  "nav.smartSync": "Smart Sync",
  "nav.transactions": "Transactions",
  "obraz.akcja": "Item photo",
  "obraz.brakWBibliotece": "the portal does not have this file",
  "obraz.dodajZKomputera": "Add from computer",
  "obraz.dodano": "Added {plik} to the portal ({kb} kB). It reaches the machines once assigned to an item.",
  "obraz.dodanoNadpisano": "Replaced {plik} in the portal ({kb} kB). Machines keep the old version until you send it again.",
  "obraz.galeriaBrakWynikow": "Nothing matches.",
  "obraz.galeriaObecny": "— current",
  "obraz.galeriaPusta": "The portal has no photos yet. Download them from a machine in “Manage photos” or upload from your computer.",
  "obraz.galeriaSzukaj": "Search by file name, e.g. P0496",
  "obraz.galeriaUzywa": "items: {n}",
  "obraz.galeriaGrup": "groups: {n}",
  "obraz.tytulGrupy": "Group image",
  "obraz.zaDlugaDlaGrupy": "File name for a group: at most {n} characters",
  "obraz.galeriaWiecej": "The list is cut — type more characters.",
  "obraz.galeriaWybrany": "This photo will go to every machine.",
  "obraz.indeks": "supplier no.",
  "obraz.indeksHint": "Search photos by this number",
  "obraz.nadpiszZgoda": "Replace",
  "obraz.nadpiszeNiezmierzone": "Not checked: {maszyny}.",
  "obraz.nadpiszeOstrzezenie": "File {plik} is already on these machines and will be replaced:",
  "obraz.nazwa": "File name",
  "obraz.nazwaHint": "Usually the supplier number, e.g. P04966198.jpg — letters, digits, dot, dash and underscore.",
  "obraz.nazwaPytanie": "Rename {z} → {na} in the portal only?\n\nItems with this photo keep the old name, and machines keep showing the old file.",
  "obraz.nazwaPytanieZPrzypisaniem": "Rename {z} → {na}?\n\nItems ({n}) get the new name and the file goes to every machine. The change applies once all confirm. The old file stays on the machines.",
  "obraz.nazwaZmieniona": "Renamed in the portal: {z} → {na}",
  "obraz.nazwaZmienionaZPrzypisaniem": "Renamed: {z} → {na}. The file is going to machines ({automatow}); items ({n}) change after confirmation.",
  "obraz.nowaNazwa": "New file name",
  "obraz.poprawionoNazwe": "Saved as {na} instead of {z}, because the file is {format}.",
  "obraz.postep": "On machines: {n} of {m}",
  "obraz.szczegolyBezBajtow": "The portal only knows this file name — not the photo itself.",
  "obraz.szczegolyNaAutomatach": "On machines:",
  "obraz.szczegolyNiezmierzone": "Not checked: {maszyny}.",
  "obraz.szczegolyNigdzie": "on none of the checked ones",
  "obraz.szczegolyPlik": "{kb} kB · source: {zrodlo} · changed {kiedy}",
  "obraz.szczegolyTowary": "Items ({n}):",
  "obraz.takzePrzypisane": "Change it in items too",
  "obraz.takzePrzypisaneOpis": "Items with this photo get the new file name and the file goes to the machines. Otherwise only the name in the portal changes.",
  "obraz.tytul": "Item photo",
  "obraz.usun": "Delete from portal",
  "obraz.usunGrupy": "Item groups lose their tile too ({n}).",
  "obraz.usunPytanie": "Delete {plik} from the portal?\n\nItems ({n}) use it — they lose the photo and machines show an empty spot. Files on the machines stay. This cannot be undone with one click.",
  "obraz.usunieto": "Deleted {plik}; items without photo: {n}",
  "obraz.syn.bezBajtow": "The portal does not have these files, so it will not send them ({n}): {pliki}",
  "obraz.syn.bezPomiaru": "Not checked: {maszyny}. Without it we do not know what they miss — check them or skip.",
  "obraz.syn.coRobi": "Puts missing files on the machines. It does not change the photos assigned to items — “another photo” stays.",
  "obraz.syn.nicDoWyslania": "Nothing to send",
  "obraz.syn.odznaczWszystko": "Clear all",
  "obraz.syn.opis": "Sends from the portal the files machines are missing.",
  "obraz.syn.pomijajBezPomiaru": "Skip unchecked",
  "obraz.syn.pominieteBezBajtow": "Skipped, the portal does not have them: {pliki}",
  "obraz.syn.podsumowanie": "files: {plikow}, transfers: {par}",
  "obraz.syn.przycisk": "Send missing to machines",
  "obraz.syn.tytul": "Sending missing photos",
  "obraz.syn.wiersz": "missing on ({maszyn}): {gdzie} · items: {towarow}",
  "obraz.syn.wszystkoZgodne": "Every file is on every checked machine.",
  "obraz.syn.wyslij": "Send",
  "obraz.syn.zaDuzoPar": "That is {par} transfers and at most {limit} go at once. Clear some files.",
  "obraz.syn.zaznaczWszystko": "Select all",
  "obraz.syn.zlecone": "Sending files: {plikow}, to machines: {automatow}",
  "obraz.wyslany": "Sending the photo to machines: {n}",
  "obraz.wyslij": "Send to machines",
  "obraz.zaDuzy": "The photo is too large — at most {n} MB.",
  "obraz.skad.najwiecej": "most photos",
  "obraz.skad.nieSprawdzano": "not checked",
  "obraz.skad.niezmierzone": "outside the last check: {n}",
  "obraz.skad.niktNieMierzony": "No machine has been checked — check them on the “On machines” tab.",
  "obraz.skad.pomiar": "photos: {ma}, missing: {brak} — checked {kiedy}",
  "obraz.skad.tytul": "Which machine to download from",
  "obraz.skad.wybranyBezSpisu": "This machine has not been checked.",
  "obraz.skad.wybranyPusty": "This machine has no photos — downloading will bring nothing.",
  "obraz.skad.zgraj": "Download from this machine",
  "obraz.zgraj": "Download from machine to portal",
  "obraz.zgrajOpis": "Downloads to the portal the photos assigned to items on the chosen machine.",
  "obraz.zgraneNicNowego": "The portal already has every photo from this machine ({n}).",
  "obraz.zgraneZlecone": "Downloading files: {plikow} ({wezel}).",
  "obraz.zmienNazwe": "Rename",
  "obraz.teraz": "Now on the machines",
  "obraz.brakZdjecia": "This item has no photo yet.",
  "obraz.brakObrazkaGrupy": "This group has no image yet.",
  "obraz.zPortalu": "Photos in the portal",
  "obraz.zKomputera": "From your computer",
  "obraz.upusc": "Drop a photo here or click to choose a file",
  "obraz.zapiszeJako": "Will be saved as",
  "obraz.zmienNazwePliku": "Rename",
  "obraz.wybierzInne": "Choose another photo",
  "obraz.gotowe": "Done — the photo is on every machine.",
  "obraz.zmieniSie": "The photo changes once it reaches every machine.",
  "obraz.ponow": "Retry",
  "obraz.ponowiono": "Retrying on machines: {n}",
  "obraz.stan.DONE": "done",
  "obraz.stan.QUEUED": "waiting in queue",
  "obraz.stan.OFFLINE": "waiting — machine silent since {kiedy}",
  "obraz.stan.W_TOKU": "in progress",
  "obraz.stan.FAILED": "failed",
  "obraz.lista.czeka": "Photo on its way — waiting for: {automaty}",
  "obraz.lista.blad": "Photo did not reach: {automaty} — open to retry",
  "obraz.lista.bladKrotko": "error",
  "ops.action": "System operations",
  "ops.card": "Card number",
  "ops.code.AML": "Assign machine to location",
  "ops.code.CC": "Cycle count",
  "ops.code.CPV": "Change privileges",
  "ops.code.CPW": "Change password",
  "ops.code.DBS": "RFID Insta-track",
  "ops.code.DD": "Item unassigned from drawer",
  "ops.code.FIW": "Free issue withdrawal",
  "ops.code.FPR": "Fingerprint scan",
  "ops.code.IA": "Inventory adjustment",
  "ops.code.IST": "Initiate stock transfer",
  "ops.code.LR": "Load repaired items",
  "ops.code.MOV": "Stock move",
  "ops.code.OML": "Open machine location",
  "ops.code.REG": "Replenish — general item",
  "ops.code.REN": "Replenish — new item",
  "ops.code.REU": "Replenish — used item",
  "ops.code.REX": "Save external request",
  "ops.code.RG": "Return to general",
  "ops.code.RK": "Return key",
  "ops.code.RN": "Return to new",
  "ops.code.RR": "Return to repair",
  "ops.code.RRG": "Return from repair to general",
  "ops.code.RRN": "Return from repair to new",
  "ops.code.RRS": "Return from repair to scrap",
  "ops.code.RRU": "Return from repair to used",
  "ops.code.RS": "Return to scrap",
  "ops.code.RS1": "Reserve tool",
  "ops.code.RS2": "Withdraw reserved tool",
  "ops.code.RSI": "Return serialized tool",
  "ops.code.RU": "Return to used",
  "ops.code.R_R": "Receive and replenish",
  "ops.code.SCL": "Weigh item",
  "ops.code.SCS": "RFID — static cabinet scan",
  "ops.code.STD": "Receive stock transfer",
  "ops.code.SU": "Cancelled by administrator",
  "ops.code.UU": "Cancelled by user",
  "ops.code.WEX": "Withdraw from external request",
  "ops.code.WG": "Withdraw — general item",
  "ops.code.WI": "Withdraw for inspection",
  "ops.code.WKT": "Withdraw kit",
  "ops.code.WN": "Withdraw — new item",
  "ops.code.WP": "Priority withdrawal",
  "ops.code.WR": "Rework pickup — from bin",
  "ops.code.WRD": "Rework pickup — from drawer",
  "ops.code.WS": "Scrap pickup — from bin",
  "ops.code.WSD": "Scrap pickup — from drawer",
  "ops.code.WU": "Withdraw — used item",
  "ops.extra": "Additional operations",
  "ops.extraCount": "· {n} of {total} selected",
  "ops.fromGroupsOutside": "This employee's groups also grant codes missing from this SPS installation's dictionary — they have no row in the list above:",
  "ops.noDictionary": "The portal has no code dictionary for this island yet — the agent has not delivered the Transactions table. Until then there is nothing to choose from.",
  "ops.outsideDictionary": "These codes are granted but absent from this installation's dictionary. They may have been added by hand in SPS, or the dictionary is polled less often. They can be revoked but not re-granted.",
  "ops.saved": "Allowed-operations change queued",
  "ops.selected": "granted: {n} of {total}",
  "ops.title": "Allowed system operations",
  "ops.unnamedHint": "We have not confirmed what this code means — SPS stores no descriptions, so the raw code is shown.",
  "ops.viaGroupCount": "{n} from groups",
  "ops.viaGroupHint": "This permission also comes from a group — unchecking it here will NOT remove access. Groups:",
  "overview.alertsOpen": "Open alerts",
  "overview.cdc": "CDC mode",
  "overview.cdcHint": "Which change-tracking mechanism the client database HAS: \"journal\" means the older triggers writing to SyncChangeTracking, \"native CT\" means MSSQL Change Tracking. This describes the database, NOT our synchronisation — the agent never reads this field and reads tables with its own cursor.",
  "overview.changesQueued": "Queued changes",
  "overview.client": "Client",
  "overview.clients": "clients",
  "overview.clockSkewTitle": "Clock drift on {n} of {outOf} machines (threshold {min} min).",
  "overview.clockSkewWhy": "Dispenses carry the machine clock time, so they land in the wrong billing period and rolling-window limits count from a shifted boundary. Nothing shows this at the machine itself.",
  "overview.confirmed": "confirmed",
  "overview.critical": "critical",
  "overview.employees": "Employees",
  "overview.groups": "Islands",
  "overview.health": "Status",
  "overview.healthAgents": "agents {odpowiada}/{wszystkich}",
  "overview.healthAllOk": "All islands ({ile}) are clear — agents are responding.",
  "overview.healthShowFailed": "Show {ile} failed operations",
  "overview.healthAttention": "needs attention",
  "overview.healthDown": "Not working: {ile} — {wyspy}",
  "overview.healthFail": "not working",
  "overview.healthOk": "all clear",
  "overview.healthWaiting": "awaiting confirmation: {ile}",
  "overview.healthWarn": "Needs attention: {ile} — {wyspy}",
  "overview.island": "Island",
  "overview.islands": "Sync islands",
  "overview.items": "Products",
  "overview.last7d": "in the last 7 days",
  "overview.lowStock": "Compartments running out",
  "overview.machines": "Machines",
  "overview.noAgent": "without agent",
  "overview.online": "online",
  "overview.selected": "selected",
  "overview.transactions": "Transactions",
  "perm.nolimitPotwierdz": "Remove the limit",
  "perm.nolimitPytanie": "Remove the {limit} limit on „{zakres}\" for „{kto}\"?\n\nAccess STAYS — after this change the target draws this item without any quantity cap.\n\nThe old limit cannot be restored with one click: it has to be set again. The previous settings stay in the limit history.",
  "picker.more": "Load more",
  "planogram.addsMachineItem": "The item is not on this machine yet — it will be added to VendingMachineItems with zeroed limits, the way SPS does it.",
  "planogram.assignDone": "Queued a change for {n} compartments",
  "planogram.assignSelected": "Set selected",
  "planogram.clearHint": "Removes the item from the selected compartments. Stock is lost together with the row.",
  "planogram.clearItem": "Clear item selection",
  "planogram.clearSelected": "Empty",
  "planogram.column": "Column",
  "planogram.columnExport": "Column (SPS DRAWERNUMBER)",
  "planogram.columnRules": "Column {n} rules:",
  "planogram.columnsShort": "columns:",
  "planogram.compartment": "Compartment",
  "planogram.compartments": "Compartments used",
  "planogram.confirmAssign": "Set the item in the selected compartments?",
  "planogram.confirmAssignDesc": "“{item}” will go into {n} compartments of this machine.",
  "planogram.confirmClear": "Empty the selected compartments?",
  "planogram.confirmClearDesc": "The item will disappear from {n} compartments of this machine.",
  "planogram.confirmSend": "Send the change",
  "planogram.confirmStockLoss": "{n} pieces of stock will be lost. The item number is part of the SPS key, so a swap means deleting the row and inserting a new one — exactly what SPS does, and it warns about it the same way.",
  "planogram.d3.labels": "Labels",
  "planogram.d3.reset": "Centre the drum",
  "planogram.d3.restock": "needs restocking",
  "planogram.d3.rotate": "Drum rotation",
  "planogram.d3.threshold": "SPS threshold:",
  "planogram.d3v2.awaria": "The 3D view could not start",
  "planogram.d3v2.awariaOpis": "The rest of the screen works normally — switch to the grid or the older drum view. The error text below helps when reporting this.",
  "planogram.d3v2.brakWebgl": "This browser does not provide 3D graphics (WebGL)",
  "planogram.d3v2.brakWebgl.krok1": "Settings → General → Performance: uncheck \"Use recommended performance settings\" and check \"Use hardware acceleration when available\".",
  "planogram.d3v2.brakWebgl.krok2": "Open about:support and find the Graphics section — it states plainly whether WebGL is blocked and why (usually the graphics driver version).",
  "planogram.d3v2.brakWebgl.krok3": "Restart the browser. If it still fails, the reason from about:support is enough to report it.",
  "planogram.d3v2.brakWebglOpis": "This is a browser or graphics-driver setting, not a portal fault — the rest of the screen works normally, and the drum is available in the older view or on the grid. In Firefox this usually helps:",
  "planogram.d3v2.ladowanie": "Loading the 3D view…",
  "planogram.d3v2.przejdzDoStarego": "Show the older drum view",
  "planogram.d3v2.sterowanie": "left button = rotate drum · right = orbit camera · wheel = zoom · click = select compartment",
  "planogram.deselect": "Deselect",
  "planogram.detailsTitle": "Compartment details",
  "planogram.dispense": "Disp.",
  "planogram.dispenseHint": "How many pieces one withdrawal takes (SPS QTYDISP). An item packed in fives and taken whole has 5 here, not 1.",
  "planogram.drawer": "Drawer",
  "planogram.drawers": "Drawers",
  "planogram.drum": "Drum {n}",
  "planogram.drumExport": "Drum (PICNUMBER)",
  "planogram.drumExtension": "extension cabinet",
  "planogram.drumMain": "machine cabinet",
  "planogram.editSection": "Change in {n} compartments",
  "planogram.effectEmptyNow": "Compartments empty today",
  "planogram.effectReplaced": "Item swap (DELETE + INSERT)",
  "planogram.effectSameItem": "Already hold this item (limits only)",
  "planogram.emptySlot": "empty compartment",
  "planogram.enforceHint": "SPS “enforce full empty” rule: a withdrawal takes the whole maximum quantity, not a single piece.",
  "planogram.enforceHintDrum": "SPS “enforce full empty” rule. NOTE: on this construction (DynaBox) it lives in a single Drawers row for the whole drum, so the change will cover ALL columns of that drum, not just the selected one.",
  "planogram.enforceLabel": "Dispense the whole contents",
  "planogram.enforceOff": "Disable dispense-all",
  "planogram.enforceOn": "Enable dispense-all",
  "planogram.enforceScopeDrum": "dispense-all applies to the whole drum",
  "planogram.fill": "Fill level",
  "planogram.findClear": "Clear highlight",
  "planogram.findHits": "highlighted: {n}",
  "planogram.findItem": "Find an item…",
  "planogram.grid": "Grid (columns × rows)",
  "planogram.group": "Group",
  "planogram.isolateHint": "Click to highlight only this group",
  "planogram.item": "Product",
  "planogram.itemNumber": "Item number",
  "planogram.itemsNarrow": "type part of the name to see the rest",
  "planogram.itemsShown": "showing {n} of {total}",
  "planogram.keepCurrent": "unchanged",
  "planogram.lastColumnAssumed": "Last column: its width cannot be derived because nothing follows it. Assumed one slot.",
  "planogram.legendGroups": "The three largest groups get their own colour, the rest stay neutral — more hues in a grid stop being distinguishable. Click any group to highlight it alone.",
  "planogram.low": "Running out",
  "planogram.lowWithThreshold": "Running out (≤{pct}% full)",
  "planogram.machine": "Machine",
  "planogram.mapa": "Map",
  "planogram.mapaBezGrupy": "no group",
  "planogram.mapaBrakWiersza": "no row",
  "planogram.mapaLegenda": "Legend — the number in a compartment matches the number here",
  "planogram.mapaLegendaPusta": "This drum has no assigned item at all.",
  "planogram.mapaPoGrupie": "Colour by item group",
  "planogram.mapaPoGrupieOpis": "a few colours instead of dozens — shows the kind of goods",
  "planogram.mapaPoTowarze": "Colour by item",
  "planogram.mapaPoTowarzeOpis": "every item its own colour — shows where one item sits",
  "planogram.mapaSzt": "pcs",
  "planogram.mapaTytul": "Cabinet map as PDF — one page per drum",
  "planogram.mapaWLegendzie": "compartments: {n} · max {m} pcs",
  "planogram.mapaWygenerowano": "Generated: {data} · items: {t} · occupied compartments: {p}",
  "planogram.max": "Max",
  "planogram.maxHint": "Compartment capacity. Empty = keep what is there; an empty compartment needs a value.",
  "planogram.mode.groups": "Groups",
  "planogram.mode.stock": "Fill level",
  "planogram.moduleOnlyOne": "This machine has only one module",
  "planogram.modulePick": "Module:",
  "planogram.needsMachinesPermission": "This screen needs the machine list and your account lacks the „Machines” permission. Ask an administrator to add it — without it you cannot pick a machine.",
  "planogram.noCompartment": "this column has no such row",
  "planogram.noItemsFound": "Nothing matches",
  "planogram.noMachines": "This island has no machine yet, so there is nothing to show.",
  "planogram.orientationNotice": "Columns are drum dividers (36 by default), rows are drawers (13). A column widened by a divider takes 2 or 3 slots and the numbering skips accordingly — after column 1 ×2 the next one is 3. Mind the names: SPS calls a column a \"drawer\" (DRAWERNUMBER) and a row a \"compartment\" (COMPARTMENTNUMBER), i.e. the opposite of the physical layout.",
  "planogram.other": "Other",
  "planogram.qty": "Stock",
  "planogram.queuedNotice": "The change goes into the queue and reaches the machine at the next sync. The planogram shows it right away.",
  "planogram.row": "Row",
  "planogram.rowExport": "Row (SPS COMPARTMENTNUMBER)",
  "planogram.rulesDone": "Column rule change queued.",
  "planogram.rulesDoneDrum": "Rule change queued — dispense-all covered the whole drum.",
  "planogram.sameAsMax": "= Max",
  "planogram.searchItem": "Search for an item...",
  "planogram.selectColumnHint": "Click the column number to select or deselect the whole column",
  "planogram.selectWholeColumns": "Select whole columns",
  "planogram.selectedBreakdown": "{withItem} with an item, {empty} empty",
  "planogram.selectedCount": "Selected: {n} compartments",
  "planogram.slots": "Drum slots",
  "planogram.slotsAtMost": "slots: at most {n}",
  "planogram.slotsExact": "slots: {n}",
  "planogram.slotsTotal": "Slots across drums (total)",
  "planogram.spsCoords": "SPS coordinates",
  "planogram.stock": "Stock",
  "planogram.stock.low": "critically low (≤25%)",
  "planogram.stock.mid": "low (≤50%)",
  "planogram.stock.ok": "healthy (>50%)",
  "planogram.stock.out": "out of stock (0)",
  "planogram.stockLost": "stock lost: {n} pcs",
  "planogram.stockNotice": "Stock (QTYCURRENT) belongs to the machine and the portal does not set it — we show it, but items and limits can be changed. Swapping an item wipes the compartment's stock, because the item number is part of the SPS key.",
  "planogram.suspiciousColumns": "Columns {list} skip more than 3 slots. That is more likely a missing row in the client database than a widening — we draw them three slots wide, but the number in the header is the real one.",
  "planogram.tooManySelected": "The selection exceeds {limit} compartments — one operation cannot cover that many. Deselect some and send it in a few rounds.",
  "planogram.uniformColumnHint": "This column has the uniform-content rule: in SPS all its compartments hold the same item, and deleting one deletes them all.",
  "planogram.uniformDropped": "The “one item per column” rule will be REMOVED from columns {list}. Otherwise this change would wipe their whole contents — with that rule SPS deletes all 13 compartments when one disappears. The rule can be switched back on with one click.",
  "planogram.uniformLabel": "One item across the whole column",
  "planogram.uniformOff": "Disable one item per column",
  "planogram.uniformOn": "Enable one item per column",
  "planogram.uniformPartialWarning": "Columns {list} have the “one item per column” rule and the selection covers only part of them. The rule will be REMOVED from them — otherwise SPS would wipe the whole column on this change, because deleting one compartment there deletes all 13. The selected compartments get the new item; the rest of the column stays as it is.",
  "planogram.uniformToggleHint": "SPS “uniform content” rule: the whole column holds the same item. With the rule on, deleting one compartment deletes all 13. It cannot be enabled on a column holding different items — SPS refuses that too.",
  "planogram.uniformUnknown": "this column's rule is not known yet — the agent has not sent column settings",
  "planogram.view.beben": "3D drum",
  "planogram.view.beben3dv2": "3D_V2",
  "planogram.view.siatka": "Grid",
  "planogram.wide": "Column widened by a divider — takes {n} drum slots",
  "podgladM.czekamy": "We asked the agent for this file — the image arrives in its cycle (up to a few minutes).",
  "podgladM.nieudane": "The agent did not return the file and gave no reason.",
  "podgladM.opis": "{maszyna} — file „{plik}\" read straight from that machine’s image directory.",
  "podgladM.ponow": "Ask again",
  "podgladM.stopka": "{plik} · {wezel} · {kb} kB · the image is not stored here, it expires after fifteen minutes",
  "podgladM.tytul": "What is on the machine",
  "podgladM.wygasl": "The image has expired — we keep it for fifteen minutes because it is a file from the customer’s disk. Ask for it again.",
  "potw.nieodwracalne": "This operation cannot be undone.",
  "profile.access": "Item access",
  "profile.accessNone": "No access entries cover this person. Whether that blocks dispensing depends on the machine settings (REST_ENABLED / REST_DENY) - the Permissions screen shows them.",
  "profile.accessUnknown": "Another {n} entries carry a mask we do not recognise - they might have covered this person, so we do not skip them silently. Details in Permissions.",
  "profile.allTransactions": "All transactions",
  "profile.back": "Employees",
  "profile.blockedWarn": "Account blocked (ALLOWLOGIN = 0). This person will not log in to any machine, regardless of the limits and assignments below.",
  "profile.data": "Employee data",
  "profile.dateRange": "Account valid between {od} and {do}. Outside that range the machine will not let this person in.",
  "profile.direct": "direct",
  "profile.flagsNone": "none",
  "profile.flagsOn": "Flags enabled",
  "profile.fromAll": "entry for all employees",
  "profile.fromGroup": "via group {name}",
  "profile.fromPerson": "entry for this person",
  "profile.groupMembers": "{n} people",
  "profile.groups": "Employee groups",
  "profile.history": "Recent operations",
  "profile.historyLast": "(last {n})",
  "profile.historyNone": "This person has no issues in the log at all.",
  "profile.kpi.issues": "Issues ({d} days)",
  "profile.kpi.last": "Last issue",
  "profile.kpi.limits": "Limit rules",
  "profile.kpi.limitsHint": "In brackets: how many rules leave this person nothing to take.",
  "profile.kpi.machines": "Machines",
  "profile.kpi.units": "Units",
  "profile.kpi.value": "Value",
  "profile.limitEditPersonal": "Personal limit — change it in Limits, in this person's section.",
  "profile.limitFromGroupEdit": "Group limit — change it in Permissions; it affects the whole group.",
  "profile.limitEmpty": "used up",
  "profile.limitFromIssues": "from {n} issues",
  "profile.limitLeft": "{n} left",
  "profile.limitOver": "exceeded",
  "profile.limitPerWindow": "pcs in a {okno} window",
  "profile.limitUnenforced": "The machine (SPSUI) only enforces minute, hour, day and week windows. This rule exists in the database but nobody enforces it.",
  "profile.limits": "Dispensing limits",
  "profile.limitsNone": "No rationing rule covers this person - neither directly nor through their groups. The machine does not cap their quantities.",
  "profile.limitsOutOfScope": "This island also has {n} rules targeting a job or a machine - they cannot be attributed to a person, but may still apply at dispense time.",
  "profile.machines": "Machine access",
  "profile.narrowed": "narrowed",
  "profile.narrowedHint": "This entry is additionally narrowed by columns: {cols}. It therefore applies more narrowly than shown here - it can only be changed in SPSUtilities.",
  "profile.noAccess": "no access",
  "profile.noLimit": "no limit",
  "profile.noMachineWarn": "This person has access to NO machine - neither directly nor through a group. They cannot dispense anything anywhere.",
  "profile.notFound": "Employee not found",
  "profile.notFoundHint": "This card belongs to a different island, or the employee was removed. Check the island selected in the top right corner.",
  "profile.open": "Open employee card",
  "profile.opsNone": "This person has no system operation granted - neither their own nor from a group.",
  "profile.orphanIssues": "Another {n} issues carrying this card number have no employee resolved in the portal (they reached the log before the catalogue knew this card). They are not counted above, nor towards limits.",
  "profile.pending": "change queued",
  "profile.rationOffWarn": "RATIONEFFECT = {n}: the machine does NOT enforce this person's limits. The rules below exist in the database, but nobody enforces them at the machine.",
  "profile.scopeAll": "all items",
  "profile.scopeGroup": "item group",
  "profile.scopeItem": "item",
  "profile.scopeSubGroup": "item subgroup",
  "profile.viaGroup": "via group",
  "profile.withLimit": "with limit",
  "ptok.colCreated": "Issued",
  "ptok.colLabel": "Description",
  "ptok.colLastUsed": "Last used",
  "ptok.colScopes": "Scope",
  "ptok.colStatus": "State",
  "ptok.colUses": "Uses",
  "ptok.copied": "Token copied to clipboard",
  "ptok.copy": "Copy",
  "ptok.copyFailed": "Copy failed — write the token down from the screen",
  "ptok.create": "Issue token",
  "ptok.empty": "No token issued yet — no external system can reach this instance's API.",
  "ptok.hide": "Hide",
  "ptok.label": "Description",
  "ptok.labelHint": "e.g. Vending+ — production",
  "ptok.noScope": "no scope",
  "ptok.noScopeHint": "A token without a scope reaches no route. Revoke it and issue a new one with a scope.",
  "ptok.onceWarning": "You see this token ONCE. It cannot be recovered — the server stores only a hash. A lost token is revoked and reissued.",
  "ptok.revoke": "Revoke",
  "ptok.revokePytanie": "Revoke token “{label}” ({prefiks}…)?\n\nRevocation is IMMEDIATE and cannot be undone — the integration using this token gets a 401 on its next call and comes back only with a new token on its side.\n\nUses so far: {uzyc}.",
  "ptok.revokeHint": "Revocation takes effect immediately and cannot be undone. The row stays so the trace that the token existed is not lost.",
  "ptok.revoked": "Token revoked",
  "ptok.scopeEdit": "Scope",
  "ptok.scopeEditHint": "Change this token’s permissions without issuing a new one — the secret stays the same",
  "ptok.scopeEditTitle": "Token permissions",
  "ptok.scopeEditWhat": "The change is immediate and does not touch the secret — the other side needs to paste or refresh nothing. Removing a permission is immediate too: the next request in that scope gets a 403.",
  "ptok.scopeEmpty": "A token with no permissions passes authentication and bounces off every route — it looks healthy and does nothing. To switch it off use “Revoke”.",
  "ptok.scopeSaved": "Token scope changed — in force from the next request.",
  "ptok.scopesHint": "The scope decides what this token can read AND WRITE in the customer database. Grant only what the integration actually needs — revoking a token does not undo what it already did.",
  "ptok.status.AKTYWNY": "active",
  "ptok.status.NIEUZYWANY": "never used",
  "ptok.status.ODWOLANY": "revoked",
  "ptok.status.WYGASL": "expired",
  "ptok.title": "Machine tokens (API access)",
  "ptok.usageHint": "The integration sends it in the X-Api-Token header to /api/v1/... on this instance, plus X-Acting-User on writes. First call: GET /api/v1/self — returns the token scope and island identifiers.",
  "ptok.vp.confirmDo": "Issue and revoke previous",
  "ptok.vp.confirmKills": "These stop working (the integration gets 401 on its next request):",
  "ptok.vp.confirmNone": "There is no working token right now — nothing will be revoked.",
  "ptok.vp.confirmTitle": "Issue a new Vending+ token?",
  "ptok.vp.confirmUses": "· used {ile}×",
  "ptok.vp.confirmWhat": "You get the new token once, on screen. The previous ones stop working immediately.",
  "ptok.vp.issue": "Issue Vending+ token",
  "ptok.vp.title": "Vending+ token",
  "ptok.sb.title": "SmartBox token",
  "ptok.sb.issue": "Issue SmartBox token",
  "ptok.sb.confirmDo": "Issue and revoke previous",
  "ptok.sb.confirmKills": "These stop working (the integration gets 401 on its next request):",
  "ptok.sb.confirmNone": "There is no working token right now — nothing will be revoked.",
  "ptok.sb.confirmTitle": "Issue a new SmartBox token?",
  "ptok.sb.confirmUses": "· used {ile}×",
  "ptok.sb.confirmWhat": "You get the new token once, on screen. The previous ones stop working immediately. The Vending+ key is left untouched.",
  "ptok.hr.title": "HR+ token",
  "ptok.hr.issue": "Issue HR+ token",
  "ptok.hr.label": "Name",
  "ptok.hr.labelHint": "e.g. HR+ personnel",
  "ptok.hr.labelShort": "Name: at least 3 characters.",
  "ptok.hr.island": "Island",
  "ptok.hr.confirmDo": "Issue and revoke previous",
  "ptok.hr.confirmKills": "This stops working (the integration gets 401 on its next request):",
  "ptok.hr.confirmNone": "This island has no working HR+ token — nothing will be revoked.",
  "ptok.hr.confirmTitle": "Issue a new HR+ token?",
  "ptok.hr.confirmUses": "· used {ile}×",
  "ptok.hr.confirmWhat": "Works only on the selected island. You get the token once, on screen. The previous HR+ token of this island stops working immediately.",
  "ptok.island": "Island: {nazwa}",
  "ptok.islandGone": "island deleted",
  "ptok.islandGoneHint": "The island of this token was deleted — the token does not work. Revoke it.",
  "ptok.vp.zabite": "Previous tokens revoked: {lista}. If the integration still uses them, it stays down until the new one is pasted in.",
  "rap.agentProblem": "The agent reports a problem — data may be stale.",
  "rap.allEmployees": "All employees",
  "rap.allGroups": "All groups",
  "rap.allMachines": "All machines",
  "rap.col.capacity": "Max capacity",
  "rap.col.card": "Card number",
  "rap.col.code": "Code",
  "rap.col.employee": "Employee",
  "rap.col.item": "Item",
  "rap.col.itemNumber": "Item number",
  "rap.col.machine": "Machine",
  "rap.col.missing": "To refill",
  "rap.col.places": "Places (drawer/compartment)",
  "rap.col.qty": "Qty",
  "rap.col.stock": "In stock",
  "rap.col.supplierPart": "Supplier part number",
  "rap.col.value": "Value",
  "rap.col.when": "When",
  "rap.employee": "Employee",
  "rap.employeeNone": "No matching employees",
  "rap.employeePickHint": "Pick a person from the list — typed text only narrows the list; the report would still cover everyone",
  "rap.empty": "Nothing to show.",
  "rap.emptyIssues": "No dispenses in this period for the selected filters.",
  "rap.exportTooBig": "The report has {total} rows and {format} takes {limit} — narrow the period or filters. We do not silently truncate the file.",
  "rap.fresh": "Data from agent \"{node}\", last signal {minut} min ago.",
  "rap.from": "From",
  "rap.generate": "Generate report",
  "rap.godzinaDo": "End time — empty means to end of day",
  "rap.godzinaOd": "Start time — empty means from midnight",
  "rap.group": "Employee group",
  "rap.harmonogramy": "Schedules",
  "rsps.przycisk": "Reports in SPS",
  "rsps.tytul": "Reports in SPS",
  "rsps.tylkoWlaczone": "Enabled only",
  "rsps.brakWlaczonych": "No report has an enabled Task Scheduler task.",
  "rsps.skonfigurowanyNa": "Configured on",
  "rsps.innaWersja": "This machine has a different configuration of this report than shown",
  "rsps.zrodlo": "Configuration from {maszyna}, reported {kiedy}",
  "rsps.brak": "No agent has reported SPS reports yet. Agent 0.7.226 or newer is needed; it reads once an hour.",
  "rsps.bezRaportu": "Scheduler tasks without a configured report",
  "rsps.zbiorczy": "aggregate",
  "rsps.tylkoSumy": "subtotals only",
  "rsps.dataWNazwie": "date in file name",
  "rsps.topN": "top {n} by {pole}",
  "rsps.naglowek": "Header",
  "rsps.kolumny": "Columns",
  "rsps.grupuj": "group by",
  "rsps.suma": "subtotal",
  "rsps.warunki": "Conditions",
  "rsps.brakWarunkow": "none",
  "rsps.od": "from",
  "rsps.do": "to",
  "rsps.wysylka": "Delivery",
  "rsps.brakWysylki": "no transmission template",
  "rsps.szablonNieznany": "template missing in SPS",
  "rsps.dw": "CC:",
  "rsps.harmonogram": "Windows Task Scheduler",
  "rsps.brakZadan": "no task runs this report",
  "rsps.maszyna": "Machine",
  "rsps.zadanie": "Task",
  "rsps.kiedy": "When",
  "rsps.parametry": "Parameters",
  "rsps.ostatnio": "Last run",
  "rsps.nastepne": "Next run",
  "rsps.wlaczone": "enabled",
  "rsps.wylaczone": "disabled",
  "rsps.konto": "account",
  "rsps.ok": "OK",
  "rsps.o": "at",
  "rsps.codziennie": "daily",
  "rsps.coDni": "every {n} days",
  "rsps.coTydzien": "weekly",
  "rsps.coTygodni": "every {n} weeks",
  "rsps.coMiesiacDnia": "monthly, on day {dni}",
  "rsps.coMiesiacTygodnia": "monthly, week {tygodnie}: {dni}",
  "rsps.jednorazowo": "once",
  "rsps.przyLogowaniu": "at logon",
  "rsps.przyStarcie": "at startup",
  "rsps.powtarzaj": "repeat every",
  "rsps.makro.today": "today",
  "rsps.makro.yesterday": "yesterday",
  "rsps.makro.tomorrow": "tomorrow",
  "rsps.makro.startoflastmonth": "start of last month",
  "rsps.makro.endoflastmonth": "end of last month",
  "rsps.makro.startofthismonth": "start of this month",
  "rsps.makro.startofmonth": "start of month",
  "rsps.makro.endofmonth": "end of month",
  "rsps.makro.startofthisweek": "start of this week",
  "rsps.makro.startoflastweek": "start of last week",
  "rsps.makro.endoflastweek": "end of last week",
  "rsps.makro.startofweek": "start of week",
  "rsps.makro.endofweek": "end of week",
  "rsps.makro.lastrun": "last run",
  "rsps.makro.daybeforelastrun": "day before last run",
  "rsps.makro.weekagoyesterday": "week ago yesterday",
  "rsps.makro.weekagotoday": "week ago today",
  "rsps.makro.monthagotoday": "month ago today",
  "rsps.makro.monthagoyesterday": "month ago yesterday",
  "rsps.dzien.Monday": "Mon",
  "rsps.dzien.Tuesday": "Tue",
  "rsps.dzien.Wednesday": "Wed",
  "rsps.dzien.Thursday": "Thu",
  "rsps.dzien.Friday": "Fri",
  "rsps.dzien.Saturday": "Sat",
  "rsps.dzien.Sunday": "Sun",
  "rsps.miesiac.January": "Jan",
  "rsps.miesiac.February": "Feb",
  "rsps.miesiac.March": "Mar",
  "rsps.miesiac.April": "Apr",
  "rsps.miesiac.May": "May",
  "rsps.miesiac.June": "Jun",
  "rsps.miesiac.July": "Jul",
  "rsps.miesiac.August": "Aug",
  "rsps.miesiac.September": "Sep",
  "rsps.miesiac.October": "Oct",
  "rsps.miesiac.November": "Nov",
  "rsps.miesiac.December": "Dec",
  "rap.issuesSummary": "Rows: {ile} · {szt} pcs dispensed for {wartosc}",
  "rap.kind": "Report type",
  "rap.kind.issues": "Dispenses",
  "rap.kind.issuesHint": "Who took what in a given period, with filters and a machine column.",
  "rap.kind.stock": "Restocking",
  "rap.kind.stockHint": "What to bring: the gap to full. Warehouse total plus each machine separately.",
  "rap.machine": "Machine",
  "rap.machineHint": "To bring: {brakuje} pcs, items at zero: {zero}.",
  "rap.noAgent": "This island has no database agent, so stock levels have no way to refresh.",
  "rap.noEmployee": "unresolved",
  "rap.noItem": "unresolved",
  "rap.notGenerated": "Set the parameters and click \"Generate report\".",
  "rap.outsideRange": "Outside the selected period, the newest matching dispense is from {kiedy}.",
  "rap.skipped": "Skipped compartments with no capacity and no stock",
  "rap.subtitle": "What to bring: gap to full, per machine and combined.",
  "rap.summaryHint": "Total across all machines on the island — this is the warehouse list.",
  "rap.summaryTitle": "To bring — combined",
  "rap.szybkiZakres": "Quick:",
  "rap.title": "Machine stock",
  "rap.to": "To",
  "rap.zakres.dzis": "Today",
  "rap.zakres.miesiac": "This month",
  "rap.zakres.poprzedniMiesiac": "Last month",
  "rap.zakres.tydzien": "This week",
  "rap.zakres.wczoraj": "Yesterday",
  "rapw.domyslne": "restore defaults",
  "rapw.dostepne": "Available to add",
  "rapw.gotowe": "Report ready — {n} rows",
  "rapw.nizej": "Move down",
  "rapw.opis": "The file is built by the server — exactly as it will go out by e-mail from the schedule. Filters come from this screen.",
  "rapw.poza": "not a default",
  "rapw.przycisk": "Custom columns",
  "rapw.pusto": "No column selected — the file would have nothing in it.",
  "rapw.tytul": "Report with chosen columns",
  "rapw.usun": "Remove from file",
  "rapw.wszystkieWybrane": "Every column is already in the file.",
  "rapw.wybrane": "In the file, in this order",
  "rapw.wyzej": "Move up",
  "role.ADMIN": "Administrator",
  "role.USER": "User",
  "rozj.bezNazwy": "machine unknown to the portal",
  "rozj.brakWcale": "not a single row on: {wezly}",
  "rozj.brakuje": "{ile} missing on: {wezly}",
  "rozj.dojezdza": "on the way, not a divergence yet",
  "rozj.dojezdzaInfo": "{n} entries are still “on the way” — refresh in a few minutes before repairing anything.",
  "rozj.dosli": "Send missing ({n})",
  "rozj.dosliNic": "Nothing to send.",
  "rozj.tylkoWKopiach": "{n} only in other databases' copies — not sent",
  "rozj.zajete": "{n} in compartments holding another item — not sent",
  "rozj.dosliOpis": "Queues the missing rows to the other nodes. Deletes nothing — extras stay.",
  "rozj.dosliWynik": "Queued {n} — they arrive on the next agent cycle.",
  "rozj.grupaBezSkrotu": "no digest (older agent): {wezly}",
  "rozj.grupaTresci": "{skrot}: {wezly}",
  "rozj.grupaWlasciciela": " — owner",
  "rozj.grupyTresci": "who has which content",
  "rozj.innaTresc": "same row count, DIFFERENT CONTENT",
  "rozj.innyUklad": "— same values in different compartments",
  "rozj.kolumnyNieznane": "— which column, we will know next cycle (agent 0.7.165+)",
  "rozj.kolumnyRozne": "— differs in: {kolumny}",
  "rozj.nadmiar": "{ile} rows MORE on {wezel} — alignment will not remove them",
  "rozj.podtytul": "{tabel} tables across {automatow} machines.",
  "rozj.pokaz": "show the divergence",
  "rozj.pozaWyrownaniem": "outside alignment",
  "rozj.tenBrakuje": "{ile} missing",
  "rozj.tenMaPelny": "full picture",
  "rozj.tytul": "What exactly diverges",
  "rozj.wlasciciel": "owner: {wezel}",
  "rozj.wlascicielNieznany": "owner unknown — the source is guessed from row counts",
  "rozj.wszystkieAutomaty": "Overwrite all machines in other databases ({n})",
  "rozj.wszystkieLiczby": "all the numbers",
  "rozj.wszystkieOdmowy": "No changes: {lista}",
  "rozj.wszystkiePytanie": "Overwrite {n} vending machines in the other machines’ databases?\n\nFor each one the portal takes the record from the machine that serves it and replaces the record in the other machines’ databases: adds missing rows, corrects different content and removes extras — together with the stock counts of those rows. The operations enter the queue.",
  "rozj.wszystkieWynik": "Queued for {ok} of {razem} machines ({zmian} changes)",
  "rozj.wyrownanieNiePomoze": "Fixed by “Overwrite this machine in other databases” on the machine card — adds missing rows, corrects different content and removes extras.",
  "rozj.wyrownaniePomoze": "Fixed by “Fill in this machine in other databases” on the machine card.",
  "rozj.zrodlo": "full picture: {wezel} ({wierszy} rows)",
  "ss.k7.nieBlokuje": "does not block",
  "rozj.zapiszPlik": "Save file",
  "rozj.tylkoPozaWyrownaniem": "No alignment button touches this divergence — the button under the database read sends the missing rows. New machine-side changes now propagate on their own; extras on a single node stay.",
  "rozj.odpytaj": "Query the databases",
  "rozj.odpytajCzekam": "waiting for nodes",
  "poczekalnia.tytul": "Node waiting room",
  "poczekalnia.poCo": "A node silent for more than {prog} min stops blocking the queue — the rest of the fleet no longer waits for a machine that is not there. You can also set one aside right away when you know it is going for service.",
  "poczekalnia.zaleglosciZostaja": "Setting a node aside takes away neither its permissions nor its backlog — it will receive them on return.",
  "poczekalnia.licznik": "{ile} set aside",
  "poczekalnia.brakWezlow": "This island has no confirmed nodes yet.",
  "poczekalnia.czeka": "queue waits",
  "poczekalnia.powod.CISZA": "silent",
  "poczekalnia.powod.RECZNIE": "set aside manually",
  "poczekalnia.powod.NIGDY_NIE_ODPOWIEDZIAL": "never reported in",
  "poczekalnia.powod.NADRABIA": "catching up",
  "poczekalnia.cisza": "silent {min} min",
  "poczekalnia.nigdy": "no contact",
  "poczekalnia.zalega": "{ile} operations pending",
  "poczekalnia.odloz": "Set aside",
  "poczekalnia.przywroc": "Restore",
  "poczekalnia.odlozony": "Node set aside — the queue no longer waits for it",
  "poczekalnia.przywrocony": "Node restored to the queue",
  "pelnyOdczyt.tytul": "Refresh the portal from databases",
  "pelnyOdczyt.poCo": "Asks the nodes to send tracked tables in full instead of only changed rows. Useful when the portal rejected reports, or someone edited the databases bypassing the portal.",
  "pelnyOdczyt.niePisze": "Nothing is written to the machines — this only asks them to read.",
  "pelnyOdczyt.przycisk": "Request full re-read",
  "pelnyOdczyt.potwierdz": "Yes, request it",
  "pelnyOdczyt.anuluj": "Cancel",
  "pelnyOdczyt.zlecony": "Requested {tabel} table(s) from {wezlow} node(s) — they will arrive with the next reports.",
  "pelnyOdczyt.przerwij": "Stop full read",
  "pelnyOdczyt.przerwijPotwierdz": "Stop",
  "pelnyOdczyt.przerwanieCena": "The portal will record \"delivered\" although the read did not finish — it may be missing columns. Request it again once the island is healthy.",
  "pelnyOdczyt.przerwany": "Stopped the read of {tabel} tables on {wezlow} nodes — agents will no longer read them in full.",
  "pelnyOdczyt.wszystkie": "All",
  "pelnyOdczyt.wszystkieTabele": "all tables",
  "pelnyOdczyt.calaWyspa": "Whole island",
  "pelnyOdczyt.wezel": "Node",
  "pelnyOdczyt.zakres": "Scope: {tabele} · {wezel}",
  "pelnyOdczyt.nieUdaloSie": "Could not request the full re-read",
  "rozj.zaStareWezly": "Not asked: {wezly} — agent older than {wersja}.",
  "pulpit.action": "Live desktop",
  "pulpit.offline": "The agent is silent — the desktop cannot come through",
  "pulpit.agentMowi": "The agent reported",
  "pulpit.agentRobi": "Agent",
  "pulpit.zadanieStan": "Task",
  "pulpit.zablokowane": "The browser blocked the new window — allow pop-ups for this site.",
  "pulpit.zlyAdres": "The desktop window address is incomplete — open it from the machine list.",
  "pulpit.tytul": "Machine desktop",
  "pulpit.podtytul": "View and control through the agent",
  "pulpit.plikiNieTedy": "Files do not go through the desktop",
  "pulpit.wysylkaWToku": "Wait — an upload is already running",
  "pulpit.naMaszynie": "is on the machine",
  "pulpit.skroty": "Shortcuts",
  "pulpit.skrot.sps": "SPS",
  "pulpit.skrot.spsui": "SPSUI",
  "pulpit.skrot.utilities": "Utilities",
  "pulpit.skrot.raporty": "Reports",
  "pulpit.skrot.pliki": "Files",
  "pulpit.skrot.zadania": "Tasks",
  "pulpit.skrot.uruchom": "Run",
  "pulpit.ctrlAltDel": "Ctrl+Alt+Del",
  "pulpit.ctrlAltDelWyslane": "Ctrl+Alt+Del sent",
  "pulpit.blokada": "Lock input",
  "pulpit.konserwacja": "Maintenance",
  "pulpit.schowek": "Clipboard",
  "pulpit.schowekNaEkran": "Copied on the machine",
  "pulpit.schowekPodpowiedz": "Paste here — it goes to the machine",
  "pulpit.restart": "Restart",
  "pulpit.wylacz": "Shut down",
  "pulpit.system": "System",
  "pulpit.napewnoRestart": "Restart the machine?",
  "pulpit.napewnoWylacz": "Shut the machine down?",
  "pulpit.tak": "Yes",
  "pulpit.nie": "No",
  "pulpit.klikniPonownie": "Click again",
  "pulpit.wylaczOstrzezenie": "The machine will not come back on its own — you cannot power it on remotely. Make sure you know how to start it on site.",
  "pulpit.pelnyEkran": "Full screen",
  "pulpit.pelnyEkranOdmowa": "The browser refused full screen.",
  "pulpit.zlecone": "Sent to the agent.",
  "pulpit.otwieram": "Opening the session…",
  "pulpit.czekamNaAgenta": "Waiting for the agent to start the desktop and open the tunnel…",
  "pulpit.sterujesz": "You are clicking and typing on the machine, just like standing at it.",
  "pulpit.obszar": "Machine desktop image",
  "pulpit.zamkniete": "Session closed.",
  "pulpit.zerwane": "Connection lost.",
  "pulpit.odmowa": "The machine refused the connection.",
  "pulpit.nieUdaloSie": "Could not open the desktop session.",
  "rozj.odpytajOpis": "A fresh SELECT on every node with a database — shows which rows are missing and which differ.",
  "rozj.odczytCzeka": "Requested — nodes answer in their own cycle.",
  "rozj.odczytZgodne": "Rows match across all databases ({n} keys).",
  "rozj.portalWierszy": "portal: {n}",
  "rozj.portalBrak": "portal is missing {n}",
  "rozj.portalNadmiar": "portal has {n} extra",
  "rozj.portalBrakPrzyklady": "missing in portal:",
  "rozj.portalNadmiarPrzyklady": "portal only:",
  "rozj.portalNieUmie": "the portal cannot rebuild this table key — nodes compared only",
  "rozj.portalNiepewne": "The read was truncated, so \"extra in portal\" may be spurious.",
  "rozj.odczytBrak": "missing on: {nieMaja}",
  "rozj.odczytBlad": "read failed",
  "rozj.odczytWiecej": "List truncated — the file has all of it.",
  "ruch.all": "all",
  "ruch.avgTime": "Avg time",
  "ruch.avgTimeWhat": "successful responses",
  "ruch.chartTitle": "Traffic · last 48 h (hourly)",
  "ruch.colAvg": "Avg time",
  "ruch.colCalls": "Calls",
  "ruch.colDuration": "Duration",
  "ruch.colEndpoint": "Endpoint",
  "ruch.colIp": "IP",
  "ruch.colLast": "Last seen",
  "ruch.colLastStatus": "Last status",
  "ruch.colRequest": "Request",
  "ruch.colResult": "Result",
  "ruch.colTime": "Time",
  "ruch.colToken": "Token",
  "ruch.empty": "No requests in this range.",
  "ruch.endpoints": "Endpoints in use ({n}) · last 7 days",
  "ruch.err24h": "Errors / 24 h",
  "ruch.errShare": "{p}% of calls",
  "ruch.errors": "failed",
  "ruch.filterIp": "IP",
  "ruch.filterMethod": "Method",
  "ruch.filterStatus": "Status",
  "ruch.next": "Next",
  "ruch.noToken": "no token",
  "ruch.now": "now",
  "ruch.ok": "successful",
  "ruch.pageOf": "Showing {od}–{do} of {total}",
  "ruch.perDay": "≈ {n}/day",
  "ruch.perHour": "≈ {n}/h",
  "ruch.perToken": "Average per token",
  "ruch.prev": "Previous",
  "ruch.req24h": "Requests / 24 h",
  "ruch.req7d": "Requests / 7 days",
  "ruch.title": "API traffic",
  "ruch.tokensActive": "{n} token(s) calling",
  "screenshot.action": "Machine screenshot",
  "screenshot.expired": "The image has expired. Request a new screenshot.",
  "screenshot.failed": "The screenshot could not be taken.",
  "screenshot.offline": "This machine’s agent is not responding — there is no screenshot to take",
  "screenshot.ordering": "Requesting a screenshot from the agent…",
  "screenshot.save": "Save to disk",
  "screenshot.timeout": "The agent did not return a screenshot. Check whether it still reports in and try again.",
  "screenshot.title": "Screenshot",
  "screenshot.waiting": "Waiting for the agent — the screenshot will arrive in the next cycle.",
  "set.api.tytul": "Integrations (API)",
  "set.api.usunieci": "Show people deleted from machines",
  "set.api.usunieciHint": "Off: the integration does not see them and gets them as deleted.",
  "set.brandingTitle": "Logo and name",
  "set.logoHint": "PNG, JPEG or WebP, up to 512 kB. SVG is not accepted because it can carry a script that runs on the login screen.",
  "set.name": "Instance name",
  "set.nameHint": "Empty field = product name.",
  "set.noLogo": "no logo",
  "set.readFailed": "Could not read the file",
  "set.removeLogo": "Remove logo",
  "set.saveName": "Save name",
  "set.saved": "Saved",
  "set.subtitle": "How this instance looks — logo and name shown in the portal and on the login screen.",
  "set.title": "Instance settings",
  "set.tooBig": "File is too large:",
  "set.upload": "Upload logo",
  "sledz.automatStoi": "THE MACHINE IS NOT DISPENSING — the interface (SPSUI) did not come back up. Start it with „Start SPSUI” or by hand on the machine.",
  "sledz.brakPomiaru": "The agent has not measured this yet (it measures hourly) or is older than this probe.",
  "sledz.cdcCoTo": "CDC (Change Data Capture) is MSSQL’s second, heavier mechanism: a log reader plus SQL Agent jobs writing changes into tables in the „cdc\" schema. We have not yet seen it enabled on any machine, which is why there is no button here.",
  "sledz.cdcWlaczony": "CDC on",
  "sledz.cdcWylaczony": "CDC off",
  "sledz.ctSzczegoly": "CT retention: {retencja} {jednostka}, auto-cleanup {cleanup}.",
  "sledz.ctWlaczony": "Change Tracking on",
  "sledz.ctWylaczony": "Change Tracking off",
  "sledz.gdzie": "Tracked tables: {objete} of {wszystkie}; {nasze} of them are tables the portal reads anyway.",
  "sledz.jednoNaraz": "Something is already being disabled on this node — these two commands cannot run at once.",
  "sledz.kolMechanizm": "Mechanism",
  "sledz.kolRozmiar": "Size",
  "sledz.kolTabela": "Table",
  "sledz.kolWierszy": "Rows",
  "sledz.kolWpisow": "Entries",
  "sledz.myNieUzywamy": "The portal does not use these mechanisms — the agent computes the diff locally.",
  "sledz.nicNieSledzi": "Neither Change Tracking nor CDC is enabled here.",
  "sledz.nieZmierzono": "not measured",
  "sledz.pokazTabele": "Show tables ({n})",
  "sledz.przerwij": "Abort and start SPS",
  "sledz.przerwijGdyTrwa": "disabling in progress — the machine may not be dispensing",
  "sledz.przerwijOpis": "Closes outstanding disable tasks and queues a start of the machine interface. Works even when the portal sees nothing in flight.",
  "sledz.rozmiar": "Takes {ile}",
  "sledz.rozmiarNieznany": "Size: not measured",
  "sledz.spsCzyste": "SPS SyncChangeTracking: empty",
  "sledz.spsJest": "SPS SyncChangeTracking: {wierszy} entries",
  "sledz.spsNicDoRoboty": "nothing to disable",
  "sledz.spsNieMa": "SPS SyncChangeTracking: absent",
  "sledz.spsNieMierzone": "SPS SyncChangeTracking: not measured",
  "sledz.spsOdbierane": "Entries are consumed: {relacji} relationships, {przetworzonych} processed.",
  "sledz.spsOpis": "SupplyPoint replication: {triggery} active triggers write to SyncChangeTracking.",
  "sledz.spsPiszacyTytul": "Who writes (from the last {probka} entries)",
  "sledz.spsProgramy": "Channel programs: {obecnych} of {wszystkich} in {katalog}.",
  "sledz.spsSieroty": "Channel programs removed but triggers left — writes still cost, the result goes nowhere.",
  "sledz.spsTabeleTytul": "SupplyPoint replication tables",
  "sledz.spsTempo": "Growing by ~{naDobe} entries a day, oldest from {najstarszy}.",
  "sledz.spsToNieCt": "This is SPS's own mechanism, not MSSQL Change Tracking.",
  "sledz.spsWProznie": "Nobody consumes these entries: 0 replication relationships and 0 processed.",
  "sledz.tabeleTytul": "Tables covered by change tracking",
  "sledz.triggerWylaczony": "disabled",
  "sledz.triggery": "Triggers: {czynne} active of {wszystkie}",
  "sledz.triggeryInne": "Other triggers: {ile}",
  "sledz.triggeryTytul": "Triggers on tables",
  "sledz.tytul": "Change tracking in the database",
  "sledz.wylacz": "Disable SPS replication",
  "sledz.wylaczCt": "Disable Change Tracking",
  "sledz.wylaczCtPotwierdz": "Disable Change Tracking",
  "sledz.wylaczCtTresc": "The agent will remove Change Tracking from every covered table, then from the database. The machine keeps working throughout — this is a metadata change, not a rebuild.\n\nNode: {wezel}. Covered tables: {tabel}.\n\nWARNING: if anything other than us reads CHANGETABLE on this database, it will stop working and leave no trace. The portal does not use Change Tracking — the agent computes diffs locally.",
  "sledz.wylaczCtTytul": "Disable native Change Tracking?",
  "sledz.wylaczCtZlecone": "Change Tracking disable queued",
  "sledz.wylaczPotwierdz": "Disable and clear",
  "sledz.wylaczTresc": "The agent will stop the machine interface (SPSUI), run spsdbupdate.exe -removereplication, clear the mechanism tables, remove the channel programs and start the interface again.\n\nThe machine will not dispense while this runs. Node: {wezel}. To remove: {wierszy} entries and {triggery} triggers.",
  "sledz.wylaczTytul": "Disable SupplyPoint replication?",
  "sledz.wylaczZlecone": "Disabling queued — progress shows in the machine tasks",
  "sledz.wynikBlad": "failed",
  "sledz.wynikCtLiczby": "Covered tables: {tPrzed} → {tPo}. On the database: {bPrzed} → {bPo}.",
  "sledz.wynikCtNarzedziem": "Disabled with SPS's own tool — our account cannot change structure on this machine.",
  "sledz.wynikCtTytul": "Last CT disable:",
  "sledz.wynikDelete": "Cleanup used batched DELETE, not TRUNCATE — the agent account was not granted the right on this machine.",
  "sledz.wynikGotowe": "done",
  "sledz.wynikLiczby": "Triggers: {tPrzed} → {tPo}. Entries: {wPrzed} → {wPo}.",
  "sledz.wynikPelne": "Mechanism fully disabled: triggers dropped, tables empty, channel programs removed.",
  "sledz.wynikPrzerwane": "interrupted",
  "sledz.wynikPrzerwaneAleZrobione": "The task was interrupted, but the current measurement says the mechanism is already disabled — nothing to do here.",
  "sledz.wynikTytul": "Last disable:",
  "sledz.zmierzono": "measured: {kiedy}",
  "spsLog.alarm": "Alert",
  "spsLog.allFiles": "all files",
  "spsLog.day": "day",
  "spsLog.days": "days",
  "spsLog.empty": "Nothing changed in the monitored files — and that is good news. An empty list means “SPS did not crash and nobody enabled debugging”, not “monitoring is broken”.",
  "spsLog.file": "File",
  "spsLog.fileTime": "file from",
  "spsLog.footnote": "Changes are detected by the agent in its cycle, so the detection time can be later than the file time. Files and the scope of collected data are configured in Island settings.",
  "spsLog.hideContent": "hide content",
  "spsLog.kind.OBCIETY": "truncated or replaced",
  "spsLog.kind.POJAWIL_SIE": "file appeared",
  "spsLog.kind.UROSL": "new entries",
  "spsLog.kind.ZNIKL": "file disappeared",
  "spsLog.node": "Node",
  "spsLog.pickIsland": "Pick an island to see SPS log changes.",
  "spsLog.retention": "Entries are kept for {dni} days. “Content” means the agent sends the appended lines — that content then leaves the customer machine and lands in the instance database, so enable it where it genuinely helps.",
  "spsLog.settingsTitle": "Monitored SPS log files",
  "spsLog.showContent": "show content",
  "spsLog.size": "Size",
  "spsLog.tail": "Content",
  "spsLog.truncated": "[…] content truncated — this is the tail of the append, not all of it.",
  "spsLog.watch": "Watch",
  "spsLog.what": "What happened",
  "spsLog.when": "Detected",
  "spscfg.action": "Database and machine number",
  "spscfg.baza": "SPS database (SQLServerDB)",
  "spscfg.inFlight": "This machine already has an SPSConfig.XML write queued — wait for its result.",
  "spscfg.offline": "This machine agent is not online, so there is nobody to perform the write.",
  "spscfg.queued": "Write queued ({n} change(s)) — the state is on the machine task list.",
  "spscfg.reported": "The values below are the agent last report ({kiedy}), not a live read of the file. In the portal this machine has number {vmid}.",
  "spscfg.restartBody": "The agent closes SPSUI, backs the file up next to the original, writes, reads it back and starts the interface in the logged-in user session. The machine does not dispense during that time. If the file already holds these values, nothing happens — there is no restart.",
  "spscfg.restartTitle": "Saving WILL STOP the machine interface",
  "spscfg.save": "Save and restart the interface",
  "spscfg.serwer": "SQL server (SQLServerName)",
  "spscfg.title": "Database and machine number (SPSConfig.XML)",
  "spscfg.vmid": "Machine number (VMID)",
  "spscfg.vmidAck": "I understand the dispensing history stays under the old number, and I want to change it.",
  "spscfg.vmidWarnTitle": "⚠️ Changing the machine number — decision pending",
  "spscfgview.action": "Show whole file",
  "spscfgview.expired": "The content has expired — open the preview again",
  "spscfgview.failed": "Could not read the file",
  "spscfgview.masked": "Masked on the machine, never sent to the portal: {pola}",
  "spscfgview.ordering": "Requesting the file…",
  "spscfgview.readonly": "Read-only — the preview touches neither the file nor the machine UI",
  "spscfgview.timeout": "The agent did not return the file within three minutes",
  "spscfgview.title": "SPSConfig.XML",
  "spscfgview.waiting": "Waiting for the agent to read the file…",
  "ss.bezBazy": "no local database (subordinate machine)",
  "ss.brakWyspy": "Pick an island above — the wizard walks through one island's deployment.",
  "ss.cofnij": "undo",
  "ss.czekaNaPotwierdzenie": "awaiting approval",
  "ss.dociaganie": "Catching up on backlogged issue history on {wezly} nodes. New issues keep flowing — limits count from current ones.",
  "ss.k1.p1": "A database fit to be the master — complete and verified. It becomes the starting point for the whole island.",
  "ss.k1.p2": "Machine numbers (VMID) agreed and DIFFERENT on every machine. Two identical numbers mix up two machines' withdrawals and that cannot be untangled.",
  "ss.k1.p3": "The same SupplyPoint version on all machines. Different versions have different columns and the configuration does not carry over in full.",
  "ss.k1.poCo": "Work done at the machines before anyone runs the installer. The portal cannot measure it — there is nobody to hear it from yet.",
  "ss.k1.potwierdz": "I confirm the preparation",
  "ss.k1.title": "Prepare the machines and the database",
  "ss.k2.doAgentow": "Issue a code and download the installer",
  "ss.k2.komplet": "That is all the machines",
  "ss.k2.poCo": "One enrollment code for the whole deployment. ⚠️ THE MODE IS CHOSEN WHEN THE CODE IS ISSUED — that is the moment that settles it. The first use of the code creates the island already in that mode, every later one joins a machine to the same island.",
  "ss.k2.title": "Install the agents",
  "ss.k3.juzWTrybie": "The island was created in this mode (chosen on the enrollment code) or has been switched to it — nothing to do here.",
  "ss.k3.poCo": "This card usually just SHOWS THE RESULT of step 2: the mode enters the island at its creation, together with the first registration. The button appears only on an island created with an older code, before the mode could be chosen.",
  "ss.k3.przelacz": "Switch to Smart Sync",
  "ss.k3.pytanie": "Switch the island to Smart Sync?\n\nMachines that are ALREADY registered will not notice: the right to synchronise is decided at registration and is never recomputed. If one of them registered in standard mode with its own database name, it will have to be reinstalled.\n\nCreate new islands in Smart Sync mode from the start — the choice is on the enrollment code.",
  "ss.k3.title": "Island mode",
  "ss.k4.czekaNaPotwierdzenie": "Node {wezel} has enrolled and is waiting for confirmation — until then the portal accepts only its heartbeat.",
  "ss.k4.poCo": "The token the MSSQL sidecar uses to reach the portal. Send it to BillVis along with the master database name — the sidecar reports in by itself.",
  "ss.k4.potwierdz": "Confirm node",
  "ss.k4.potwierdzony": "Node confirmed",
  "ss.k4.title": "Key for the cloud master",
  "ss.k5.brakChmury": "No cloud node in sight (step 4) — without it there is nowhere to send the package.",
  "ss.k5.brakKopii": "Storage is empty — upload a package from your computer or make a backup on the Backups screen.",
  "ss.k5.brakWezla": "This island has no confirmed node yet — there is nothing to attribute the package to in storage.",
  "ss.k5.doKopii": "Go to backups",
  "ss.k5.lub": "or",
  "ss.k5.naChmure": "Send to the cloud node",
  "ss.k5.poCo": "A backup of one machine goes to storage and from there onto the disk the cloud MSSQL can see.",
  "ss.k5.title": "Database to the cloud",
  "ss.k5.wMagazynie": "Packages ready in storage",
  "ss.k5.wgrano": "Uploaded „{plik}\" ({mb} MB) to storage",
  "ss.k5.wiecejPaczek": "{n} more in storage — see the full list on the Backups screen.",
  "ss.k5.wysylka": "Uploading „{plik}\" — {procent}%",
  "ss.k5.zPliku": "Upload a backup from a file",
  "ss.k5.zPlikuHint": "The usual route for Smart Sync: a .bak or .zip package from your computer. It lands in the instance storage, and from there you send it to the cloud node with the button on the list below.",
  "ss.k5.zrodloMaszyna": "backup from {wezel}",
  "ss.k5.zrodloPlik": "uploaded from a computer",
  "ss.k6.brakPaczki": "There is no package on the cloud node yet — do step 5.",
  "ss.k6.nazwa": "Target database name",
  "ss.k6.nazwaInna": "This name differs from the island's master database. Restoring under a different name will not set the master and would require changing SPS_DB at BillVis.",
  "ss.k6.nazwaWhat": "Type it exactly: {baza}. This is the same name BillVis has in SPS_DB. The restore REFUSES a name that already exists, so there is no second attempt.",
  "ss.k6.odtworz": "Restore the database",
  "ss.k6.paczka": "Package on the cloud node: {nazwa}",
  "ss.k6.poCo": "This restore is what sets the \"island master\" badge. It is the only way the portal learns where the master is.",
  "ss.k6.pytanie": "Restore the database as \"{baza}\"?\n\nNO WAY BACK: the restore refuses a name that already exists, so there is no second seeding. Fixing it would need a new database name and a change to SPS_DB at BillVis.",
  "ss.k6.stoi": "The island master is on node {wezel}.",
  "ss.k6.title": "Restore the database as master",
  "ss.k7.juzWlaczone": "Sibling withdrawal fan-out is on.",
  "ss.k7.poCo": "This is why Smart Sync exists: machines count limits from their siblings' withdrawals too. The button turns on only once every check has passed.",
  "ss.k7.przewinButton": "Send",
  "ss.k7.przewinNic": "No withdrawals since that moment — nothing changed",
  "ss.k7.przewinOd": "Send pending withdrawals from",
  "ss.k7.przewinPoCo": "Enabling distribution starts from the current moment, so withdrawals made during the installation never reached the other nodes or the master. Here you pick from when to send them. Writes are idempotent — whatever is already there will not be duplicated.",
  "ss.k7.przewinWezel": "will receive {n} withdrawals",
  "ss.k7.przewinWynik": "Rewound {wezly} nodes, {n} withdrawals since that moment",
  "ss.k7.pytanie": "Enable sibling withdrawal fan-out?\n\nThis is the only portal feature that WRITES rows into the customer's withdrawal log. Turning it off stops further ones but does NOT undo those already written.\n\nHistory will not travel: machine cursors are set to \"now\", so machines only get what happens from this moment on.",
  "ss.k7.skadDymek": "Show which machines this number comes from",
  "ss.k7.skadPozycja": "from {automat} (VMID {vmid}) — {n}",
  "ss.k7.skadStopka": "Without this node’s own issues — those already sit there.",
  "ss.k7.title": "Check, then enable withdrawal fan-out",
  "ss.k7.wlacz": "Enable withdrawal fan-out",
  "ss.k7.granicaBrak": "There was no time boundary.",
  "ss.k7.granicaJest": "Catch-up reaches back to {data} — current withdrawals travel regardless of date.",
  "ss.k7.granicaZdejmij": "Remove the boundary",
  "ss.k7.granicaZdjeta": "Catch-up scope removed — the whole backlog will travel.",
  "ss.k7.porzucButton": "Stop sending backlogged dispenses",
  "ss.k7.porzucPoCo": "History before the boundary will not go to the machines; current dispenses keep flowing.",
  "ss.k7.porzucPytanie": "The backlogged history will NOT go to the machine databases and this cannot be undone in one move. Current dispenses keep flowing. Stop it?",
  "ss.k7.porzuconoWynik": "Dropped {n} backlogged dispenses.",
  "ss.zalegle.tytul": "Pending withdrawals",
  "ss.zalegle.W_TOKU": "Sending pending withdrawals from {od} in progress",
  "ss.zalegle.ZAKONCZONE": "Pending withdrawals from {od} sent",
  "ss.zalegle.PRZERWANE": "Sending pending withdrawals from {od} stopped",
  "ss.zalegle.zlecone": "started {data}",
  "ss.kopia.zlecona": "Backup requested — it will take a moment.",
  "ss.zakladka.wdrozenie": "Deployment",
  "ss.zakladka.synchronizacje": "Synchronisation",
  "ss.odtworzenie.zlecone": "Database restore requested.",
  "ss.paczka.zlecona": "Sending the package to the cloud node requested.",
  "ss.potwierdzil": "Confirmed by {kto}, {kiedy}.",
  "ss.rozsylanie.wlaczone": "Sibling withdrawal fan-out enabled.",
  "ss.stan.CZEKA": "waiting",
  "ss.stan.TERAZ": "now",
  "ss.stan.UWAGA": "attention",
  "ss.stan.ZROBIONE": "done",
  "ss.title": "Smart Sync",
  "ss.tryb.zmieniony": "Island switched to Smart Sync.",
  "table.actions": "Actions",
  "table.clearFilters": "Clear filters",
  "table.cooldownIn": "Next download in",
  "table.cooldownWait": "This report was just downloaded — please wait a moment.",
  "table.empty": "No results",
  "table.exportDone": "Export ready",
  "table.exportEmpty": "Nothing to export",
  "table.exportFailed": "Export failed",
  "table.filters": "Filters",
  "table.filtersActive": "Filter applied",
  "table.next": "Next page",
  "table.of": "of",
  "table.pageSize": "Rows per page",
  "table.prev": "Previous page",
  "table.refresh": "Refresh",
  "table.search": "Search…",
  "table.showing": "Showing",
  "table.txtBezNaglowkow": "Without headers",
  "table.txtBezNaglowkowOpis": "data only — for a program that ingests the file",
  "table.txtWybierz": "TXT (tab delimited) — choose whether the file gets a column-name row",
  "table.txtZNaglowkami": "With headers",
  "table.txtZNaglowkamiOpis": "the first row holds the column names",
  "theme.toDark": "Dark theme",
  "theme.toLight": "Light theme",
  "tokchm.baza": "Cloud database name (SPS_DB)",
  "tokchm.bazaBrak": "This island has no master database yet — the first agent on a client machine will bring it. Until then there is nothing to put in SPS_DB.",
  "tokchm.bazaNiepotwierdzona": "unconfirmed",
  "tokchm.bazaPodpis": "The sidecar restores the backup under this name. Machine database names do not matter here — in Smart Sync each has its own.",
  "tokchm.bazaPotwierdzona": "confirmed",
  "tokchm.bazaWhat": "Taken from the island, not typed. The backup must be restored under this name — only then does the portal treat this node as the island master.",
  "tokchm.bazaWzorzec": "Database name: a letter or underscore first, then letters, digits, _ $ -",
  "tokchm.bazaZapisana": "Cloud master database name: „{baza}\"",
  "tokchm.bazaZapisz": "Save the name",
  "tokchm.bazaZasiana": "the master sits on node {wezel}",
  "tokchm.bladOdwolania": "Could not revoke the token.",
  "tokchm.bladWydania": "Could not issue the token.",
  "tokchm.blokBrakBazy": "We are not assembling the paste block, because the master database name is not known yet. The token is valid — supply SPS_DB once the island has a master.",
  "tokchm.blokOpis": "Exactly these two lines go into the instance secret. The rest of the contract (AGENT_ROLE, AGENT_PORTAL_URL, MSSQL_*) is set by the platform.",
  "tokchm.dowod": "Issued token: prefix {prefiks}, length {dlugosc}. An agent token is always “sva_” and 47 characters — an enrollment code (“sve_”) does NOT belong in this variable.",
  "tokchm.dowodZly": "this does not look like an agent token, please report it",
  "tokchm.kopiaNieudana": "Could not copy — retype the value from the screen.",
  "tokchm.kopiujOba": "Copy token and database name",
  "tokchm.kopiujToken": "Copy token only",
  "tokchm.label": "Cloud master — {wyspa}",
  "tokchm.listaPusto": "This node has no token yet — issue one with the button above.",
  "tokchm.listaTytul": "Token for this node",
  "tokchm.nadpisze": "Issuing a new token immediately revokes the one this node is writing with.",
  "tokchm.stanNieznany": "It is not known yet whether this node has a token — the list has not loaded. Wait a moment before issuing a new one.",
  "tokchm.nadpiszePytanie": "Issue a new token for node “{wezel}”?\n\nThe current token ({prefiks}…) stops working THIS SECOND, and the cloud master agent stops writing until you paste the new token into the instance secret.\n\nCurrent token state: {stan}.",
  "tokchm.nodeId": "Node name",
  "tokchm.nodeIdWhat": "The cloud master’s identity in the portal — it stays for good, so it should still be readable months later. Empty = we fill in the suggestion.",
  "tokchm.odwolaj": "Revoke",
  "tokchm.odwolajPytanie": "Revoke the token of node “{wezel}” ({prefiks}…)?\n\nRevocation is IMMEDIATE and cannot be undone — an agent using this token stops being accepted, and the cloud master stops writing until it gets a new token.\n\nCurrent token state: {stan}.",
  "tokchm.odwolany": "Token revoked — it will not admit any agent.",
  "tokchm.razWarning": "Save this NOW — the token cannot be read again.",
  "tokchm.skopiowanoOba": "Token and database name copied — paste both lines into the instance secret.",
  "tokchm.skopiowanoToken": "Token copied.",
  "tokchm.stanNieuzyty": "never used",
  "tokchm.stanOdwolany": "revoked",
  "tokchm.stanUzywany": "in use",
  "tokchm.title": "Cloud master — token and database name",
  "tokchm.tylkoSmart": "This island runs in plain mode, so its master sits on a client machine and there is no cloud agent. The token is issued only after switching the island to Smart Sync (Settings → “Deployment model and island database”).",
  "tokchm.ukryj": "Hide",
  "tokchm.wydaj": "Issue a token for the cloud master",
  "traffic.day": "day",
  "traffic.days": "days",
  "traffic.empty": "No traffic in this period.",
  "traffic.footnote": "Measured on the instance: request and response bytes of the agent channel including headers. Excludes TLS and TCP/IP overhead, so the operator bill will be ~10–15% higher.",
  "traffic.in": "to portal",
  "traffic.kind.aktualizacje": "agent updates",
  "traffic.kind.heartbeat": "heartbeat",
  "traffic.kind.inne": "other",
  "traffic.kind.pliki": "files & backups",
  "traffic.kind.rodzenstwo": "sibling dispensations",
  "traffic.kind.wydania": "dispensations",
  "traffic.kind.zadania": "tasks",
  "traffic.kind.zmiany": "config down",
  "traffic.noThreshold": "alert threshold not set",
  "traffic.node": "Node",
  "traffic.out": "from portal",
  "traffic.perDay": "Daily average",
  "traffic.perKind": "Where the traffic goes",
  "traffic.perNode": "Per agent",
  "traffic.pickIsland": "Pick an island to see data usage.",
  "traffic.requests": "Requests",
  "traffic.requestsShort": "requests",
  "traffic.retention": "history",
  "traffic.threshold": "alert threshold",
  "traffic.tlsNote": "excludes TLS and TCP/IP overhead (~10–15% more on the operator bill)",
  "traffic.total": "Total",
  "tx.allCodes": "all types",
  "tx.allCostCenters": "All cost centres",
  "tx.allGroups": "all groups",
  "tx.allMachines": "all machines",
  "tx.code": "Type",
  "tx.code.IA": "adjustment",
  "tx.code.REN": "refill",
  "tx.code.WN": "issue",
  "tx.costCenter": "Cost centre",
  "tx.costCenterHint": "Value frozen at the moment of dispense, exactly as the machine recorded it. Different spellings of the same name are not merged.",
  "tx.employee": "Employee",
  "tx.emptyForRange": "No transactions in the selected range ({range}).",
  "tx.exportTooBig": "The list has {total} rows and {format} takes {limit} — narrow the period or filters. We do not silently truncate the file.",
  "tx.from": "From",
  "tx.groupAtIssue": "Group at issue",
  "tx.groupAtIssueHint": "The employee group FROZEN by SPS at the moment of issue (USERGROUP01..10). Filtering on it gives the same answer even after people are moved between groups — otherwise last year’s withdrawals would be rewritten into the employee’s new group.",
  "tx.groupAtIssueUnknown": "No group information on this withdrawal. An empty value means „we do not know\" (older synchronisation did not carry these columns) OR „outside any group\" — the two cannot be told apart, so the portal does not guess.",
  "tx.issued": "Issued",
  "tx.item": "Product",
  "tx.machine": "Machine",
  "tx.machineFilterUnavailable": "The machine list cannot be loaded (your account lacks the „Machines” permission), so filtering by machine is unavailable.",
  "tx.newestOutsideRange": "Newest issue matching the other filters: {date} — pick a wider range or \"All\".",
  "tx.noCostCenter": "no cost centre",
  "tx.period": "Period",
  "tx.preset.all": "All",
  "tx.preset.d30": "30 days",
  "tx.preset.d7": "7 days",
  "tx.preset.mtd": "This month",
  "tx.preset.today": "Today",
  "tx.qty": "Quantity",
  "tx.summaryFor": "For the selected filters:",
  "tx.to": "To",
  "tx.totalValue": "Total value (absolute amounts: issues, refills and corrections)",
  "tx.unitCost": "Unit price",
  "tx.value": "Value",
  "tx.when": "Date and time",
  "user.logout": "Sign out",
  "zderz.bladWczytania": "Could not check whether any limit blocks a full dispense — the detector did NOT answer, so this list does not mean „no blocks\".",
  "zderz.brakRoli": "Changing a limit requires the administrator role.",
  "zderz.grupa": "group \"{nazwa}\"",
  "zderz.grupaOsob": "group \"{nazwa}\" · {osob} people",
  "zderz.iInne": " · the other {n} dispense the same or more",
  "zderz.lead": "Only COMPLETE blocks are reported: when EVERY compartment holding this item dispenses more per withdrawal than the limit allows — so the person has no way to take it and the machine refuses with \"rationing exceeded\" every time. The same item at 7 and at 4 with a limit of 4 is NOT an error: the drum turns to the one with four. Checked {limitow} limits against {miejsc} compartments. ⚠️ The sensor does not look at machine assignments or at compartments narrowed by location group, so someone cut off from that one fitting compartment will not be reported.",
  "zderz.limitLinia": "limit {maxQty} pcs. / {okno} · smallest issue for this item on the island",
  "zderz.miejsce": "{towar} — closest: {automat} (VMID {vmid}), drum {pic}, drawer {szuflada}, compartment {przegroda}",
  "zderz.miejsceKrotkie": "{automat} · drawer {szuflada}, compartment {przegroda} — {wydanie} pcs.",
  "zderz.niesprawdzone": "{n} limits the sensor does NOT check:",
  "zderz.podnies": "Raise the limit to {n}",
  "zderz.podniesOpis": "Sets the limit to {n} pcs. in the same period — what the SMALLEST issue of this item takes, i.e. exactly enough to give the person one way to withdraw. The window stays unchanged.",
  "zderz.pytanieGrupa": "Raise the limit to {n} pcs. / {okno} for the WHOLE group \"{kto}\" ({osob} people)?\n\nScope: {zakres}. The change affects every member of this group.",
  "zderz.pytanieOsoba": "Raise the limit to {n} pcs. / {okno} for \"{kto}\"?\n\nScope: {zakres}.",
  "zderz.sztuk": "pcs.",
  "zderz.title": "The limit will not let a full issue through",
  "zderz.tylkoOdczyt": "This rationing row is narrowed in SPS (job, machine or AUX fields) — the portal does not edit it. Fix the limit in SPSUI.",
  "zderz.wszyscy": "everyone",
  "zderz.zlecone": "Limit increase queued — the change will travel to the machine in the change queue.",
  "zdj.bezPliku": "no photo",
  "zdj.brakMaszyn": "This island has no machines with an agent.",
  "zdj.brakWBibliotece": "the portal does not have this file",
  "zdj.brakWynikow": "Nothing matches the filters.",
  "zdj.mierzono": "checked {kiedy}",
  "zdj.nieMierzono": "not checked",
  "zdj.plik": "File",
  "zdj.pokazZMaszyny": "click to see the photo from this machine",
  "zdj.probaNieudana": "check failed ({kiedy}): {powod}",
  "zdj.przycisk": "Manage photos",
  "zdj.spis": "Check machines",
  "zdj.spisNikt": "There are no machines that can be checked.",
  "zdj.spisOpis": "Checks which files are on the machines. Transfers nothing.",
  "zdj.spisZaStare": "Skipped machines with an older agent: {wezly} — {wersja} needed, they update themselves.",
  "zdj.spisZaStareWszystkie": "No machine can do this yet: {wezly} — agent {wersja} needed. It updates itself, or use “update now” on the Agents screen.",
  "zdj.spisZlecony": "Checking machines ({wezlow}) — results shortly.",
  "zdj.stan.BEZ_OBRAZKA": "no photo",
  "zdj.stan.BRAKI": "missing on some machines",
  "zdj.stan.NIEZMIERZONE": "not checked",
  "zdj.stan.ROZJAZD": "another photo on some machines",
  "zdj.stan.WSZEDZIE": "on every machine",
  "zdj.stanMaszyny.BRAK": "no file — the machine shows an empty spot",
  "zdj.stanMaszyny.INNY_PLIK": "this machine has another photo assigned",
  "zdj.stanMaszyny.INNY_PLIK.opis": "this machine shows {plik}",
  "zdj.stanMaszyny.INNY_ROZMIAR": "same name, different content",
  "zdj.stanMaszyny.INNY_ROZMIAR.opis": "same name, different content ({bajty} B)",
  "zdj.stanMaszyny.MA": "present",
  "zdj.stanMaszyny.NIEZMIERZONE": "not checked",
  "zdj.stanMaszyny.PUSTY_PLIK": "empty file (0 B) — the machine shows an empty spot",
  "zdj.szukaj": "Search item or file",
  "zdj.towar": "Item",
  "zdj.tylkoBraki": "Missing only",
  "zdj.tytul": "Item photos",
  "zdj.ucieto": "Showing {ile} of {z} — narrow the search.",
  "zdj.wToku": "checking…",
  "zdj.wezelZaStary": "agent {wersja}, {wymagana} needed — it updates itself",
  "zdj.zakladka.galeria": "Photos in the portal",
  "zdj.zakladka.pokrycie": "On machines",
  "zdj.zmien": "Change",
  "zdj.zmienOpis": "Choose another photo for this item",
  "zajetosc.tytul": "Machine occupancy",
  "zajetosc.poCo": "The portal's number and how much of it the portal can vouch for. A frozen row has an unexecuted change, so its state predates it.",
  "zajetosc.pozycji": "{n} positions",
  "zajetosc.zamrozonych": "{n} frozen ({p}%)",
  "zajetosc.pewna": "nothing frozen",
  "zajetosc.brakPlanogramu": "no planogram",
  "zajetosc.brakWlasciciela": "the portal does not know this machine’s node",
  "zajetosc.cisza": "silent {n} min",
  "zajetosc.nigdyNieOdpowiedzial": "never responded",
  "zajetosc.niepelne": "The queue exceeds the counting limit — the frozen count is understated.",
  "zajetosc.zapytaj": "Ask the machines",
  "zajetosc.czekam": "Waiting for replies…",
  "zajetosc.nikt": "Nobody has asked the databases yet — the figures above are the portal’s alone.",
  "zajetosc.wgBaz": "per database:",
  "zajetosc.zlecono": "Asked {n} nodes — replies arrive on the next cycles.",
  "zajetosc.zaStare": "Skipped nodes on an older agent: {wezly}",
  "zajetosc.wszystkie.przycisk": "Take stock from all machines",
  "zajetosc.wszystkie.opis": "Each machine reports the stock of its own compartments and the portal takes its numbers. Nothing is sent to the machines; positions with pending changes stay as they are.",
  "zajetosc.wszystkie.zlecono": "Asked machines: {n}. The portal takes the stock as they answer.",
  "zajetosc.wszystkie.wToku": "Taking stock…",
  "zajetosc.wszystkie.gotowe": "Stock taken from the machines.",
  "zajetosc.wszystkie.CZEKA": "waiting for the read",
  "zajetosc.wszystkie.BLAD": "read failed: {powod}",
  "zajetosc.wszystkie.NIE": "unchanged: {powod}",
  "zajetosc.wszystkie.PRZYJETO": "positions taken: {n}",
  "zajetosc.wszystkie.ZGODNE": "matching",
  "zajetosc.wszystkie.zamrozonych": "skipped with pending changes: {n}",
  "zajetosc.wszystkie.nieznanych": "outside the portal planogram: {n}",
  "zajetosc.wszystkie.bezWlasciciela": "Skipped, no single database (VMID): {automaty}",
  "zajetosc.wszystkie.zaStare": "Skipped older agents: {wezly}",
  "stanTabel.tytul": "Table state — portal vs nodes",
  "stanTabel.poCo": "Node figures arrive with the sensor on every cycle, the portal’s from the read model. Nothing here asks the machines.",
  "stanTabel.portal": "portal {n}",
  "stanTabel.zgodne": "in agreement ({n} nodes)",
  "stanTabel.rozjazd": "DIVERGED: {wezly}",
  "stanTabel.nieWiemy": "unknown",
  "stanTabel.nieMierzona": "the sensor does not count this table",
  "stanTabel.brakMeldunkow": "no node has reported yet",
  "stanTabel.brakLicznika": "the portal does not count this table",
  "stanTabel.podsumowanie": "Compared {n} of {razem} tables — the rest await a node-side counter.",
  "stanTabel.policz": "Count in the databases",
  "stanTabel.czekam": "Waiting for replies…",
  "stanTabel.zlecono": "Requested a count on {n} nodes — replies arrive on the next cycles.",
  "stanTabel.zaStare": "Skipped nodes on an older agent: {wezly}",
  "stanTabel.zCzujnika": "from the sensor",
  "stanTabel.zOdczytu": "from the count",
  "stanTabel.podzbior": "not compared — the portal keeps only part of this table",
  "stanTabel.wiersze": "Rows",
  "stanTabel.uzgodnij": "Align",
  "stanTabel.znanaRoznica": "Known difference",
  "stanTabel.znanaPytanie": "Accept the {n} difference in {tabela} as explained? The row turns grey and goes red again as soon as the difference changes.",
  "stanTabel.znana": "known difference {n} — {kto}, {kiedy}",
  "stanTabel.znanaByla": "previously accepted: {n}",
  "stanTabel.cofnij": "Undo",
  "stanTabel.miedzyWezlami": "Nodes differ from each other: {tabel} tables across {automatow} machines",
  "wstrz.tytul": "Held removals",
  "wstrz.czeka": "awaiting decision",
  "wstrz.naglowek": "{kto} removed {n} {co} at once",
  "wstrz.co.AUTOMAT": "machine assignments",
  "wstrz.co.GRUPA": "group memberships",
  "wstrz.co.MPK": "cost-center assignments",
  "wstrz.co.INNE": "rows",
  "wstrz.pozostaleMaja": "Nothing went to the island — the other databases still have them.",
  "wstrz.lista": "Show list",
  "wstrz.ukryj": "Hide list",
  "wstrz.kolNumer": "Number",
  "wstrz.kolOsoba": "Employee",
  "wstrz.kolCel.AUTOMAT": "Machine",
  "wstrz.kolCel.GRUPA": "Group",
  "wstrz.kolCel.MPK": "Cost center",
  "wstrz.kolCel.INNE": "Target",
  "wstrz.jeszcze": "…and {n} more",
  "wstrz.rozeslij": "Propagate",
  "wstrz.przywroc": "Restore",
  "wstrz.pytanieRozeslij": "Remove {n} in all databases of the island?",
  "wstrz.pytaniePrzywroc": "Restore {n} on {kto}?",
  "wstrz.takRozeslij": "Yes, propagate",
  "wstrz.takPrzywroc": "Yes, restore",
  "wstrz.zakolejkowano": "Queued {n}",
  "stanRoz.pokaz": "Stock divergence",
  "stanRoz.czekam": "Waiting for node replies…",
  "stanRoz.zgodne": "Stock agrees across all databases ({n} positions)",
  "stanRoz.roznych": "{n} positions with differing stock",
  "stanRoz.brakujace": "{n} positions missing somewhere",
  "stanRoz.zaStare": "Skipped nodes on an older agent: {wezly}",
  "stanRoz.zlecono": "Asked {n} nodes about this machine’s stock.",
  "stanRoz.nikt": "Nobody has asked the databases about this machine’s stock yet.",
  "stanRoz.wyrownaj": "Re-broadcast stock",
  "stanRoz.wyrownano": "Broadcast {n} positions to the other nodes.",
  "stanRoz.nicDoRozeslania": "The portal has no positions to broadcast for this machine.",
  "stanRoz.bezOdpowiedzi": "no reply",
  "uzgadnianie.tytul": "Align machine databases",
  "uzgadnianie.poCo": "One table, in batches. The next batch only after every node confirms. We add missing rows — nothing is deleted.",
  "uzgadnianie.wybierzTabele": "pick a table",
  "uzgadnianie.wybierzAutomat": "pick a machine",
  "uzgadnianie.zacznij": "Start",
  "uzgadnianie.zaczeto": "Run started — {n} nodes queued",
  "uzgadnianie.zaStare": "Skipped, agent too old: {wezly}",
  "uzgadnianie.przerwij": "Stop",
  "uzgadnianie.wznow": "Resume",
  "uzgadnianie.gdzie": "source: {wezel} ({nr} of {z}) · from row {od}",
  "uzgadnianie.podsumowanie": "batches: {paczek} · rows sent: {rozeslanych}",
  "uzgadnianie.znane": "{n} already sent earlier",
  "uzgadnianie.pominiete": "skipped nodes: {wezly}",
  "uzgadnianie.stan.TRWA": "running",
  "uzgadnianie.stan.WSTRZYMANY": "paused",
  "uzgadnianie.stan.PRZERWANY": "stopped",
  "uzgadnianie.stan.ZROBIONY": "finished",
  "uzgadnianie.faza.GOTOWY": "waiting for the next step",
  "uzgadnianie.faza.ODCZYT": "reading a batch from the node",
  "uzgadnianie.faza.ROZSYLKA": "waiting for node confirmations",
  "stanRoz.przyjmij": "Take the owner's stock",
  "stanRoz.przyjeto": "Portal took the stock: {n} positions",
  "stanRoz.potwierdz": "Confirm",
  "kopiaPortalu.tytul": "Portal export",
  "kopiaPortalu.poCo": "This island's vending data as CSV, to compare with the master database. Not a restorable backup — no change queue, no logs, no agents.",
  "kopiaPortalu.pobierz": "Download portal export",
  "kopiaPortalu.zawartosc": "{n} files, {w} rows in total",
  "kopiaPortalu.osobowe": "The package contains staff names and card numbers — without them the Users table cannot be compared. The portal never stores PINs.",
  "kopiaPortalu.brakWyspy": "Pick an island to see what the export will contain.",
  "itm.supplier": "Supplier",
  "itm.supplierUnknown": "(not in dictionary)",
  "itm.noSupplier": "no supplier",
  "itm.noSuppliersOnIsland": "This island has no suppliers defined yet.",
  "dost.przycisk": "Suppliers",
  "dost.tytul": "Supplier dictionary",
  "dost.dodaj": "New supplier",
  "dost.edycja": "Edit supplier",
  "dost.pusto": "This island has no suppliers yet.",
  "dost.towarow": "{n} items",
  "dost.zaDlugi": "number too long — cannot be assigned to an item",
  "dost.spozaSlownika": "{n} items point to a number outside the dictionary.",
  "dost.numer": "Number",
  "dost.numerHint": "At most 32 characters — that is what the supplier column on an item holds. It cannot be changed after saving.",
  "dost.nazwa": "Name",
  "dost.adres": "Address, line {n}",
  "dost.zapisano": "Supplier change queued",
  "dost.usun": "Delete supplier",
  "dost.usunPytanie": "Delete supplier {nazwa}?",
  "dost.usunZTowarami": "Supplier {nazwa} is assigned to items ({n}). Deleting it removes it from them too. Delete?",
  "dost.usunieto": "Deletion of supplier {nazwa} queued",
  "szer.poszerz": "Widen — absorb the next column",
  "szer.zwez": "Narrow — give back the last column",
  "szer.skutek.BEZ_SKUTKU": "Column {zostaje} will absorb column {kolumna}. {przegrod} empty compartments disappear.",
  "szer.skutek.ZNIKNIE_PLANOGRAM": "Column {zostaje} will absorb column {kolumna}. {przegrod} compartments disappear, {pozycji} of them with an assigned item — no stock.",
  "szer.skutek.GINIE_TOWAR": "Column {zostaje} will absorb column {kolumna}. {przegrod} compartments disappear, {pozycji} of them with an assigned item and {sztuk} pcs of stock.",
  "szer.skutekZwezenia": "Column {zostaje} gives back column {kolumna}. It returns empty, with {przegrod} compartments — no items.",
  "szer.towarNieWroci": "Narrowing gives the column back, but not the items that were in it.",
  "szer.potwierdzPoszerzenie": "Widen column {n}",
  "szer.potwierdzZwezenie": "Narrow column {n}",
  "szer.zakolejkowano": "Width change queued",
  "szer.tryb": "Edit columns",
  "kmpk.brakOsob": "Nobody matches this phrase.",
  "kmpk.do": "To",
  "kmpk.doZmiany": "To correct: {n}",
  "kmpk.juzPoprawne": "skipping {n} already correct",
  "kmpk.kolAutomat": "Machine",
  "kmpk.kolData": "Date",
  "kmpk.kolIlosc": "Qty",
  "kmpk.kolMpk": "Cost center",
  "kmpk.kolTowar": "Item",
  "kmpk.mpk": "New cost center",
  "kmpk.mpkBiezace": "Current cost center: {mpk}",
  "kmpk.nicDoZmiany": "No issues to correct in this period.",
  "kmpk.od": "From",
  "kmpk.operacji": "operations: {n}",
  "kmpk.pokaz": "Show what changes",
  "kmpk.pracownik": "Employee",
  "kmpk.pusto": "(empty)",
  "kmpk.starszyAgent": "Confirming requires agent {wersja} on every island database. Older ones: {lista}.",
  "kmpk.szukaj": "Start typing a name or card number…",
  "kmpk.tytul": "Cost center correction in issue history",
  "kmpk.wiecej": "… and {n} more",
  "kmpk.zatwierdz": "Correct cost center ({n})",
  "kmpk.zrobione": "Queued {n} issues in {k} operations",
  "baza.zakladka": "Queries",
  "baza.zakladkaZmiany": "Changes",
  "baza.baza": "Database",
  "baza.master": "master",
  "baza.zaStary": "agent {wersja} — too old",
  "baza.porownaj": "Compare with",
  "baza.szukaj": "Find table",
  "baza.czytamSchemat": "Reading schema…",
  "baza.odswiezSchemat": "Refresh schema",
  "baza.top": "Top 1000",
  "baza.wstawKolumne": "Insert name into query",
  "baza.klucz": "key",
  "baza.widok": "view",
  "baza.zapisBramka": "writable through the gate",
  "baza.zapisZakaz": "read-only",
  "baza.placeholder": "SELECT TOP 100 * FROM Items",
  "baza.wykonaj": "Run",
  "baza.eksport": "Export CSV",
  "baza.czekam": "waiting for {wezel}…",
  "baza.wierszy": "{n} rows · {ms} ms · {wezel}",
  "baza.obcieto": "cut to {n}",
  "baza.porownanie": "vs {wezel}: equal {z} · different {i} · only here {t} · missing here {b}",
  "baza.poKluczu": "by key",
  "baza.poWierszach": "by whole rows",
  "baza.niepelne": "comparison incomplete — result cut",
  "baza.inneKolumny": "The databases returned different columns — not comparing.",
  "baza.stan": "State",
  "baza.stanWiersza.ZGODNY": "equal",
  "baza.stanWiersza.INNY": "different",
  "baza.stanWiersza.TYLKO_TU": "only here",
  "baza.stanWiersza.BRAK_TU": "missing here",
  "baza.tam": "there: {v}",
  "baza.brakBaz": "This island has no database with an agent.",
  "baza.edytuj": "Edit result",
  "baza.edycjaTabeli": "Editing: {tabela}",
  "baza.dodajWiersz": "Add row",
  "baza.zakonczEdycje": "Stop editing",
  "baza.usunNowy": "Remove new row",
  "baza.usunWiersz": "Delete row",
  "baza.przywrocWiersz": "Undo delete",
  "baza.nowyWiersz": "New row",
  "baza.wiersz": "Row",
  "baza.doWyslania": "Changes to send: {n}",
  "baza.pojdzie": "Goes to:",
  "baza.zaDuzoZmian": "At most {n} changes at once — narrow the filter.",
  "baza.hurtKolumna": "Column",
  "baza.hurtWartosc": "Value",
  "baza.hurtUstaw": "Set in all rows",
  "baza.hurtUsunWszystkie": "Delete all",
  "baza.hurtPrzywrocWszystkie": "Undo delete all",
  "baza.hurtObciety": "Result cut off — narrow the filter to change all matching rows.",
  "baza.hurtCzesci": "Goes out in parts — operations: {k}",
  "baza.hurtTytul": "Bulk change preview",
  "baza.hurtOpis": "Changes: {n} · operations: {k} (at most {max} each)",
  "baza.hurtZablokowane": "Blocked: {n}",
  "baza.hurtPomin": "Skip blocked ({n})",
  "baza.hurtPominiete": "Skipped: {n}",
  "baza.hurtIleZmian": "changes: {n}, first #{nr}",
  "baza.odrzucZmiany": "Discard changes",
  "baza.podgladWysylka": "Preview and send",
  "baza.wyslano": "Queued to the island — the result changes after the agents run.",
  "baza.odswiezWynik": "Refresh result",
  "baza.wyslanoGotowe": "The change is on every database of the island.",
  "baza.stanWezla.CZEKA": "waiting",
  "baza.stanWezla.W_DRODZE": "on the way",
  "baza.stanWezla.ZROBIONE": "done",
  "baza.stanWezla.BLAD": "error",
  "baza.pominieto": "skipped {n}",
  "baza.operacjaNr": "Operation {n}:",
  "baza.operacjiGotowe": "Operations done: {z} of {n}",
  "baza.sortuj": "Sort",
  "baza.podpowiedzi": "Suggestions",
  "baza.tabela": "table",
  "baza.naprawa": "Fix",
  "baza.wg": "as in {wezel}",
  "baza.wgOpis": "Align everywhere to the version from {wezel}",
  "baza.wgOpisUsun": "This row is missing in {wezel} — it will be deleted on the whole island",
  "baza.potwierdzNaprawyUsun": "Yes, send {n} (deletions: {u})",
  "baza.wzorzec": "reference: {wezel}",
  "baza.wszystkieWg": "All as in {wezel}",
  "baza.naprawyDoWyslania": "Fixes to send: {n}",
  "baza.wyslijNaprawy": "Send fixes",
  "baza.potwierdzNaprawy": "Yes, send {n}",
  "baza.naprawyWyslane": "Queued to the island: patches {p}, fills {d}, deletions {u}.",
  "baza.wyczysc": "Clear"
}
